import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { createSvgIcon } from "@mui/material";
import { A } from "../ArrowDown-d6bxUL0F.js";
import { A as A2, C, O } from "../OpenDiagonallyRight-CGdCEXlF.js";
import { S, a } from "../SwatchSquare-CaaLsjAC.js";
const Icon$38 = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2h.13c4.923.025 9.063 1.473 9.823 3.362l.047.13V11h-2V8.4c-1.825.972-4.729 1.6-8 1.6s-6.176-.628-8-1.6V12h.051l.11.104c.299.283.816.59 1.51.868 1.39.555 3.269.917 5.329 1.007v2.001c-2.859-.113-5.364-.709-7-1.58V18c0-.036.005-.041.036-.014l.124.118c.3.283.817.59 1.512.867 1.389.556 3.268.918 5.328 1.008v2.001c-4.948-.196-8.835-1.835-8.995-3.85L2 18V5.493c.428-1.303 2.46-2.417 5.267-3.017C8.676 2.172 10.287 2 12 2m0 2a21.3 21.3 0 0 0-4.668.511c-.607.146-1.165.32-1.66.518-.618.246-1.095.516-1.404.772L4.051 6l.11.104c.299.283.816.59 1.51.867C7.284 7.616 9.554 8 12 8s4.717-.384 6.328-1.029c.617-.246 1.095-.516 1.404-.772l.216-.2-.108-.103c-.3-.283-.817-.59-1.512-.867a13 13 0 0 0-2.167-.63 21.7 21.7 0 0 0-3.842-.397zm5 10a5.38 5.38 0 0 1 5 3.41 5.38 5.38 0 0 1-5 3.408 5.38 5.38 0 0 1-5-3.409A5.38 5.38 0 0 1 17 14m0 1.136a2.274 2.274 0 1 0 .002 4.547A2.274 2.274 0 0 0 17 15.136m-1.364 2.273c0-.755.61-1.363 1.364-1.363s1.364.608 1.364 1.363-.61 1.364-1.364 1.364-1.364-.61-1.364-1.364",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$38 = createSvgIcon(Icon$38(), "AccessIn");
function AccessIn({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$38,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const AccessIn$1 = forwardRef(AccessIn);
const Icon$37 = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    d: "M4 8h4V4H4zM10 20h4v-4h-4zM8 20H4v-4h4zM4 14h4v-4H4zM14 14h-4v-4h4zM14 8h-4V4h4zM16 14h4v-4h-4zM20 20h-4v-4h4zM21 0h-2v3h-3v2h3v3h2V5h3V3h-3z"
  }
) });
const BaseSvgIcon$37 = createSvgIcon(Icon$37(), "AddApp");
function AddApp({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$37,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const AddApp$1 = forwardRef(AddApp);
const Icon$36 = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19 14v3h3v2h-3v3h-2v-3h-3v-2h3v-3zm0-11a3 3 0 0 1 2.995 2.824L22 6v6h-2V6a1 1 0 0 0-.883-.993L19 5H5a1 1 0 0 0-.993.883L4 6v12a1 1 0 0 0 .883.993L5 19h7v2H5a3 3 0 0 1-2.995-2.824L2 18V6a3 3 0 0 1 2.824-2.995L5 3z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$36 = createSvgIcon(Icon$36(), "AddSection");
function AddSection({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$36,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const AddSection$1 = forwardRef(AddSection);
const Icon$35 = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    d: "M3 7v2h10V7zm4 6v2H3v2h4v2h2v-6zm14 4v-2H11v2zm-6-6h2V9h4V7h-4V5h-2z"
  }
) });
const BaseSvgIcon$35 = createSvgIcon(Icon$35(), "AdvancedSettings");
function AdvancedSettings({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$35,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const AdvancedSettings$1 = forwardRef(AdvancedSettings);
const Icon$34 = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M12 1c2.212 0 4.27.655 5.994 1.778a4.7 4.7 0 0 1-1.118.763l-.848.411A9 9 0 0 0 3 12v6a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-5.324l1.639-3.372.017-.037c.224.874.344 1.79.344 2.733v6l-.007.257a5 5 0 0 1-4.736 4.736L18 23H6a5 5 0 0 1-4.993-4.743L1 18v-6C1 5.925 5.925 1 12 1"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M9.5 11a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M14.5 11a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M14.783 7.007A5.5 5.5 0 0 1 15 17.976V18a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-.023A5.5 5.5 0 0 1 9.5 7h5zM9.5 9a3.5 3.5 0 1 0 0 7h5a3.5 3.5 0 1 0 0-7z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M20.84 2.25a6.7 6.7 0 0 0 3.09 3.09 6.7 6.7 0 0 0-3.09 3.09 6.7 6.7 0 0 0-3.09-3.09 6.7 6.7 0 0 0 3.09-3.09"
    }
  )
] });
const BaseSvgIcon$34 = createSvgIcon(Icon$34(), "AiAgent");
function AiAgent({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$34,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const AiAgent$1 = forwardRef(AiAgent);
const Icon$33 = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10.02 5.694a15.73 15.73 0 0 0 7.22 7.305 15.74 15.74 0 0 0-7.22 7.305A15.73 15.73 0 0 0 2.8 13a15.73 15.73 0 0 0 7.22-7.305m0 3.834a17.8 17.8 0 0 1-3.44 3.47c1.299.99 2.457 2.16 3.44 3.47a17.8 17.8 0 0 1 3.44-3.47 17.8 17.8 0 0 1-3.44-3.47",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M17.855 1.1A9.04 9.04 0 0 0 22 5.301a9.04 9.04 0 0 0-4.145 4.201 9.04 9.04 0 0 0-4.146-4.2A9.04 9.04 0 0 0 17.855 1.1"
    }
  )
] });
const BaseSvgIcon$33 = createSvgIcon(Icon$33(), "AiGeneratedObject");
function AiGeneratedObject({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$33,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const AiGeneratedObject$1 = forwardRef(AiGeneratedObject);
const Icon$32 = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M11.293 15.879a1 1 0 0 1 1.414 0l1.414 1.414a1 1 0 0 1 0 1.414l-1.414 1.414a1 1 0 0 1-1.414 0l-1.414-1.414a1 1 0 0 1 0-1.414z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M7 16a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm-2 .75a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h2a.25.25 0 0 0 .25-.25v-2a.25.25 0 0 0-.25-.25zM19 16a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm-2 .75a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h2a.25.25 0 0 0 .25-.25v-2a.25.25 0 0 0-.25-.25zM7 10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm-2 .75a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h2a.25.25 0 0 0 .25-.25v-2a.25.25 0 0 0-.25-.25z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M13 10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M19 10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm-2 .75a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h2a.25.25 0 0 0 .25-.25v-2a.25.25 0 0 0-.25-.25z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M7 4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zM13 4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zM19 4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z"
    }
  )
] });
const BaseSvgIcon$32 = createSvgIcon(Icon$32(), "AiTool");
function AiTool({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$32,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const AiTool$1 = forwardRef(AiTool);
const Icon$31 = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12.93 17.25 9.15 6.75H7.545L3.75 17.25h1.62l.855-2.415h4.245l.84 2.415zM7.995 9.885q.225-.645.36-1.185.09.45.36 1.185l1.275 3.57H6.705zM17.704 9.436a5 5 0 0 0-1.03-.098q-1.725 0-2.891.802l.47 1.287q.938-.697 2.21-.697.863 0 1.256.364.394.362.394 1.226v.424q-.772-.454-1.908-.454-1.241 0-2.104.65-.864.652-.863 1.909 0 1.241.765 1.915t1.99.674q1.302 0 2.12-.848v.666h1.514v-5.012q0-.908-.265-1.529-.264-.621-.734-.9a3.1 3.1 0 0 0-.924-.38m-2.475 4.512q.478-.296 1.234-.296.938 0 1.65.379v1.18q-.742.834-1.832.834-.741 0-1.135-.318t-.394-.879q0-.604.477-.9",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M3 1a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3zM2 4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$31 = createSvgIcon(Icon$31(), "Annotation");
function Annotation({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$31,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Annotation$1 = forwardRef(Annotation);
const Icon$30 = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M20 3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h6.5v-2H4V5h16v10h2V5c0-1.1-.9-2-2-2"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5 10a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v5H8.5v-2h-2v2H5zm1.5 1.5h2v-1h-2zM11 9h4c.55 0 1 .45 1 1v2c0 .55-.45 1-1 1h-2.5v2H11zm3.5 1.5h-2v1h2z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M19 9h-2v6h2zM15.636 23.535l1.414-1.414L14.93 20l2.121-2.121-1.414-1.415L12.101 20zM21.071 20 18.95 22.12l1.414 1.414L23.899 20l-3.535-3.536-1.414 1.415z"
    }
  )
] });
const BaseSvgIcon$30 = createSvgIcon(Icon$30(), "ApiCall");
function ApiCall({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$30,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const ApiCall$1 = forwardRef(ApiCall);
const Icon$2$ = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m11.835 11.995 3.17-3.17-1.41-1.41-4.59 4.58 4.59 4.59 1.41-1.42z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2$ = createSvgIcon(Icon$2$(), "ArrowLeft");
function ArrowLeft({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2$,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const ArrowLeft$1 = forwardRef(ArrowLeft);
const Icon$2_ = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12.175 12.005-3.17 3.17 1.41 1.41 4.59-4.58-4.59-4.59-1.41 1.42z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2_ = createSvgIcon(Icon$2_(), "ArrowRight");
function ArrowRight({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2_,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const ArrowRight$1 = forwardRef(ArrowRight);
const Icon$2Z = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M19 14c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5m-1.5 2.986v4.022h1v-4.022zm2 4.022h1v-4.022h-1z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M11.99 2C17.52 2 22 6.48 22 12q0 .335-.021.663A7 7 0 0 0 20 12.071V12c0-4.42-3.58-8-8-8s-8 3.58-8 8 3.58 8 8 8h.071c.1.698.302 1.362.592 1.977Q12.33 22 11.99 22C6.47 22 2 17.52 2 12S6.47 2 11.99 2"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "m12.5 12.25 2.144 1.27a7 7 0 0 0-1.051 1.035L11 13V7h1.5z"
    }
  )
] });
const BaseSvgIcon$2Z = createSvgIcon(Icon$2Z(), "AsynchronousWait");
function AsynchronousWait({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2Z,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const AsynchronousWait$1 = forwardRef(AsynchronousWait);
const Icon$2Y = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m12.056 6.776.651.559C14.03 8.47 16 10.916 16 13c0 2.206-1.794 4-4 4s-4-1.794-4-4c0-2.173 2.227-4.656 3.405-5.665zM10 13c0 1.103.897 2 2 2s2-.897 2-2c0-.952-.921-2.436-1.95-3.527C10.974 10.585 10 12.061 10 13",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m2 0c0 4.411 3.589 8 8 8s8-3.589 8-8-3.589-8-8-8-8 3.589-8 8",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$2Y = createSvgIcon(Icon$2Y(), "Autostyle");
function Autostyle({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2Y,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Autostyle$1 = forwardRef(Autostyle);
const Icon$2X = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m4 15 1.5-6H8l1.5 6H8l-.37-1.5H5.88L5.5 15zm2.5-4-.25 1h1L7 11z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M11.5 12.43 10.5 9H9l1.75 6h1.5L14 9h-1.5zM15.75 9h3c.6 0 1 .5 1 1v.5h-3.5v3h2V12h1.5v2c0 .5-.4 1-1 1h-3c-.6 0-1-.5-1-1v-4c0-.5.4-1 1-1"
    }
  )
] });
const BaseSvgIcon$2X = createSvgIcon(Icon$2X(), "Avg");
function Avg({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2X,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Avg$1 = forwardRef(Avg);
const Icon$2W = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.527 14.626v1.863c1.143.325 1.842.747 1.842 1.213 0 .494-.785.943-2.06 1.273l-.398.096q-.515.115-1.11.204l-.487.067-.508.058-.528.049-.27.02-.555.033-.57.023q-.289.01-.583.011l-.297.002q-.297 0-.59-.006l-.576-.017-.283-.013-.555-.033-.537-.043-.261-.026-.509-.058-.486-.067-.463-.075q-.339-.06-.648-.13l-.397-.095c-1.276-.33-2.06-.779-2.06-1.273 0-.466.698-.89 1.841-1.213v-1.864c-2.77.656-4.604 1.787-4.604 3.078 0 1.59 2.79 2.945 6.692 3.455l.593.07c.902.096 1.856.147 2.843.147s1.941-.051 2.843-.147l.593-.07c3.902-.51 6.692-1.864 6.692-3.456 0-1.29-1.834-2.42-4.604-3.076m-1.023-9.751c.826 0 1.5.676 1.5 1.5s-.674 1.5-1.5 1.5c-.825 0-1.5-.676-1.5-1.5s.675-1.5 1.5-1.5m1.876 9.375h-3.751V10.5a1.876 1.876 0 0 1 3.75 0zM12.003 3c.825 0 1.5.676 1.5 1.5s-.675 1.5-1.5 1.5-1.5-.676-1.5-1.5.675-1.5 1.5-1.5m1.876 9.375h-3.751v-3.75a1.876 1.876 0 0 1 3.75 0zm-6.377-7.5c.825 0 1.5.676 1.5 1.5s-.675 1.5-1.5 1.5-1.5-.676-1.5-1.5.675-1.5 1.5-1.5m1.875 9.375h-3.75V10.5a1.876 1.876 0 0 1 3.75 0z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2W = createSvgIcon(Icon$2W(), "Behavioral");
function Behavioral({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2W,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Behavioral$1 = forwardRef(Behavioral);
const Icon$2V = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M7.273 13.442v-2.556l1.653-.016v4.252a4.55 4.55 0 0 1-1.653-1.68M10.366 8.766v6.908c.546.101 1.106.101 1.652 0V8.766zM15.148 11.923v1.514a4.55 4.55 0 0 1-1.652 1.674v-3.189z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m20.861 19.357-3.024-3.024a.5.5 0 0 0-.111-.085 8.221 8.221 0 1 0-1.43 1.44.5.5 0 0 0 .08.107l3.024 3.023a.473.473 0 0 0 .67 0l.791-.791a.473.473 0 0 0 0-.67m-9.634-1.956a6.186 6.186 0 1 1 0-12.37 6.186 6.186 0 0 1 0 12.37",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$2V = createSvgIcon(Icon$2V(), "Bigquery");
function Bigquery({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2V,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Bigquery$1 = forwardRef(Bigquery);
const Icon$2U = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 3a7 7 0 0 1 1.39 13.862 7 7 0 1 1-7.78-9.724A7 7 0 0 1 14 3M7.025 9.405l-.065.029a5.001 5.001 0 1 0 6.087 7.502 7.003 7.003 0 0 1-6.022-7.53M9.1 9.001l-.029.146A5 5 0 0 0 13.898 15Q14 14.514 14 14a5 5 0 0 0-4.9-4.999M14 5a5 5 0 0 0-4.047 2.064 7.003 7.003 0 0 1 6.022 7.53A5 5 0 0 0 14 5m-1 8.5c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5m-1.5-.5c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5m1.5-1c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5m-1.5-.5c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5M10 11c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5m1.5-1c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5M10 9.5c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2U = createSvgIcon(Icon$2U(), "Blending");
function Blending({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2U,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Blending$1 = forwardRef(Blending);
const Icon$2T = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm-6 2h6v14H4V8h8a2 2 0 0 0 2-2z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2T = createSvgIcon(Icon$2T(), "BlockLabel");
function BlockLabel({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2T,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const BlockLabel$1 = forwardRef(BlockLabel);
const Icon$2S = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2.064 2.086.65 3.5l1.576 1.576C2.082 5.352 2 5.666 2 6v12a2 2 0 0 0 2 2h13.15l3.299 3.299 1.414-1.414zM15.15 18l-9-9H4v9z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M20 6V17.17l1.767 1.767c.149-.28.233-.599.233-.938V6a2 2 0 0 0-2-2H6.828l5 5H12a2 2 0 0 0 2-2V6z"
    }
  )
] });
const BaseSvgIcon$2S = createSvgIcon(Icon$2S(), "BlockLabelOff");
function BlockLabelOff({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2S,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const BlockLabelOff$1 = forwardRef(BlockLabelOff);
const Icon$2R = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    d: "M18 18v-2H6v2zM7.41 5.59 12 10.18l4.59-4.59L18 7l-6 6-6-6z"
  }
) });
const BaseSvgIcon$2R = createSvgIcon(Icon$2R(), "BottomRow");
function BottomRow({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2R,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const BottomRow$1 = forwardRef(BottomRow);
const Icon$2Q = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16m0 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2Q = createSvgIcon(Icon$2Q(), "BulletPointAlt");
function BulletPointAlt({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2Q,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const BulletPointAlt$1 = forwardRef(BulletPointAlt);
const Icon$2P = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M12 9a3 3 0 1 1 0 6 3 3 0 0 1 0-6" }),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16m0 2a6 6 0 1 0 0 12 6 6 0 0 0 0-12",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$2P = createSvgIcon(Icon$2P(), "BulletPointCheckedAlt");
function BulletPointCheckedAlt({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2P,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const BulletPointCheckedAlt$1 = forwardRef(BulletPointCheckedAlt);
const Icon$2O = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M12 8.75a3.251 3.251 0 0 0 0 6.5 3.251 3.251 0 0 0 0-6.5"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2m0 2c-4.415 0-8 3.585-8 8s3.585 8 8 8 8-3.585 8-8-3.585-8-8-8",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$2O = createSvgIcon(Icon$2O(), "Carto");
function Carto({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2O,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Carto$1 = forwardRef(Carto);
const Icon$2N = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M19.986 11.526q.015.235.014.474a8 8 0 1 1-7.178-7.958q.28-.235.617-.4a3.7 3.7 0 0 0 1.425-1.226A10 10 0 0 0 12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10c0-.902-.12-1.776-.343-2.607-.473.352-.86.814-1.119 1.348-.143.295-.33.559-.552.785"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M12 7.364A10.04 10.04 0 0 1 7.364 12 10.04 10.04 0 0 1 12 16.636 10.04 10.04 0 0 1 16.636 12 10.04 10.04 0 0 1 12 7.364M14.75 6.34a6.7 6.7 0 0 0 3.09-3.09 6.7 6.7 0 0 0 3.09 3.09 6.7 6.7 0 0 0-3.09 3.09 6.7 6.7 0 0 0-3.09-3.09"
    }
  )
] });
const BaseSvgIcon$2N = createSvgIcon(Icon$2N(), "CartoAi");
function CartoAi({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2N,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const CartoAi$1 = forwardRef(CartoAi);
const Icon$2M = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M12 8.75a3.251 3.251 0 0 0 0 6.5 3.251 3.251 0 0 0 0-6.5"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2m0 2c-4.415 0-8 3.585-8 8s3.585 8 8 8 8-3.585 8-8-3.585-8-8-8",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$2M = createSvgIcon(Icon$2M(), "CartoSymbol");
function CartoSymbol({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2M,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const CartoSymbol$1 = forwardRef(CartoSymbol);
const Icon$2L = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsxs(
    "g",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      clipPath: "url(#a)",
      clipRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx("path", { d: "M4 2h16c1.1 0 2 .9 2 2v7h-2v-1h-4v1h-2v-1h-4v4h1v2h-1v4h1v2H4c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2m0 6h4V4H4zm6 0h4V4h-4zm6 0h4V4h-4zM4 20h4v-4H4zm0-10h4v4H4z" }),
        /* @__PURE__ */ jsx("path", { d: "M22 17c0 .98-.29 1.938-.833 2.753L23.91 22.5l-1.41 1.41-2.747-2.743A4.97 4.97 0 0 1 17 22c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5m-5-3c-1.654 0-3 1.346-3 3 0 1.655 1.346 3 3 3s3-1.345 3-3c0-1.654-1.346-3-3-3" })
      ]
    }
  ),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M0 0h24v24H0z" }) }) })
] });
const BaseSvgIcon$2L = createSvgIcon(Icon$2L(), "CatalogView");
function CatalogView({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2L,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const CatalogView$1 = forwardRef(CatalogView);
const Icon$2K = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5 12a7 7 0 1 1 14 0 7 7 0 0 1-14 0m2.056-.75h1.17l2.07-2.036a.75.75 0 0 1 1.276.535v1.867l1.401-2.262a.75.75 0 0 1 1.388.395v2.446l.57-.678a.75.75 0 0 1 .574-.267h1.44a5.001 5.001 0 0 0-9.89 0m9.888 1.5h-1.09l-1.67 1.985a.75.75 0 0 1-1.323-.483v-1.868l-1.401 2.263a.75.75 0 0 1-1.388-.395v-2.714l-1.013.996a.75.75 0 0 1-.526.216H7.056a5.001 5.001 0 0 0 9.888 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12m11-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$2K = createSvgIcon(Icon$2K(), "CatastropheModeling");
function CatastropheModeling({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2K,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const CatastropheModeling$1 = forwardRef(CatastropheModeling);
const Icon$2J = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 15v4h4v2H5c-1.05 0-1.918-.82-1.994-1.851L3 19v-4zm16 0v4c0 1.05-.82 1.918-1.851 1.994L19 21h-4v-2h4v-4zM9 3v2H5v4H3V5c0-1.05.82-1.918 1.851-1.994L5 3zm10 0c1.05 0 1.918.82 1.994 1.851L21 5v4h-2V5h-4V3z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2J = createSvgIcon(Icon$2J(), "Center");
function Center({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2J,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Center$1 = forwardRef(Center);
const Icon$2I = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 15v4h4v2H5c-1.05 0-1.918-.82-1.994-1.851L3 19v-4zm16 0v4c0 1.05-.82 1.918-1.851 1.994L19 21h-4v-2h4v-4zm-9-8c2.1 0 4 1.61 4 4.1 0 1.66-1.33 3.63-4 5.9-2.67-2.27-4-4.24-4-5.9C8 8.61 9.9 7 12 7m0 2.86A1.071 1.071 0 0 0 12 12a1.071 1.071 0 0 0 0-2.14M9 3v2H5v4H3V5c0-1.05.82-1.918 1.851-1.994L5 3zm10 0c1.05 0 1.918.82 1.994 1.851L21 5v4h-2V5h-4V3z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2I = createSvgIcon(Icon$2I(), "CenterLayer");
function CenterLayer({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2I,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const CenterLayer$1 = forwardRef(CenterLayer);
const Icon$2H = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m6.121 4.707 2.877 2.877V5H11v6l-6-.007V8.999l2.584-.001L4.707 6.12zM13 13l6 .007v1.994h-2.585l2.878 2.878-1.414 1.414L15 16.415V19H13z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2H = createSvgIcon(Icon$2H(), "CloseDiagonallyLeft");
function CloseDiagonallyLeft({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2H,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const CloseDiagonallyLeft$1 = forwardRef(CloseDiagonallyLeft);
const Icon$2G = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13 2v4.17L15.17 4l1.42 1.41L12 10 7.42 5.41 8.83 4 11 6.17V2zm-1 12 4.58 4.59L15.17 20 13 17.83V22h-2v-4.17L8.83 20l-1.42-1.41z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2G = createSvgIcon(Icon$2G(), "CloseVertically");
function CloseVertically({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2G,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const CloseVertically$1 = forwardRef(CloseVertically);
const Icon$2F = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M21.995 5.824A3 3 0 0 0 19 3H5l-.176.005A3 3 0 0 0 2 6v12l.005.176A3 3 0 0 0 5 21h5v-2H5l-.117-.007A1 1 0 0 1 4 18V6l.007-.117A1 1 0 0 1 5 5h14l.117.007A1 1 0 0 1 20 6v8h2V6z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "m17.05 22.121-1.414 1.415L12.101 20l3.535-3.535 1.414 1.414L14.93 20zM18.95 22.121 21.07 20l-2.121-2.121 1.414-1.415L23.899 20l-3.535 3.535z"
    }
  )
] });
const BaseSvgIcon$2F = createSvgIcon(Icon$2F(), "CodeBlock");
function CodeBlock({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2F,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const CodeBlock$1 = forwardRef(CodeBlock);
const Icon$2E = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    d: "M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8c-1.18 0-2.34-.26-3.43-.78-.27-.13-.56-.19-.86-.19-.19 0-.38.03-.56.08l-3.2.94.94-3.2c.14-.47.1-.98-.11-1.42A7.9 7.9 0 0 1 4 12c0-4.41 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12c0 1.54.36 2.98.97 4.29L1 23l6.71-1.97c1.31.61 2.75.97 4.29.97 5.52 0 10-4.48 10-10S17.52 2 12 2"
  }
) });
const BaseSvgIcon$2E = createSvgIcon(Icon$2E(), "Comments");
function Comments({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2E,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Comments$1 = forwardRef(Comments);
const Icon$2D = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.778 3c1.177 0 2.132.82 2.216 1.851L22 5v14c0 1.05-.911 1.918-2.057 1.994l-.165.006H4.222c-1.177 0-2.132-.82-2.216-1.851L2 19V5c0-1.05.901-1.918 2.056-1.994L4.222 3zM20 7H4v12h16zM8 9l4 4-4 4-1.4-1.4L9.2 13l-2.6-2.6zm10 6v2h-6v-2z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2D = createSvgIcon(Icon$2D(), "Console");
function Console({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2D,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Console$1 = forwardRef(Console);
const Icon$2C = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.5 2a1 1 0 0 1 .075 1.997L13.5 4H13v2.083l.046.008q.073.013.145.027l.023.005.008.002.014.003q.366.075.715.196l.016.006.026.01.04.013.066.025.021.008a5 5 0 0 1 .307.125l.007.003.03.014.08.036q.427.2.824.469l.108.076 1.473-1.473-.353-.354a1 1 0 0 1 1.36-1.465l.054.051 1.056 1.056.005.005.003.003 1.058 1.058a1 1 0 0 1-1.36 1.465l-.054-.051-.354-.354-1.473 1.473.024.034a6 6 0 0 1 .558.98 6 6 0 0 1 .188.469l.013.038q.16.463.243.956H20v-.5a1 1 0 0 1 1.997-.075L22 10.5v3a1 1 0 0 1-1.997.075L20 13.5V13h-2.083a6 6 0 0 1-.238.942l-.018.052a6 6 0 0 1-.189.47q-.237.528-.58 1.012l1.472 1.473.354-.353a1 1 0 0 1 1.465 1.36l-.051.054-1.056 1.056-.005.005-.006.005-1.055 1.056a1 1 0 0 1-1.465-1.36l.051-.054.354-.354-1.473-1.473q-.485.344-1.013.582l-.03.013-.007.003-.025.011a5 5 0 0 1-.282.115l-.02.007-.067.025-.033.011-.033.012-.016.006-.055.018q-.274.092-.561.157l-.1.021-.02.005-.024.005-.19.035L13 20h.5a1 1 0 0 1 .075 1.997L13.5 22h-3a1 1 0 0 1-.075-1.997L10.5 20h.5v-2.083l-.191-.035-.023-.005-.008-.002-.013-.002a6 6 0 0 1-.662-.179l-.053-.018-.017-.006-.033-.012-.033-.011-.066-.025-.021-.008a5 5 0 0 1-.282-.114l-.025-.011-.007-.003-.03-.013a6 6 0 0 1-.904-.506l-.025-.017-.084-.059-1.473 1.473.354.354a1 1 0 0 1-1.36 1.465l-.054-.051-1.056-1.056-.005-.005-.006-.006-1.055-1.055a1 1 0 0 1 1.36-1.465l.054.051.354.354 1.473-1.473-.076-.11a6 6 0 0 1-.694-1.373l-.018-.052A6 6 0 0 1 6.083 13H4v.5a1 1 0 0 1-1.997.075L2 13.5v-3a1 1 0 0 1 1.997-.075L4 10.5v.5h2.083q.083-.493.243-.956l.013-.038a6 6 0 0 1 .16-.408l.014-.028.014-.034q.211-.47.506-.904l.038-.055.038-.054L5.636 7.05l-.354.354a1 1 0 0 1-1.465-1.36l.051-.054 1.057-1.057.004-.004.005-.006L5.99 3.869a1 1 0 0 1 1.465 1.36l-.051.054-.354.354 1.473 1.473q.485-.344 1.013-.582l.03-.013.007-.003.035-.015.065-.028.207-.083.02-.007.067-.025.04-.014.026-.009.016-.006q.348-.12.715-.196l.014-.003.008-.002q.084-.018.168-.032L11 6.083V4h-.5a1 1 0 0 1-.075-1.997L10.5 2zm-1.44 6h-.146l-.11.005-.027.001-.03.002-.028.002-.029.002-.059.005.034-.003-.143.014.047-.005-.08.01h-.01l-.03.005a4 4 0 0 0-.661.15l-.059.018-.048.017-.039.013-.088.034-.116.046-.076.034-.086.04-.114.056q-.113.058-.223.125l-.035.021-.04.025-.02.014-.026.016-.028.018-.023.016-.095.066-.025.018-.043.032-.034.025a4 4 0 0 0-.316.27l.04-.038-.122.118-.08.082a4 4 0 0 0-.27.316l-.02.028-.037.05-.018.024-.017.022-.006.01-.01.015-.013.018-.02.03.01-.015-.056.085a4 4 0 0 0-.319.601l-.038.094-.036.095-.007.019-.007.02-.005.015-.014.04-.012.036.007-.021a4 4 0 0 0-.182.843l-.004.042-.006.072-.002.018-.002.024-.001.027-.002.041.001-.023-.002.05-.001.018L8 11.92v.116a4 4 0 0 0 .005.188l.003.04.001.021.001.015a4 4 0 0 0 .034.3q.047.311.142.613l.008.026.009.026.002.007.016.047.004.012.008.021.036.095.046.116.032.073q.019.042.039.083l.059.12a4 4 0 0 0 .235.395l.02.03.078.11-.007-.01.025.033.025.034q.112.147.24.285l.014.015.04.042.056.056.082.08a4 4 0 0 0 .316.27l.018.013.06.044.024.018.023.017.009.006.007.005.042.029-.017-.011.052.035.053.034.019.012.077.048.107.062q.114.065.231.12l.04.019a4 4 0 0 0 .312.129l.054.02.036.011-.037-.012.05.017.032.01-.024-.008.179.055q.182.052.367.085l.112.019.052.007.031.004.01.002.031.003.06.007.083.008.029.002.056.004.03.002.025.001.022.001q.176.008.35 0h.022l.026-.002.03-.002.055-.004.029-.002.083-.008.06-.007q.015 0 .03-.004h.011l.03-.005.053-.007q.31-.048.608-.142l.059-.02-.006.003.054-.019-.036.012.036-.011.038-.015.09-.033a4 4 0 0 0 .19-.08l.048-.021.04-.019q.117-.056.231-.12l.107-.062.077-.048.019-.012.026-.018-.026.018.052-.034.053-.035-.018.011q.042-.028.082-.057l.025-.018.059-.044.018-.014q.147-.111.285-.239l.015-.015.042-.04q.029-.026.056-.055l.08-.082a4 4 0 0 0 .27-.316l.025-.034.05-.067-.033.044.08-.11.02-.03a4 4 0 0 0 .234-.395l.06-.12.038-.083.032-.073a4 4 0 0 0 .09-.232l-.008.021.011-.033.017-.047.01-.034-.008.027a4 4 0 0 0 .19-.938l.004-.037.002-.037.002-.03.002-.034.001-.034-.002.034.004-.096a4 4 0 0 0-.003-.263v-.026l-.003-.023v-.018l-.005-.066-.004-.053-.002-.016v-.006l-.01-.092a4 4 0 0 0-.176-.793l.007.021-.012-.035-.014-.04-.005-.017a4 4 0 0 0-.473-.928l.005.008-.018-.026-.033-.047-.018-.025-.036-.049-.021-.028a4 4 0 0 0-.24-.285l-.015-.015-.04-.042-.055-.056-.082-.08a4 4 0 0 0-.316-.27l-.034-.025-.043-.032-.025-.018-.023-.017-.009-.006-.015-.01-.018-.013-.053-.035-.053-.035-.021-.014-.04-.025-.035-.021a4 4 0 0 0-.223-.125l-.114-.056-.086-.04-.076-.034a4 4 0 0 0-.189-.074l-.054-.02-.048-.016-.034-.011.025.008-.179-.054a4 4 0 0 0-.367-.085l-.112-.019-.052-.007-.031-.004-.01-.002-.031-.003-.06-.007-.085-.008-.083-.006-.03-.002-.025-.001-.02-.001-.09-.003h-.027M9.88 12.707a1 1 0 1 1 1.414 1.414 1 1 0 0 1-1.414-1.414M12.5 9a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m0 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2C = createSvgIcon(Icon$2C(), "Covid19");
function Covid19({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2C,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Covid19$1 = forwardRef(Covid19);
const Icon$2B = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19 14v3h3v2h-3v3h-2v-3h-3v-2h3v-3zm1.5-11c.28 0 .5.22.5.5V12h-2V5.7l-3 1.16V12h-2V6.87l-4-1.4v11.66l2 .699v2.121L9 18.9l-5.34 2.07-.16.03c-.28 0-.5-.22-.5-.5V5.38c0-.23.15-.41.36-.48L9 3l6 2.1 5.34-2.07zM8 5.45 5 6.46v11.85l3-1.16z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2B = createSvgIcon(Icon$2B(), "CreateMap");
function CreateMap({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2B,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const CreateMap$1 = forwardRef(CreateMap);
const Icon$2A = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    d: "M21 19.004h3v2h-3v3h-2v-3h-3v-2h3v-3h2zM13.118 23.951a12.4 12.4 0 0 1-2.21.002l.179-1.992a10 10 0 0 0 1.846-.003zM7.554 20.962a10 10 0 0 0 1.72.664l-.544 1.925a12 12 0 0 1-2.066-.798zM4.62 18.75c.416.454.876.873 1.366 1.243L4.782 21.59A12 12 0 0 1 3.145 20.1zM2.679 15.632q.337.862.825 1.65l-1.697 1.056a12 12 0 0 1-.99-1.979zM16.243 16.244A5.96 5.96 0 0 1 12 18.002a5.96 5.96 0 0 1-4.243-1.758l1.415-1.414c1.51 1.512 4.146 1.512 5.656 0zM2 12.023c.002.618.059 1.236.172 1.838l-1.965.37A12 12 0 0 1 0 12.028zM24 12.002c0 .74-.068 1.482-.201 2.202l-1.967-.364A10 10 0 0 0 22 12.002l2-.046zM12 10.002a2 2 0 1 1 0 4 2 2 0 0 1 0-4M13.548 6.225A6 6 0 0 1 18 12.002c0 .488-.07.98-.224 1.548l-1.932-.519A4 4 0 0 0 16 12.002a3.994 3.994 0 0 0-2.969-3.845zM10.97 8.157A3.994 3.994 0 0 0 8 12.002c0 .308.05.635.155 1.031l-1.932.516A5.9 5.9 0 0 1 6 12.002a6 6 0 0 1 4.453-5.777zM2.664 8.412a10 10 0 0 0-.5 1.773l-1.967-.36c.133-.728.334-1.442.6-2.133zM23.176 7.624c.269.688.474 1.4.613 2.126l-1.965.374a10 10 0 0 0-.51-1.77zM4.592 5.285c-.412.455-.785.951-1.109 1.475l-1.7-1.051q.583-.945 1.33-1.768zM20.838 3.886q.752.818 1.342 1.76l-1.696 1.061a10 10 0 0 0-1.119-1.467zM7.518 3.06q-.827.416-1.565.977l-1.21-1.592C5.33 2 5.96 1.605 6.618 1.273zM17.314 1.24c.662.328 1.294.717 1.885 1.16L17.997 4a10 10 0 0 0-1.571-.967zM11.045 2.048a10 10 0 0 0-1.81.34L8.68.468c.708-.203 1.44-.341 2.176-.411zM13.068.05c.737.064 1.466.198 2.177.397l-.539 1.926a10 10 0 0 0-1.813-.331z"
  }
) });
const BaseSvgIcon$2A = createSvgIcon(Icon$2A(), "CreateSpatialAnalysis");
function CreateSpatialAnalysis({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2A,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const CreateSpatialAnalysis$1 = forwardRef(CreateSpatialAnalysis);
const Icon$2z = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m11.394 2.204-4.5 3.428a1 1 0 0 0 0 1.591l4.5 3.43a1 1 0 0 0 1.213 0l4.5-3.43a1 1 0 0 0-.001-1.59l-4.5-3.428a1 1 0 0 0-1.212 0M12 4.257l2.85 2.17L12 8.599 9.15 6.427zM2.394 14.751l9 6.858a1 1 0 0 0 .606.205v-2.269L9.137 17.31 12 15.129v-2.514L8.107 9.649a1 1 0 0 0-1.221.007l-4.501 3.511a1 1 0 0 0 .009 1.584m5.113-3.045 2.843 2.166-2.905 2.213-2.808-2.139z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M17.116 9.656 20.119 12h-3.25l-.376-.294-.386.294h-3.3l3.088-2.351a1 1 0 0 1 1.221.007M19 17v-3h-2v3h-3v2h3v3h2v-3h3v-2z"
    }
  )
] });
const BaseSvgIcon$2z = createSvgIcon(Icon$2z(), "CreateTileset");
function CreateTileset({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2z,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const CreateTileset$1 = forwardRef(CreateTileset);
const Icon$2y = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 2a2 2 0 0 1 2 2v1.25h.013c2.301.04 3.645 1.104 3.733 3.058l.004.205c0 1.143.587 1.678 2.054 1.733l.196.004V9a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v2.22h-2V9h-3v2.216h-2l-.196.004c-1.4.053-1.999 1.076-2.05 2.115l-.008.357c-.085 1.887-1.34 2.943-3.498 3.05L9 16.75V18a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25l.204-.007c1.39-.066 1.99-.564 2.042-1.604l.008-.358c.045-1.004.422-1.77 1.09-2.282-.668-.51-1.045-1.276-1.09-2.28l-.004-.206c0-1.143-.589-1.687-2.046-1.756L9 6.75V8a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 12H4v4h3zM7 4H4v4h3zm12 12v-3h-2v3h-3v2h3v3h2v-3h3v-2z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2y = createSvgIcon(Icon$2y(), "CreateWorkflow");
function CreateWorkflow({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2y,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const CreateWorkflow$1 = forwardRef(CreateWorkflow);
const Icon$2x = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2q.418 0 .826.013l.473.02.443.027.806.071.282.031c3.673.429 6.507 1.67 7.123 3.2l.047.13V18c0 2.21-4.477 4-10 4-5.415 0-9.824-1.721-9.995-3.87L2 18V5.493c.409-1.246 2.285-2.318 4.9-2.935l.475-.105.437-.086.368-.064.548-.084.062-.008q.663-.09 1.361-.143l.53-.033.471-.02Q11.572 2 12 2m0 14c-3.271 0-6.175-.628-8-1.6V18c0-.036.005-.041.036-.014l.124.118c.3.283.817.59 1.512.867C7.282 19.617 9.552 20 12 20c2.447 0 4.717-.384 6.328-1.029.617-.246 1.095-.516 1.404-.772l.232-.213q.033-.03.035-.007L20 18v-3.6c-1.823.971-4.728 1.6-8 1.6m0-6c-3.271 0-6.175-.628-8-1.6V12h.051l.11.104c.299.283.816.59 1.51.868C7.284 13.616 9.554 14 12 14s4.717-.384 6.328-1.028c.617-.247 1.095-.517 1.404-.773l.216-.199H20V8.4c-1.823.972-4.728 1.6-8 1.6m.374-5.997L12 4l-.74.012.172-.005c-1.515.04-2.926.235-4.108.506-.603.145-1.159.318-1.652.516-.618.246-1.095.516-1.404.772L4.051 6l.11.104c.299.283.816.59 1.51.867C7.284 7.616 9.554 8 12 8s4.717-.384 6.328-1.029c.617-.246 1.095-.516 1.404-.772l.216-.2-.108-.103c-.3-.283-.817-.59-1.512-.867a13 13 0 0 0-2.28-.653 22 22 0 0 0-3.18-.359z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2x = createSvgIcon(Icon$2x(), "Data");
function Data({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2x,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Data$1 = forwardRef(Data);
const Icon$2w = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12.826 2.013a25 25 0 0 0-1.674.001l-.471.02-.53.034q-.699.053-1.36.143l-.063.008-.548.084-.368.064-.437.086-.475.105C4.285 3.175 2.41 4.248 2 5.493V18l.005.13C2.176 20.279 6.585 22 12 22c3.7 0 6.932-.804 8.661-2H12c-2.447 0-4.717-.384-6.328-1.029-.695-.277-1.212-.584-1.512-.867l-.124-.118q-.032-.03-.035-.007V8.4C5.824 9.372 8.728 10 12 10s6.177-.628 8-1.6V12h2V5.493l-.047-.131c-.616-1.53-3.45-2.771-7.123-3.2l-.282-.031-.806-.07-.443-.028zm-1.242 1.991L12 4l.374.003.494.014c1.145.045 2.223.176 3.18.359.849.168 1.62.388 2.28.653.695.277 1.212.584 1.512.867l.108.103-.216.2c-.309.256-.787.526-1.404.772C16.718 7.616 14.448 8 12 8c-2.447 0-4.717-.384-6.328-1.029-.695-.277-1.212-.584-1.512-.867L4.051 6l.217-.2c.309-.255.786-.525 1.404-.771.493-.198 1.049-.37 1.652-.516a21 21 0 0 1 4.108-.506z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M11 12c1.3 0 2.41.83 2.83 2H22v2h-1v2h-2v-2h-.992v2H16v-2h-2.17c-.42 1.16-1.53 2-2.83 2-1.66 0-3-1.35-3-3 0-1.66 1.34-3 3-3m-1 3c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$2w = createSvgIcon(Icon$2w(), "DataAccess");
function DataAccess({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2w,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const DataAccess$1 = forwardRef(DataAccess);
const Icon$2v = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12.13 2H12c-1.712 0-3.324.172-4.733.476C4.46 3.076 2.427 4.19 2 5.493V18l.005.13c.16 2.015 4.047 3.654 8.995 3.85V19.98c-2.06-.09-3.939-.452-5.328-1.008-.695-.277-1.212-.584-1.512-.867l-.124-.118C4.005 17.959 4 17.964 4 18v-3.6c1.636.871 4.141 1.467 7 1.58V13.98c-2.06-.09-3.939-.452-5.328-1.007-.695-.278-1.212-.585-1.512-.868L4.051 12H4V8.4c1.824.972 4.729 1.6 8 1.6s6.176-.628 8-1.6V11h2V5.493l-.047-.131c-.76-1.89-4.9-3.337-9.824-3.362M7.331 4.511A21.3 21.3 0 0 1 12 4l.319.002c1.395.02 2.707.172 3.842.397.804.165 1.536.377 2.167.63.695.277 1.212.584 1.512.867l.108.103-.216.2c-.309.256-.787.526-1.404.772C16.718 7.616 14.448 8 12 8c-2.447 0-4.717-.384-6.328-1.029-.695-.277-1.212-.584-1.512-.867L4.051 6l.217-.2c.309-.255.786-.525 1.404-.771a12 12 0 0 1 1.66-.518",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M21.167 19.753A4.97 4.97 0 0 0 22 17c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5c.98 0 1.938-.29 2.753-.833L22.5 23.91l1.41-1.41zM14 17c0-1.654 1.346-3 3-3s3 1.346 3 3c0 1.655-1.346 3-3 3s-3-1.345-3-3",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$2v = createSvgIcon(Icon$2v(), "DataExplorer");
function DataExplorer({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2v,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const DataExplorer$1 = forwardRef(DataExplorer);
const Icon$2u = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M18 13a5 5 0 1 1 0 10 5 5 0 0 1 0-10m-1 8h2v-1h-2zm-1-2h4v-1h-4zm-1.5-2h7v-1h-7z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m12.826 2.014.473.02.443.027.806.07.282.031c3.673.428 6.507 1.67 7.123 3.2l.047.13v6.763a7 7 0 0 0-2-.965l.001-2.89C18.177 9.372 15.271 10 12 10s-6.176-.628-8-1.6V12h.05l.11.104c.3.283.817.59 1.512.868C7.283 13.616 9.552 14 12 14l.256-.001a7 7 0 0 0-.963 1.991c-2.98-.083-5.601-.689-7.293-1.59V18c0-.036.005-.042.036-.015l.124.119c.3.283.817.59 1.512.868 1.453.581 3.443.95 5.615 1.017.215.726.544 1.403.967 2.01L12 22c-5.414 0-9.824-1.721-9.995-3.87L2 18V5.492c.41-1.245 2.285-2.318 4.9-2.934l.475-.105.437-.087.368-.063.549-.084.061-.008q.662-.09 1.361-.143l.53-.033.471-.02a25 25 0 0 1 1.674-.001M11.31 4.01q.06-.002.123-.003l-.172.004zc-1.47.046-2.836.238-3.987.502a12 12 0 0 0-1.652.515c-.617.247-1.095.517-1.404.773L4.05 6l.11.104c.299.283.816.59 1.51.868C7.284 7.616 9.554 8 12 8s4.717-.384 6.328-1.028c.617-.247 1.096-.517 1.404-.773l.216-.2-.108-.103c-.3-.283-.817-.59-1.512-.868a13 13 0 0 0-2.28-.652 22 22 0 0 0-3.18-.358l-.494-.015L12 4z",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$2u = createSvgIcon(Icon$2u(), "DataFilter");
function DataFilter({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2u,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const DataFilter$1 = forwardRef(DataFilter);
const Icon$2t = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2.833 10.717V12c0 .532 2.249 1.833 6.417 1.833 1.97 0 3.505-.291 4.583-.654v1.906c-1.368.382-2.975.582-4.583.582-2.407 0-4.825-.438-6.417-1.284v1.284c0 .531 2.249 1.833 6.417 1.833 1.97 0 3.505-.291 4.583-.654v1.912c-1.368.38-2.977.575-4.583.575-4.1 0-8.25-1.26-8.25-3.666v-11C1 2.26 5.15 1 9.25 1s8.25 1.26 8.25 3.667v5.5l-1.833.55C14.075 11.562 11.657 12 9.25 12s-4.825-.438-6.417-1.283M9.25 8.333c-2.407 0-4.825-.438-6.417-1.283v1.283c0 .532 2.249 1.834 6.417 1.834s6.417-1.302 6.417-1.834V7.05c-1.592.845-4.01 1.283-6.417 1.283m6.417-3.666c0-.533-2.249-1.834-6.417-1.834S2.833 4.134 2.833 4.667c0 .531 2.249 1.833 6.417 1.833s6.417-1.302 6.417-1.833",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M18.417 16.583h1.833a2.753 2.753 0 0 1 2.75 2.75 2.753 2.753 0 0 1-2.75 2.75V23h-1.833v-.917h-1.834V20.25h3.667a.92.92 0 0 0 .917-.917.92.92 0 0 0-.917-.916h-1.833a2.753 2.753 0 0 1-2.75-2.75 2.753 2.753 0 0 1 2.75-2.75V12h1.833v.917h1.833v1.833h-3.666a.92.92 0 0 0-.917.917c0 .505.412.916.917.916"
    }
  )
] });
const BaseSvgIcon$2t = createSvgIcon(Icon$2t(), "DataMonetization");
function DataMonetization({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2t,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const DataMonetization$1 = forwardRef(DataMonetization);
const Icon$2s = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.955 2.5a1 1 0 0 0-1.366-.366l-3.464 2a1 1 0 0 0-.367 1.366l.084.144-7.488 5.198a1 1 0 0 0-.296 1.321l.04.07-2.598 1.5a1 1 0 0 0-.366 1.365l1.5 2.598A1 1 0 0 0 5 18.062l2.598-1.5.04.07a1 1 0 0 0 1.293.404l.626-.295q.086.12.185.234l-2.826 5.024h2.293l2.275-4.043a3 3 0 0 0 1.032 0l2.274 4.043h2.294l-2.826-5.023a2.99 2.99 0 0 0 .64-2.753l2.277-1.073.084.144a1 1 0 0 0 1.366.366l3.464-2a1 1 0 0 0 .366-1.366zM12.039 16a1 1 0 1 0-.077 0zM12 12c.65 0 1.25.206 1.742.557l2.43-1.145-2.327-4.03L7.25 11.96l1.66 2.874.097-.046A3 3 0 0 1 12 12m2.99-6.635 1.732-1 3.5 6.063-1.732 1zm-8.893 8.599-1.732 1 .5.866 1.732-1z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2s = createSvgIcon(Icon$2s(), "DataObservatory");
function DataObservatory({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2s,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const DataObservatory$1 = forwardRef(DataObservatory);
const Icon$2r = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 2q.418 0 .826.013l.473.02.443.027.806.071.282.031c3.673.429 6.507 1.67 7.123 3.2l.047.13V12h-2V8.4c-1.823.972-4.728 1.6-8 1.6-3.271 0-6.175-.628-8-1.6V12h.051l.11.104c.299.283.816.59 1.51.868C7.284 13.616 9.554 14 12 14q.505 0 1-.021v2.001q-.493.02-1 .02c-3.271 0-6.175-.628-8-1.6V18c0-.036.005-.041.036-.014l.124.118c.3.283.817.59 1.512.867C7.282 19.617 9.552 20 12 20q.505 0 1-.021v2.001q-.493.02-1 .02c-5.415 0-9.824-1.721-9.995-3.87L2 18V5.493c.409-1.246 2.285-2.318 4.9-2.935l.475-.105.437-.086.368-.064.548-.084.062-.008q.663-.09 1.361-.143l.53-.033.471-.02Q11.572 2 12 2m.374 2.003L12 4l-.689.01.121-.003-.171.005.05-.001c-1.47.047-2.837.238-3.987.502-.603.145-1.159.318-1.652.516-.618.246-1.095.516-1.404.772L4.051 6l.11.104c.299.283.816.59 1.51.867C7.284 7.616 9.554 8 12 8s4.717-.384 6.328-1.029c.617-.246 1.095-.516 1.404-.772l.216-.2-.108-.103c-.3-.283-.817-.59-1.512-.867a13 13 0 0 0-2.28-.653 22 22 0 0 0-3.18-.359z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M15 19.17 17.83 22l4.94-4.96-1.41-1.41-3.54 3.54-1.41-1.41z"
    }
  )
] });
const BaseSvgIcon$2r = createSvgIcon(Icon$2r(), "DataOk");
function DataOk({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2r,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const DataOk$1 = forwardRef(DataOk);
const Icon$2q = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 2q.418 0 .826.013l.473.02.443.027.806.071.282.031c3.673.429 6.507 1.67 7.123 3.2l.047.13v6.763a7 7 0 0 0-2-.965V8.4c-1.823.972-4.728 1.6-8 1.6-3.271 0-6.175-.628-8-1.6V12h.051l.11.104c.299.283.816.59 1.51.868C7.284 13.616 9.554 14 12 14l.256-.001a7 7 0 0 0-.963 1.991c-2.98-.083-5.601-.689-7.293-1.59V18c0-.036.005-.041.036-.014l.124.118c.3.283.817.59 1.512.867 1.453.582 3.443.951 5.615 1.018.214.726.544 1.403.967 2.01L12 22c-5.415 0-9.824-1.721-9.995-3.87L2 18V5.493c.409-1.246 2.285-2.318 4.9-2.935l.475-.105.437-.086.368-.064.548-.084.062-.008q.663-.09 1.361-.143l.53-.033.471-.02Q11.572 2 12 2m.374 2.003L12 4l-.689.01.121-.003-.171.005.05-.001c-1.47.047-2.837.238-3.987.502-.603.145-1.159.318-1.652.516-.618.246-1.095.516-1.404.772L4.051 6l.11.104c.299.283.816.59 1.51.867C7.284 7.616 9.554 8 12 8s4.717-.384 6.328-1.029c.617-.246 1.095-.516 1.404-.772l.216-.2-.108-.103c-.3-.283-.817-.59-1.512-.867a13 13 0 0 0-2.28-.653 22 22 0 0 0-3.18-.359z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M18 13c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5m.458 2-.001 3.139 2.25 1.372-.78 1.28-2.97-1.809V15z",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$2q = createSvgIcon(Icon$2q(), "DataPending");
function DataPending({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2q,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const DataPending$1 = forwardRef(DataPending);
const Icon$2p = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 2q.418 0 .826.013l.473.02.443.027.806.071.282.031c3.673.429 6.507 1.67 7.123 3.2l.047.13v6.763a7 7 0 0 0-2-.965V8.4c-1.823.972-4.728 1.6-8 1.6-3.271 0-6.175-.628-8-1.6V12h.051l.11.104c.299.283.816.59 1.51.868C7.284 13.616 9.554 14 12 14l.256-.001a7 7 0 0 0-.963 1.991c-2.98-.083-5.601-.689-7.293-1.59V18c0-.036.005-.041.036-.014l.124.118c.3.283.817.59 1.512.867 1.453.582 3.443.951 5.615 1.018.214.726.544 1.403.967 2.01L12 22c-5.415 0-9.824-1.721-9.995-3.87L2 18V5.493c.409-1.246 2.285-2.318 4.9-2.935l.475-.105.437-.086.368-.064.548-.084.062-.008q.663-.09 1.361-.143l.53-.033.471-.02Q11.572 2 12 2m.374 2.003L12 4l-.689.01.121-.003-.171.005.05-.001c-1.47.047-2.837.238-3.987.502-.603.145-1.159.318-1.652.516-.618.246-1.095.516-1.404.772L4.051 6l.11.104c.299.283.816.59 1.51.867C7.284 7.616 9.554 8 12 8s4.717-.384 6.328-1.029c.617-.246 1.095-.516 1.404-.772l.216-.2-.108-.103c-.3-.283-.817-.59-1.512-.867a13 13 0 0 0-2.28-.653 22 22 0 0 0-3.18-.359z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "m21.516 22.6-3.253-1.963L15.01 22.6l.864-3.7L13 16.41l3.784-.32 1.48-3.49 1.478 3.49 3.784.32-2.873 2.49z"
    }
  )
] });
const BaseSvgIcon$2p = createSvgIcon(Icon$2p(), "DataPremium");
function DataPremium({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2p,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const DataPremium$1 = forwardRef(DataPremium);
const Icon$2o = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 2q.418 0 .826.013l.473.02.443.027.806.071.282.031c3.673.429 6.507 1.67 7.123 3.2l.047.13v6.763a7 7 0 0 0-2-.965V8.4c-1.823.972-4.728 1.6-8 1.6-3.271 0-6.175-.628-8-1.6V12h.051l.11.104c.299.283.816.59 1.51.868C7.284 13.616 9.554 14 12 14l.256-.001a7 7 0 0 0-.963 1.991c-2.98-.083-5.601-.689-7.293-1.59V18c0-.036.005-.041.036-.014l.124.118c.3.283.817.59 1.512.867 1.453.582 3.443.951 5.615 1.018.214.726.544 1.403.967 2.01L12 22c-5.415 0-9.824-1.721-9.995-3.87L2 18V5.493c.409-1.246 2.285-2.318 4.9-2.935l.475-.105.437-.086.368-.064.548-.084.062-.008q.663-.09 1.361-.143l.53-.033.471-.02Q11.572 2 12 2m.374 2.003L12 4l-.689.01.121-.003-.171.005.05-.001c-1.47.047-2.837.238-3.987.502-.603.145-1.159.318-1.652.516-.618.246-1.095.516-1.404.772L4.051 6l.11.104c.299.283.816.59 1.51.867C7.284 7.616 9.554 8 12 8s4.717-.384 6.328-1.029c.617-.246 1.095-.516 1.404-.772l.216-.2-.108-.103c-.3-.283-.817-.59-1.512-.867a13 13 0 0 0-2.28-.653 22 22 0 0 0-3.18-.359z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M23 18a5 5 0 1 0-10 0 5 5 0 0 0 10 0m-8.5 0q.001-.371.074-.721l2.071 2.071v.45c0 .495.406.9.9.9v.77A3.5 3.5 0 0 1 14.5 18m4.846-3.15v-.082a3.5 3.5 0 0 1 1.266 5.562.89.89 0 0 0-.816-.53h-.45v-1.35a.45.45 0 0 0-.45-.45h-2.7v-.9h.9c.247 0 .45-.203.45-.45v-.9h.9c.494 0 .9-.405.9-.9",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$2o = createSvgIcon(Icon$2o(), "DataPublic");
function DataPublic({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2o,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const DataPublic$1 = forwardRef(DataPublic);
const Icon$2n = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 2q.418 0 .826.013l.473.02.443.027.806.071.282.031c3.673.429 6.507 1.67 7.123 3.2l.047.13v6.763a7 7 0 0 0-2-.965V8.4c-1.823.972-4.728 1.6-8 1.6-3.271 0-6.175-.628-8-1.6V12h.051l.11.104c.299.283.816.59 1.51.868C7.284 13.616 9.554 14 12 14l.256-.001a7 7 0 0 0-.963 1.991c-2.98-.083-5.601-.689-7.293-1.59V18c0-.036.005-.041.036-.014l.124.118c.3.283.817.59 1.512.867 1.453.582 3.443.951 5.615 1.018.214.726.544 1.403.967 2.01L12 22c-5.415 0-9.824-1.721-9.995-3.87L2 18V5.493c.409-1.246 2.285-2.318 4.9-2.935l.475-.105.437-.086.368-.064.548-.084.062-.008q.663-.09 1.361-.143l.53-.033.471-.02Q11.572 2 12 2m.374 2.003L12 4l-.689.01.121-.003-.171.005.05-.001c-1.47.047-2.837.238-3.987.502-.603.145-1.159.318-1.652.516-.618.246-1.095.516-1.404.772L4.051 6l.11.104c.299.283.816.59 1.51.867C7.284 7.616 9.554 8 12 8s4.717-.384 6.328-1.029c.617-.246 1.095-.516 1.404-.772l.216-.2-.108-.103c-.3-.283-.817-.59-1.512-.867a13 13 0 0 0-2.28-.653 22 22 0 0 0-3.18-.359z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M23 18a5 5 0 1 0-10 0 5 5 0 0 0 10 0m-8.5 0a3.5 3.5 0 0 1 3.5-3.5v7a3.5 3.5 0 0 1-3.5-3.5",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$2n = createSvgIcon(Icon$2n(), "DataSample");
function DataSample({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2n,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const DataSample$1 = forwardRef(DataSample);
const Icon$2m = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.826 2.013a25 25 0 0 0-1.674.001l-.471.02-.53.034q-.699.053-1.36.143l-.063.008-.548.084-.368.064-.437.086-.475.105C4.285 3.175 2.41 4.248 2 5.493V18l.005.13C2.176 20.279 6.585 22 12 22q.507 0 1-.02V19.98Q12.505 20 12 20c-2.447 0-4.717-.384-6.328-1.029-.695-.277-1.212-.584-1.512-.867l-.124-.118C4.005 17.959 4 17.964 4 18v-3.6c1.825.972 4.729 1.6 8 1.6q.507 0 1-.02V13.98Q12.505 14 12 14c-2.447 0-4.717-.384-6.328-1.028-.695-.278-1.212-.585-1.512-.868L4.051 12H4V8.4c1.825.972 4.729 1.6 8 1.6s6.177-.628 8-1.6V12h2V5.493l-.047-.131c-.616-1.53-3.45-2.771-7.123-3.2l-.282-.031-.806-.07-.443-.028zM12 4l.374.003.494.014c1.145.045 2.223.176 3.18.359.849.168 1.62.388 2.28.653.695.277 1.212.584 1.512.867l.108.103-.216.2c-.309.256-.787.526-1.404.772C16.718 7.616 14.448 8 12 8c-2.447 0-4.717-.384-6.328-1.029-.695-.277-1.212-.584-1.512-.867L4.051 6l.217-.2c.309-.255.786-.525 1.404-.771.493-.198 1.049-.37 1.652-.516a21 21 0 0 1 3.987-.502zm-.689.01.121-.003-.171.005zm9.81 11.455 1.415 1.414L20.414 19l2.121 2.121-1.414 1.415L19 20.414l-2.121 2.121-1.415-1.414L17.587 19l-2.121-2.121 1.414-1.415L19 17.587z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2m = createSvgIcon(Icon$2m(), "DataUnavailable");
function DataUnavailable({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2m,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const DataUnavailable$1 = forwardRef(DataUnavailable);
const Icon$2l = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.99 3H11.8L3.6 7.583l-.1.17v.505l.1.171 8.198 4.625h.193l7.022-3.956v1.231l-7.119 4.01-7.724-4.318-.175-.008-.378.168-.117.18v3.194l.1.171 8.198 4.625h.193l7.022-3.955v1.23l-7.119 4.01-7.724-4.318h-.19l-.38.21-.1.172v.546l.1.172L11.8 21h.191l8.156-4.583.1-.17V13.05l-.092-.166-.336-.21-.2-.005-7.725 4.318-7.118-4.01v-1.231l7.023 3.955h.193l8.156-4.624.1-.171V7.754l-.101-.172-.379-.21h-.191l-7.683 4.318-6.535-3.684 6.536-3.644 5.58 3.142.189.002.546-.294.104-.173v-.378l-.1-.171z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2l = createSvgIcon(Icon$2l(), "Databricks");
function Databricks({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2l,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Databricks$1 = forwardRef(Databricks);
const Icon$2k = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m7.086 15.795 1.12 1.118-2.598 2.598c.034.13.059.265.059.406a1.583 1.583 0 1 1-1.584-1.584q.14.001.274.029l.132.03zm9.828 0 2.597 2.598c.13-.035.265-.06.406-.06a1.583 1.583 0 1 1-1.584 1.584q.001-.14.029-.274l.03-.13-2.597-2.6zM12 8.833a3.963 3.963 0 0 1 3.953 3.755l.005.204v2.375c0 .4-.297.732-.684.784l-.107.007h-.792v3.167c0 .4-.297.732-.684.784l-.108.008h-3.166a.79.79 0 0 1-.785-.685l-.007-.107v-3.167h-.792a.79.79 0 0 1-.784-.684l-.007-.107v-2.375A3.963 3.963 0 0 1 12 8.833m0 1.584a2.38 2.38 0 0 0-2.37 2.212l-.005.163v1.583h.792c.401 0 .732.298.784.684l.007.108v3.166h1.584v-3.166c0-.4.297-.732.684-.785l.107-.007h.792v-1.583A2.38 2.38 0 0 0 12 10.417m-7.917 0c.531 0 .997.265 1.284.667l.08.124H7.25v1.584H5.447A1.578 1.578 0 0 1 2.5 12c0-.874.709-1.583 1.583-1.583m15.834 0a1.583 1.583 0 0 1 0 3.166c-.532 0-.998-.265-1.284-.667l-.08-.124H16.75v-1.584h1.803c.274-.47.78-.791 1.364-.791M12 4.083a2.38 2.38 0 0 1 2.375 2.375A2.38 2.38 0 0 1 12 8.833a2.38 2.38 0 0 1-2.375-2.375A2.38 2.38 0 0 1 12 4.083M4.083 2.5c.875 0 1.584.71 1.584 1.583q-.001.14-.029.274l-.03.132 2.598 2.597-1.12 1.12L4.49 5.608c-.13.034-.265.059-.406.059a1.583 1.583 0 0 1 0-3.167m15.834 0a1.583 1.583 0 0 1 0 3.167q-.14-.001-.274-.029l-.132-.03-2.597 2.598-1.12-1.12 2.598-2.597a1.6 1.6 0 0 1-.059-.406c0-.874.709-1.583 1.584-1.583M12 5.667a.792.792 0 1 0 .002 1.585A.792.792 0 0 0 12 5.667",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2k = createSvgIcon(Icon$2k(), "Demographics");
function Demographics({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2k,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Demographics$1 = forwardRef(Demographics);
const Icon$2j = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.395 13.54a.79.79 0 0 1 .891.29l.06.097.785 1.546a.76.76 0 0 1-.074.809l-.073.082-.23.227h5.96c.298 0 .57.165.703.427a.76.76 0 0 1-.014.718l-.06.091-2.357 3.091a.8.8 0 0 1-.524.302l-.105.007H5.714a.78.78 0 0 1-.679.766L4.93 22H1.786a.78.78 0 0 1-.779-.668L1 21.227v-6.181c0-.391.296-.715.68-.766l.106-.007h3.143c.295 0 .55.162.684.4l.044.092zm-5.252 2.278H2.57v4.637h1.572zm5.102-.6-3.53 1.157v3.307h8.25l1.178-1.546H8.07v-.772a.83.83 0 0 1 .15-.453l.08-.094 1.171-1.151zM21.4 14.2c.882 0 1.6.718 1.6 1.6v1.6c0 .882-.718 1.6-1.6 1.6h-1.6c-.882 0-1.6-.718-1.6-1.6v-1.6c0-.882.718-1.6 1.6-1.6zm0 1.6h-1.6v1.6h1.598zm-5.6-7.2c.882 0 1.6.718 1.6 1.6v1.6c0 .882-.718 1.6-1.6 1.6h-1.6c-.882 0-1.6-.718-1.6-1.6v-1.6c0-.882.718-1.6 1.6-1.6zm5.6 0c.882 0 1.6.718 1.6 1.6v1.6c0 .882-.718 1.6-1.6 1.6h-1.6c-.882 0-1.6-.718-1.6-1.6v-1.6c0-.882.718-1.6 1.6-1.6zm-5.6 1.6h-1.6v1.6h1.598zm5.6 0h-1.6v1.6h1.598zM10.2 3c.882 0 1.6.718 1.6 1.6v1.6c0 .882-.718 1.6-1.6 1.6H8.6C7.718 7.8 7 7.082 7 6.2V4.6C7 3.718 7.718 3 8.6 3zm5.6 0c.882 0 1.6.718 1.6 1.6v1.6c0 .882-.718 1.6-1.6 1.6h-1.6c-.882 0-1.6-.718-1.6-1.6V4.6c0-.882.718-1.6 1.6-1.6zm5.6 0c.882 0 1.6.718 1.6 1.6v1.6c0 .882-.718 1.6-1.6 1.6h-1.6c-.882 0-1.6-.718-1.6-1.6V4.6c0-.882.718-1.6 1.6-1.6zM10.2 4.6H8.6v1.6h1.598zm5.6 0h-1.6v1.6h1.598zm5.6 0h-1.6v1.6h1.598z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2j = createSvgIcon(Icon$2j(), "Derived");
function Derived({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2j,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Derived$1 = forwardRef(Derived);
const Icon$2i = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.962 13 12 10.33 13.038 13zM12 6a1.001 1.001 0 0 1 0 2 1.001 1.001 0 0 1 0-2m4.927 17 1.368-2-2.333-6H17v-2h-1.816l-1.4-3.601A2.98 2.98 0 0 0 15 7a2.99 2.99 0 0 0-2-2.816V2h-2v2.184A2.99 2.99 0 0 0 9 7c0 .986.482 1.853 1.216 2.399L8.816 13H7v2h1.038l-2.333 6 1.368 2 3.11-8h3.633z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2i = createSvgIcon(Icon$2i(), "Distance");
function Distance({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2i,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Distance$1 = forwardRef(Distance);
const Icon$2h = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx("circle", { cx: 12, cy: 12, r: 5, fill: "currentColor" }) });
const BaseSvgIcon$2h = createSvgIcon(Icon$2h(), "Dot");
function Dot({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2h,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Dot$1 = forwardRef(Dot);
const Icon$2g = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16m0 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2g = createSvgIcon(Icon$2g(), "DrawCircle");
function DrawCircle({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2g,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const DrawCircle$1 = forwardRef(DrawCircle);
const Icon$2f = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 3c4.935 0 9 3.736 9 9l-.002.343-.012.668q-.018.657-.062 1.266l-.05.597C20.498 18.767 19.267 21 17 21c-1.192 0-1.971-.341-2.988-1.122l-.472-.375c-.401-.319-.64-.473-.888-.566a5 5 0 0 0-.415-.13l-.34-.085-.398-.086-.456-.086-.66-.111-1.708-.273a9 9 0 0 1-.952-.206C5.46 17.301 3 14.954 3 12.015c0-1.508.485-2.995 1.436-4.458.355.585.906 1.04 1.562 1.272C5.328 9.916 5 10.977 5 12.015c0 1.889 1.78 3.588 3.282 4.025l.085.023.345.076.517.092 1.619.257.583.1.518.098.237.05.433.103c.272.07.512.143.73.224.434.161.783.373 1.235.718l.457.362c.806.646 1.24.857 1.959.857.893 0 1.63-1.518 1.895-4.45l.045-.585q.02-.3.033-.62l.02-.655Q19 12.354 19 12c0-4.12-3.133-7-7-7a1 1 0 1 1 0-2M7 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2f = createSvgIcon(Icon$2f(), "DrawLasso");
function DrawLasso({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2f,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const DrawLasso$1 = forwardRef(DrawLasso);
const Icon$2e = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    d: "M14 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4M8 12a2 2 0 1 0-4 0 2 2 0 0 0 4 0M20 20a2 2 0 1 0-4 0 2 2 0 0 0 4 0M11.292 5.293a3 3 0 0 0 1.415 1.415l-4 3.999a3 3 0 0 0-1.414-1.415zM15.091 19.263 7.8 14.4c.54-.405.94-.99 1.11-1.664L16.2 17.6c-.54.405-.94.99-1.11 1.664"
  }
) });
const BaseSvgIcon$2e = createSvgIcon(Icon$2e(), "DrawLine");
function DrawLine({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2e,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const DrawLine$1 = forwardRef(DrawLine);
const Icon$2d = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 18a2 2 0 1 1 0 4 2 2 0 0 1 0-4m16 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4m-2.829 1a3 3 0 0 0 0 2H6.829a3 3 0 0 0 0-2zm-2.463-5.707 3.998 4a3 3 0 0 0-1.414 1.414l-4-3.999a3 3 0 0 0 1.31-1.214zM2.998 6.829a3 3 0 0 0 2.002 0v10.342a3 3 0 0 0-2.002 0zM12 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4m1.84-3.919c.464.483 1.09.81 1.79.896l-1.47 2.94a3 3 0 0 0-1.79-.894zM16 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4M4 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4m9.171.998a3 3 0 0 0 0 2.002H6.829a3 3 0 0 0 0-2.002z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2d = createSvgIcon(Icon$2d(), "DrawPolygon");
function DrawPolygon({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2d,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const DrawPolygon$1 = forwardRef(DrawPolygon);
const Icon$2c = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 18a2 2 0 1 1 0 4 2 2 0 0 1 0-4m16 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4m-2.829 1a3 3 0 0 0-.17.974l-.001.052.007.183q.03.414.164.79H6.829a3 3 0 0 0 0-2zM2.998 6.828a3 3 0 0 0 2.002 0v10.342a3 3 0 0 0-2.002 0zm16.001 0a3 3 0 0 0 2 0v10.342a3 3 0 0 0-2 0zM20 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4M4 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4m13.171.998a3 3 0 0 0-.17.976L17 4.026l.007.183q.03.414.164.79H6.829a3 3 0 0 0 0-2z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2c = createSvgIcon(Icon$2c(), "DrawSquare");
function DrawSquare({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2c,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const DrawSquare$1 = forwardRef(DrawSquare);
const Icon$2b = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M11 18V9.858A3.99 3.99 0 0 1 8 6a4 4 0 0 1 8 0 3.99 3.99 0 0 1-3 3.858V18zm3-12c0-1.103-.897-2-2-2s-2 .897-2 2 .897 2 2 2 2-.897 2-2",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M15 16.181v-2.013c3.746.421 7 1.655 7 3.832 0 2.748-5.184 4-10 4S2 20.748 2 18c0-2.177 3.254-3.411 7-3.832v2.013c-3.288.41-5 1.415-5 1.819 0 .514 2.75 2 8 2s8-1.486 8-2c0-.404-1.712-1.409-5-1.819"
    }
  )
] });
const BaseSvgIcon$2b = createSvgIcon(Icon$2b(), "DropAPin");
function DropAPin({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2b,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const DropAPin$1 = forwardRef(DropAPin);
const Icon$2a = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13 2v2h8c.51 0 .935.388.993.884L22 5v14c0 .51-.388.935-.884.993L21 20h-8v2h-2v-2H3c-.51 0-.935-.388-.993-.884L2 19V5c0-.51.388-.935.884-.993L3 4h8V2zm-2 4H4v12h7zm9 0h-7v12h7z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2a = createSvgIcon(Icon$2a(), "DualMap");
function DualMap({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2a,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const DualMap$1 = forwardRef(DualMap);
const Icon$29 = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.5 7c3.703 0 7 3.253 7 7.595 0 3.577-3.161 6.77-6.77 6.9l-.23.005H8.1c-3.245 0-5.6-2.323-5.6-4.833 0-3.201 2.355-5.524 5.6-5.524l.54.034c.244.01.541.01.86-.034C10.525 8.76 13.15 7 16.5 7m.042 2c-2.837 0-4.962 1.67-5.667 4.2.065.194-.172.468-.708.7a1 1 0 0 1-.144.01l-.455-.011-.11.001c-.57-.525-1.166-.7-1.416-.7-2.112 0-3.542 1.413-3.542 3.5 0 1.339 1.333 2.703 3.326 2.795l.216.005h8.5c2.575 0 4.958-2.355 4.958-4.9 0-3.245-2.383-5.6-4.958-5.6M2.5 8.5v2h-2v-2zM7.737 5c1.314 0 2.48.6 3.263 1.552a9.6 9.6 0 0 0-2.733 2.749c-.18-.011-.35-.022-.53-.022-1.493 0-2.892.45-4.057 1.221a4.3 4.3 0 0 1-.18-1.22C3.5 6.914 5.396 5 7.737 5M3.48 4.039 4.958 5.48l-1.48 1.439L2 5.478zm8.5 0 1.478 1.44-1.479 1.44-1.478-1.44zM9 2.5v2H7v-2z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$29 = createSvgIcon(Icon$29(), "Environmental");
function Environmental({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$29,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Environmental$1 = forwardRef(Environmental);
const Icon$28 = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.5 2h3a6 6 0 0 1 5.456 3.5h.088A6 6 0 0 1 17.5 2h3v1a6 6 0 0 1-6 6H13v3.835A7.99 7.99 0 0 1 19.5 9.5H23v1a8 8 0 0 1-8 8h-2v4h-2v-4H9a8 8 0 0 1-8-8v-1h3.5a7.99 7.99 0 0 1 6.5 3.335V9H9.5a6 6 0 0 1-6-6zm2.126 2C6.07 5.725 7.636 7 9.5 7h.874A4 4 0 0 0 6.5 4zM14.5 7a4 4 0 0 0 3.874-3H17.5a4 4 0 0 0-3.874 3zM3.083 11.5A6 6 0 0 0 9 16.5h1.417a6 6 0 0 0-5.917-5zM15 16.5a6 6 0 0 0 5.917-5H19.5a6 6 0 0 0-5.917 5z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$28 = createSvgIcon(Icon$28(), "EnvironmentalManagement");
function EnvironmentalManagement({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$28,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const EnvironmentalManagement$1 = forwardRef(EnvironmentalManagement);
const Icon$27 = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M4 17v-3h16v3zm0-7V7h16v3z" }) });
const BaseSvgIcon$27 = createSvgIcon(Icon$27(), "Equal");
function Equal({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$27,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Equal$1 = forwardRef(Equal);
const Icon$26 = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.91 15.59 12.5 17l-5-5 5-5 1.41 1.41L11.33 11H21v2h-9.67zM5 3h14a2 2 0 0 1 2 2v4h-2V5H5v14h14v-4h2v4a2 2 0 0 1-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$26 = createSvgIcon(Icon$26(), "ExitToAppLeft");
function ExitToAppLeft({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$26,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const ExitToAppLeft$1 = forwardRef(ExitToAppLeft);
const Icon$25 = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m7.122 9.632 12.121-1.79h.005a.72.72 0 0 0 .593-.527l1.13-3.406a.718.718 0 0 0-.738-.907l-.045.003L8.62 4.715C7.365 4.911 6.268 5.83 5.94 7.04l-.956 3.492c.135-.492.567-.616 2.138-.9m-.061 1.154c-1.453.301-1.996.786-2.314 1.497a4 4 0 0 0-.148.395l-.835 2.952a4.5 4.5 0 0 1 1.504-.51l.008-.002 8.184-1.2c.712-.117.846-.616.982-1.126l.031-.114.86-3.123-8.03 1.187zM5.448 16.23c-1.636.266-2.173 1.349-2.302 1.68a2.267 2.267 0 0 0 1.869 3.058q.475.072 1.086-.017l1.86-.258a1.18 1.18 0 0 0 .975-.86l1.169-4.286z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$25 = createSvgIcon(Icon$25(), "Fabric");
function Fabric({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$25,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Fabric$1 = forwardRef(Fabric);
const Icon$24 = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c5.05-.5 9-4.76 9-9.95",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$24 = createSvgIcon(Icon$24(), "Facebook");
function Facebook({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$24,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Facebook$1 = forwardRef(Facebook);
const Icon$23 = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 5a1 1 0 0 1 .993.883L22 6v12a1 1 0 0 1-.883.993L21 19H3a1 1 0 0 1-.993-.883L2 18V6a1 1 0 0 1 .883-.993L3 5zM4 13.414V17h3.586zM13.586 7H4v3.586L10.414 17H20v-3.586zM12 8c2.205 0 4 1.794 4 4s-1.795 4-4 4-4-1.794-4-4 1.795-4 4-4m0 2c-1.104 0-2 .898-2 2 0 1.103.896 2 2 2s2-.897 2-2-.896-2-2-2m8-3h-3.586L20 10.586z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$23 = createSvgIcon(Icon$23(), "Financial");
function Financial({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$23,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Financial$1 = forwardRef(Financial);
const Icon$22 = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    d: "M13 23h-2V1h2zM7 21h2v-2H7zM3 9h2V7H3zM21 19V5c0-1.1-.9-2-2-2h-4v2h4v14h-4v2h4c1.1 0 2-.9 2-2M5 5V3c-1.1 0-2 .9-2 2zM3 17h2v-2H3zM7 5h2V3H7zM3 13h2v-2H3zM3 19c0 1.1.9 2 2 2v-2z"
  }
) });
const BaseSvgIcon$22 = createSvgIcon(Icon$22(), "FlipInverse");
function FlipInverse({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$22,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const FlipInverse$1 = forwardRef(FlipInverse);
const Icon$21 = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M6 18V6h12v12zM7 7h10v10H7z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2 4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm2 0h16v16H4z",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$21 = createSvgIcon(Icon$21(), "Framed");
function Framed({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$21,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Framed$1 = forwardRef(Framed);
const Icon$20 = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M20 4c1.07 0 1.945.844 1.998 1.9L22 6v7.5h-2.002l.001-2.5H4v7h7.5v2H4a2 2 0 0 1-1.998-1.9L2 18V6c0-1.069.843-1.945 1.9-1.998L4 4zm0 2H4v3h15.999z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M10 15v2H5v-2zM12 12v2H5v-2zM18 19.5h-1v-3h1zM18.125 20.5a.625.625 0 1 1-1.25 0 .625.625 0 0 1 1.25 0"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m23.5 23-6-11-6 11zm-2.527-1.5h-6.946l3.473-6.368z",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$20 = createSvgIcon(Icon$20(), "FraudDetection");
function FraudDetection({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$20,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const FraudDetection$1 = forwardRef(FraudDetection);
const Icon$1$ = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2m0 2c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8m2.123 2q.571-.001.973.241c.305.185.477.448.477.767 0 .405-.265.659-.673.659a.98.98 0 0 1-.687-.3l-.089-.086-.253-.24c-.226 0-.401.144-.535.487l-.043.122-.037.123-.053.228-.052.277-.025.158-.05.351-.024.195-.047.426-.045.475-.06.745 2.198-.006-.002 1.356-2.268-.007-.043.433-.05.614-.027.29-.06.547a13 13 0 0 1-.3 1.717l-.052.19-.048.155q-.308.957-.984 1.515a2.43 2.43 0 0 1-1.58.568q-.545.001-.93-.233c-.29-.179-.454-.435-.454-.744 0-.183.066-.35.192-.484a.65.65 0 0 1 .48-.212c.203 0 .39.076.558.217l.083.076.28.287c.057.057.098.076.13.076.374 0 .682-.605.818-1.929l.091-.997.042-.646.057-1.022.05-.426-2.31-.005-.013-1.329h2.423l.024-.258q.15-1.543.457-2.41l.063-.168.06-.142q.36-.774.96-1.208c.408-.294.87-.443 1.378-.443",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1$ = createSvgIcon(Icon$1$(), "Functions");
function Functions({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1$,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Functions$1 = forwardRef(Functions);
const Icon$1_ = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M20.6 3.4 23 4.5l-2.4 1.1L19.5 8l-1.1-2.4L16 4.5l2.4-1.1L19.5 1z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10a10 10 0 0 0 8.74-5.14l-1.111-2.45C18.603 17.648 15.57 20 12 20c-4.41 0-8-3.59-8-8s3.59-8 8-8q.67.001 1.309.107l2.743-1.251A10 10 0 0 0 12 2"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M13 7v2h-2V7zM13 17v-6h-2v6zM21.478 9.485l.78 1.72 1.72.78-1.72.78-.78 1.72-.78-1.72-1.72-.78 1.72-.78z"
    }
  )
] });
const BaseSvgIcon$1_ = createSvgIcon(Icon$1_(), "GeneratingDescription");
function GeneratingDescription({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1_,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const GeneratingDescription$1 = forwardRef(GeneratingDescription);
const Icon$1Z = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M21.495 4.851A2.007 2.007 0 0 0 19.5 3h-15l-.149.006A2.007 2.007 0 0 0 2.5 5v14l.006.149A2.007 2.007 0 0 0 4.5 21h10.086a16 16 0 0 1-.995-2H9.5v-9h5v2.633a5.4 5.4 0 0 1 2-1.303V10h3v1.121a5.35 5.35 0 0 1 2.001.89L21.5 5zM4.5 10h3v9h-3zm0-5h15v3h-15z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M18.36 13c1.856 0 3.36 1.492 3.36 3.333 0 1.134-.69 2.61-1.445 3.884l-.285.468-.354.548-.337.497-.248.351-.32.437-.371.482-.371-.482-.32-.437-.248-.351-.268-.393-.28-.427-.143-.225-.285-.468C15.69 18.943 15 17.467 15 16.333 15 14.493 16.504 13 18.36 13m0 1.667c-.927 0-1.68.746-1.68 1.666S17.433 18 18.36 18s1.68-.747 1.68-1.667-.753-1.666-1.68-1.666",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$1Z = createSvgIcon(Icon$1Z(), "GeocodeTable");
function GeocodeTable({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1Z,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const GeocodeTable$1 = forwardRef(GeocodeTable);
const Icon$1Y = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6 18h12V6H6zM8 8h8v8H8zm8-7h2v3h-2zM6 1h2v3H6zm10 19h2v3h-2zM6 20h2v3H6zM20 6h3v2h-3zm0 10h3v2h-3zM1 6h3v2H1zm0 10h3v2H1z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1Y = createSvgIcon(Icon$1Y(), "Geography");
function Geography({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1Y,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Geography$1 = forwardRef(Geography);
const Icon$1X = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.625 4c.483 0 .875.395.875.881v10.107c0 .488-.035 1.015-.518 1.015h-1.996V22.5h-2.001v-2.003H5.995V22.5H4.007v-6.497H2.292c-.483 0-.792-.17-.792-.658V4.881c0-.486.392-.881.875-.881zM18 16H6v2.5h12zm2.5-10h-17v8h17zm-3 .5 1 1.5-5 4.5c-.542.493-1.09.493-1.5 0l-2-2-3 3L6 12l3.5-3c.308-.329.856-.329 1 0l2 1.5zm-7-5H14V3h-3.5z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1X = createSvgIcon(Icon$1X(), "Geomarketing");
function Geomarketing({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1X,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Geomarketing$1 = forwardRef(Geomarketing);
const Icon$1W = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 2a2 2 0 0 1 .778 3.843l-1.57 12.563A2 2 0 1 1 16.268 21H7.732a2 2 0 1 1-2.94-2.595L3.222 5.843a2 2 0 1 1 2.74-1.455l5.393 4.718a2 2 0 0 1 1.291 0l5.392-4.718A2 2 0 0 1 20 2m-1.319 4.482-4.719 4.13Q14 10.801 14 11a2 2 0 1 1-3.962-.388l-4.72-4.13 1.461 11.675c.402.17.737.468.953.843h8.536c.216-.375.551-.672.953-.843z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1W = createSvgIcon(Icon$1W(), "Geometry");
function Geometry({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1W,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Geometry$1 = forwardRef(Geometry);
const Icon$1V = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2C6.478 2 2 6.426 2 11.887c0 4.368 2.865 8.074 6.839 9.382.5.091.683-.215.683-.476 0-.236-.01-1.014-.014-1.84-2.782.597-3.369-1.167-3.369-1.167-.455-1.143-1.11-1.447-1.11-1.447-.907-.613.068-.6.068-.6 1.005.069 1.533 1.018 1.533 1.018.892 1.511 2.34 1.074 2.91.822.09-.64.35-1.075.635-1.322-2.221-.25-4.556-1.098-4.556-4.886 0-1.08.39-1.962 1.03-2.654-.103-.25-.446-1.255.097-2.617 0 0 .84-.265 2.751 1.014A9.7 9.7 0 0 1 12 6.78c.85.004 1.706.114 2.505.333 1.909-1.28 2.748-1.014 2.748-1.014.544 1.362.201 2.368.098 2.617a3.8 3.8 0 0 1 1.029 2.654c0 3.797-2.34 4.633-4.566 4.878.358.307.678.908.678 1.83 0 1.324-.012 2.389-.012 2.714 0 .263.18.572.687.474C19.138 19.96 22 16.254 22 11.887 22 6.427 17.523 2 12 2",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1V = createSvgIcon(Icon$1V(), "Github");
function Github({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1V,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Github$1 = forwardRef(Github);
const Icon$1U = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.905 10.699H12v3.087h5.27A5.565 5.565 0 1 1 12 6.436c1.391 0 2.662.512 3.638 1.356L18.1 5.384A9 9 0 1 0 12 21c4.359 0 7.994-3.1 8.822-7.214a9 9 0 0 0 .083-3.088",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1U = createSvgIcon(Icon$1U(), "Google");
function Google({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1U,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Google$1 = forwardRef(Google);
const Icon$1T = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.522 2.004c.645 0 1.245.324 1.608.86l.086.139 3.522 8.002c.32.566.347 1.253.08 1.84l-.08.158-3.522 8.002c-.323.57-.898.939-1.534.992l-.16.007H6.478a1.94 1.94 0 0 1-1.608-.86l-.086-.14-3.522-8.001a2.04 2.04 0 0 1-.08-1.84l.08-.158 3.522-8.002c.323-.571.898-.94 1.534-.993l.16-.006zM17.5 4.002h-11L3 12.004l3.5 8.002h11l3.5-8.002zM16 8a2 2 0 0 1 1.994 1.85L18 10v.5c0 .83-.67 1.5-1.5 1.5.781 0 1.42.594 1.493 1.355L18 13.5v.5a2 2 0 0 1-1.851 1.995L16 16h-3v-2h3v-1h-2v-2h2v-1h-3V8zM8 8v3h1V8h2v8H9v-3H8v3H6V8z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1T = createSvgIcon(Icon$1T(), "H3");
function H3({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1T,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const H3$1 = forwardRef(H3);
const Icon$1S = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.625 3a5.63 5.63 0 0 1 5.625 5.625q-.002.692-.145 1.375h-2.316c.136-.462.211-.923.211-1.375a3.38 3.38 0 0 0-3.375-3.375c-1.9 0-3.375 1.815-3.375 3.375a1.125 1.125 0 0 1-2.247.077L11 8.625c0-1.56-1.475-3.375-3.375-3.375A3.38 3.38 0 0 0 4.25 8.625c0 3.725 5.063 7.974 7.75 9.822v2.546a1.1 1.1 0 0 1-.382-.114l-.09-.05C11.14 20.586 2 14.802 2 8.625A5.63 5.63 0 0 1 7.625 3c1.793 0 3.455.942 4.5 2.34C13.17 3.942 14.832 3 16.625 3m-2.01 6.892a.25.25 0 0 1 .467-.002l2.119 5.512 1.16-3.483a.25.25 0 0 1 .437-.072l.024.04 1.274 2.548H23a.25.25 0 0 1 .246.206l.004.045v.958a.25.25 0 0 1-.25.25h-3.65a.25.25 0 0 1-.224-.138l-.303-.607-1.303 3.91a.25.25 0 0 1-.451.052l-.02-.041-2.186-5.686-.88 2.348a.25.25 0 0 1-.19.158l-.044.004H11.5a.25.25 0 0 1-.25-.25v-.958a.25.25 0 0 1 .25-.25h1.411z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1S = createSvgIcon(Icon$1S(), "HealthAnalytics");
function HealthAnalytics({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1S,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const HealthAnalytics$1 = forwardRef(HealthAnalytics);
const Icon$1R = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M12 3.867c4.41 0 8 3.59 8 8a7.95 7.95 0 0 1-.844 3.574l1.476 1.476A9.95 9.95 0 0 0 22 11.867c0-5.52-4.48-10-10-10a9.95 9.95 0 0 0-5.05 1.368l1.476 1.476A7.95 7.95 0 0 1 12 3.867"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M17.972 19.887A9.95 9.95 0 0 1 12 21.867c-1.54 0-2.98-.36-4.29-.97L1 22.867l1.97-6.71c-.61-1.31-.97-2.75-.97-4.29 0-2.238.737-4.306 1.98-5.972L1.9 3.815 3.314 2.4l18.414 18.414-1.414 1.414zM5.415 7.329a7.95 7.95 0 0 0-.635 7.968c.21.44.25.95.11 1.42l-.94 3.2 3.2-.94c.18-.05.37-.08.56-.08.3 0 .59.06.86.19a7.953 7.953 0 0 0 7.968-.635z",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$1R = createSvgIcon(Icon$1R(), "HideComments");
function HideComments({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1R,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const HideComments$1 = forwardRef(HideComments);
const Icon$1Q = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "m17 15.17-1.41 1.42L11 12l4.59-4.58L17 8.83 13.83 12z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M22 20a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1zM8.5 19H20V5H8.5zm-2 0V5H4v14z",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$1Q = createSvgIcon(Icon$1Q(), "HideLeftsidebar");
function HideLeftsidebar({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1Q,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const HideLeftsidebar$1 = forwardRef(HideLeftsidebar);
const Icon$1P = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "m13 12-4.59 4.58L7 15.17 10.17 12 7 8.83l1.41-1.42z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M18 3a4 4 0 0 1 4 4v10a4 4 0 0 1-3.794 3.995L18 21H6l-.206-.005a4 4 0 0 1-3.79-3.789L2 17V7a4 4 0 0 1 4-4zM6 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h9V5zm10.5 14H18a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1.5z",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$1P = createSvgIcon(Icon$1P(), "HideRightsidebar");
function HideRightsidebar({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1P,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const HideRightsidebar$1 = forwardRef(HideRightsidebar);
const Icon$1O = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.4 3.2a1 1 0 0 1 1.09-.072l.11.072 8 6a1 1 0 0 1 .393.683L21 10v11h-8v-6h-2v6H3V10a1 1 0 0 1 .31-.724L3.4 9.2zM9 13h6v6h4v-8.5l-7-5.25-7 5.25V19h4z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1O = createSvgIcon(Icon$1O(), "Home");
function Home({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1O,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Home$1 = forwardRef(Home);
const Icon$1N = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11 2.5c.414-.558.982-.593 1.415-.104l.085.104L21 11l.5 1c-.208.45-.527.687-.905.544L20.5 12.5H19v8c.07.526-.306.941-.875.994L18 21.5H6c-.596 0-1.016-.38-1.008-.889l.008-.11v-8H3c-.419.224-.775-.013-1-.5-.07-.222-.006-.592.385-.914L2.5 11zm1 2L5.5 11H6c.586-.152 1.013.22 1.006.874L7 12v7.5h10V12c-.061-.688.327-1.11.892-1.022L18 11h.5zM13 9v1h2v2h-3.5c-.276-.15-.5.064-.5.5 0 .076.172.249.4.425l.1.075h1c1.378-.2 2.5.866 2.5 2 0 1.259-.78 2.19-1.84 2.464L13 17.5v1h-2v-1H9v-2h3.5c.276.15.5-.064.5-.5 0-.075-.171-.248-.4-.424l-.1-.076h-1c-1.378.2-2.5-.866-2.5-2 0-1.258.78-2.189 1.84-2.463L11 10V9z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1N = createSvgIcon(Icon$1N(), "Housing");
function Housing({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1N,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Housing$1 = forwardRef(Housing);
const Icon$1M = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 2c1.053 0 1.918.816 1.994 1.85L17 4v4H7v8h10v4a2 2 0 0 1-1.85 1.994L15 22H7a2 2 0 0 1-1.995-1.85L5 20V4c0-1.054.817-1.918 1.85-1.995L7 2zm0 16H7v2h8zm4-10a3 3 0 0 1 3 3c0 .97-.705 2.175-1.432 3.158l-.272.358-.266.332-.252.3-.335.38L19 16l-.262-.274-.181-.198-.335-.38-.252-.3-.266-.332-.272-.358C16.705 13.175 16 11.97 16 11a3 3 0 0 1 3-3m0 1.5a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 19 9.5M15 4H7v2h8z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1M = createSvgIcon(Icon$1M(), "HumanMobility");
function HumanMobility({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1M,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const HumanMobility$1 = forwardRef(HumanMobility);
const Icon$1L = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19 3c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2zm0 2H5v14h14zM9.5 9v6H8V9zM15 9c.85 0 1.5.65 1.5 1.5v3c0 .85-.65 1.5-1.5 1.5h-3.5V9zm0 1.5h-2v3h2z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1L = createSvgIcon(Icon$1L(), "Id");
function Id({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1L,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Id$1 = forwardRef(Id);
const Icon$1K = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M16 8h-2c-1.1 0-2-.9-2-2s.9-2 2-2h2V2h-2c-2.21 0-4 1.79-4 4s1.79 4 4 4h2zM24 6c0-2.21-1.79-4-4-4h-2v2h2c1.1 0 2 .9 2 2s-.9 2-2 2h-2v2h2c2.21 0 4-1.79 4-4"
    }
  ),
  /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M20 5v2h-6V5z" }),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M19 19v-7h1q.511 0 1-.083V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2h3.803a6 6 0 0 0-.72 2H5v14z"
    }
  ),
  /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "m14.14 11.86-3 3.87L9 13.14 6 17h12z" })
] });
const BaseSvgIcon$1K = createSvgIcon(Icon$1K(), "Image");
function Image({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1K,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Image$1 = forwardRef(Image);
const Icon$1J = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M20 12c0 2.21-.895 4.21-2.343 5.657l1.414 1.414A9.97 9.97 0 0 0 22 12c0-5.523-4.477-10-10-10S2 6.477 2 12a9.97 9.97 0 0 0 2.929 7.071l1.414-1.414A8 8 0 1 1 20 12"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M16 22a1 1 0 0 0 .914-1.406l-3.297-7.417a2 2 0 1 0-3.235 0l-3.296 7.417A1 1 0 0 0 8 22zm-2.872-5L12 14.462 10.872 17zm.667 1.5h-3.59L9.54 20h4.922z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M15.715 13.486a4 4 0 1 0-7.43 0l-1.857.743a6 6 0 1 1 11.145 0z"
    }
  )
] });
const BaseSvgIcon$1J = createSvgIcon(Icon$1J(), "Infrastructure");
function Infrastructure({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1J,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Infrastructure$1 = forwardRef(Infrastructure);
const Icon$1I = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.007 5.293a5.7 5.7 0 0 1 4.602 2.302l-1.534 1.15a3.8 3.8 0 0 0-3.068-1.536c-1.217 0-2.336.56-3.067 1.535L7.407 7.592a5.7 5.7 0 0 1 4.6-2.3m0-3.834a9.57 9.57 0 0 1 7.321 3.4l-1.463 1.237a7.66 7.66 0 0 0-5.857-2.72 7.66 7.66 0 0 0-5.87 2.733L4.672 4.874a9.57 9.57 0 0 1 7.335-3.415m1.91 8.626a2.88 2.88 0 0 1 2.875 2.874v5.75a2.88 2.88 0 0 1-2.875 2.875h-3.834a2.88 2.88 0 0 1-2.875-2.875v-5.75a2.88 2.88 0 0 1 2.875-2.874zm0 1.916h-3.834a.96.96 0 0 0-.958.959v5.75c0 .527.43.958.958.958h3.834a.96.96 0 0 0 .958-.959v-5.75a.96.96 0 0 0-.958-.958M12 15.593a1.198 1.198 0 1 1 0 2.396 1.198 1.198 0 0 1 0-2.396",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1I = createSvgIcon(Icon$1I(), "IotAnalytics");
function IotAnalytics({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1I,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const IotAnalytics$1 = forwardRef(IotAnalytics);
const Icon$1H = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "m10 10.59 2.12-2.12 1.41 1.41L11.41 12l2.12 2.12-1.41 1.41L10 13.41l-2.12 2.12-1.41-1.41L8.59 12 6.46 9.88l1.41-1.41z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M16 5c.67 0 1.27.33 1.63.84L22 12l-4.37 6.16c-.36.51-.96.84-1.63.84l-11-.01c-1.1 0-2-.89-2-1.99V7c0-1.1.9-1.99 2-1.99zM5 17h11l3.55-5L16 7H5z",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$1H = createSvgIcon(Icon$1H(), "LabelDeprecated");
function LabelDeprecated({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1H,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const LabelDeprecated$1 = forwardRef(LabelDeprecated);
const Icon$1G = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m11.4 2.2-8 6a1 1 0 0 0 0 1.6l2.267 1.7L3.4 13.2a1 1 0 0 0 0 1.6l8 6a1 1 0 0 0 1.2 0l8-6a1 1 0 0 0 0-1.6l-2.267-1.7L20.6 9.8a1 1 0 0 0 0-1.6l-8-6a1 1 0 0 0-1.2 0m5.267 10.55L12.6 15.8a1 1 0 0 1-1.2 0l-4.067-3.05-1.667 1.249L12 18.75l6.333-4.751zM12 4.25l6.333 4.749L12 13.75 5.666 8.999z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1G = createSvgIcon(Icon$1G(), "Layers");
function Layers({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1G,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Layers$1 = forwardRef(Layers);
const Icon$1F = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.2 3H4.8C3.81 3 3 3.81 3 4.8v14.4c0 .99.81 1.8 1.8 1.8h14.4c.99 0 1.8-.81 1.8-1.8V4.8c0-.99-.81-1.8-1.8-1.8M8.4 18.3H5.7v-8.1h2.7zM7.05 8.67c-.9 0-1.62-.72-1.62-1.62s.72-1.62 1.62-1.62 1.62.72 1.62 1.62-.72 1.62-1.62 1.62M18.3 18.3h-2.7v-4.77c0-.72-.63-1.35-1.35-1.35s-1.35.63-1.35 1.35v4.77h-2.7v-8.1h2.7v1.08c.45-.72 1.44-1.26 2.25-1.26 1.71 0 3.15 1.44 3.15 3.15z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1F = createSvgIcon(Icon$1F(), "Linkedin");
function Linkedin({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1F,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Linkedin$1 = forwardRef(Linkedin);
const Icon$1E = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 11H1v2h6zm6-10h-2v6h2zm4 10v2h6v-2zm-5-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3m-1 14h2v-6h-2z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1E = createSvgIcon(Icon$1E(), "MapCoordinates");
function MapCoordinates({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1E,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const MapCoordinates$1 = forwardRef(MapCoordinates);
const Icon$1D = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M17 7.976C17 6.333 15.657 5 14 5s-3 1.333-3 2.976c0 1.012.617 2.33 1.29 3.468l.255.418.127.2.25.382.24.35.221.314.286.39.331.43.331-.43.286-.39.221-.314.301-.443.316-.49.254-.417C16.384 10.306 17 8.988 17 7.976m-4.5 0c0-.821.672-1.488 1.5-1.488s1.5.667 1.5 1.488c0 .822-.672 1.488-1.5 1.488s-1.5-.666-1.5-1.488",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M23 15q0 .824-.587 1.413A1.93 1.93 0 0 1 21 17H7q-.824 0-1.412-.587A1.93 1.93 0 0 1 5 15V4q0-.824.588-1.412A1.93 1.93 0 0 1 7 2h14q.824 0 1.413.587Q23 3.176 23 4zm-2 0V4H7v11z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M1.588 20.413Q2.175 21 3 21h17v-2H3V6H1v13q0 .824.587 1.413"
    }
  )
] });
const BaseSvgIcon$1D = createSvgIcon(Icon$1D(), "MapCopy");
function MapCopy({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1D,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const MapCopy$1 = forwardRef(MapCopy);
const Icon$1C = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 16h16v2H4zm2 4h12v2H6zM20 2H4c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2m0 10H4V4h16z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1C = createSvgIcon(Icon$1C(), "MapOthers");
function MapOthers({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1C,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const MapOthers$1 = forwardRef(MapOthers);
const Icon$1B = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2a5 5 0 0 1 1.001 9.9L13 22h-2V11.9A5.002 5.002 0 0 1 12 2m0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1B = createSvgIcon(Icon$1B(), "MapPin");
function MapPin({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1B,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const MapPin$1 = forwardRef(MapPin);
const Icon$1A = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M13.946 4c-.606 0-1.191.089-1.743.255a10.1 10.1 0 0 0-3.68-.155 8.054 8.054 0 0 1 13.207 8.033h-2.096A6.054 6.054 0 0 0 13.946 4"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M9.946 6a8.06 8.06 0 0 1 7.824 6.133h-2.081a6.054 6.054 0 1 0-11.08 4.782l.196.364-.818 2.738 2.748-.813.362.193c.848.454 1.817.711 2.849.711.721 0 1.413-.126 2.054-.357v2.093a8 8 0 0 1-2.054.264 8 8 0 0 1-3.415-.758l-5.518 1.633 1.644-5.5A8.054 8.054 0 0 1 9.947 6"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "m23 16.34-1.41-1.41-4.24 4.24-2.12-2.12-1.41 1.41L17.34 22z"
    }
  )
] });
const BaseSvgIcon$1A = createSvgIcon(Icon$1A(), "MarkCommentRead");
function MarkCommentRead({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1A,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const MarkCommentRead$1 = forwardRef(MarkCommentRead);
const Icon$1z = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2a1 1 0 0 1 .707.293l9 9A1 1 0 0 1 21 13h-2v3h-2v-4a1 1 0 0 1 1-1h.586L12 4.414 5.414 11H6a1 1 0 0 1 1 1v8h6v2H6a1 1 0 0 1-1-1v-8H3a1 1 0 0 1-.707-1.707l9-9A1 1 0 0 1 12 2m0 9c2.206 0 4 1.794 4 4-.003.712-.2 1.41-.567 2.02L18.414 20 17 21.414l-2.98-2.98A3.96 3.96 0 0 1 12 19c-2.206 0-4-1.794-4-4s1.794-4 4-4m0 2c-1.103 0-2 .896-2 2 0 1.103.897 2 2 2s2-.897 2-2c0-1.104-.897-2-2-2",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1z = createSvgIcon(Icon$1z(), "MarketAnalysis");
function MarketAnalysis({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1z,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const MarketAnalysis$1 = forwardRef(MarketAnalysis);
const Icon$1y = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M8.5 9H4c-.55 0-1 .45-1 1v5h1.5v-4.5h1v3H7v-3h1V15h1.5v-5c0-.55-.45-1-1-1"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m10.25 15 1.5-6h2.5l1.5 6h-1.5l-.37-1.5h-1.75l-.38 1.5zm2.5-4-.25 1h1l-.25-1z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M18.906 10.543 19.866 9h1.817l-1.87 3 1.87 3h-1.817l-.96-1.542-.96 1.542h-1.818l1.87-3-1.87-3h1.818z"
    }
  )
] });
const BaseSvgIcon$1y = createSvgIcon(Icon$1y(), "Max");
function Max({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1y,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Max$1 = forwardRef(Max);
const Icon$1x = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M11.293 15.879a1 1 0 0 1 1.414 0l1.414 1.414a1 1 0 0 1 0 1.414l-1.414 1.414a1 1 0 0 1-1.414 0l-1.414-1.414a1 1 0 0 1 0-1.414z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M7 16a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm-2 .75a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h2a.25.25 0 0 0 .25-.25v-2a.25.25 0 0 0-.25-.25zM19 16a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm-2 .75a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h2a.25.25 0 0 0 .25-.25v-2a.25.25 0 0 0-.25-.25zM7 10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm-2 .75a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h2a.25.25 0 0 0 .25-.25v-2a.25.25 0 0 0-.25-.25z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M13 10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M19 10a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm-2 .75a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h2a.25.25 0 0 0 .25-.25v-2a.25.25 0 0 0-.25-.25z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M7 4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zM13 4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zM19 4a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z"
    }
  )
] });
const BaseSvgIcon$1x = createSvgIcon(Icon$1x(), "McpTool");
function McpTool({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1x,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const McpTool$1 = forwardRef(McpTool);
const Icon$1w = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    d: "M4 18q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 16V8q0-.824.587-1.412A1.93 1.93 0 0 1 4 6h16q.824 0 1.413.588Q22 7.175 22 8v8q0 .824-.587 1.413A1.93 1.93 0 0 1 20 18zm0-2h16V8h-3v4h-2V8h-2v4h-2V8H9v4H7V8H4z"
  }
) });
const BaseSvgIcon$1w = createSvgIcon(Icon$1w(), "MeasureTool");
function MeasureTool({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1w,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const MeasureTool$1 = forwardRef(MeasureTool);
const Icon$1v = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    d: "M5 9h4.5c.55 0 1 .45 1 1v5H9v-4.5H8v3H6.5v-3h-1V15H4v-5c0-.55.45-1 1-1M12 15h1.5V9H12zM18.75 9v3.5L16.25 9H15v6h1.25v-3.5L18.8 15H20V9z"
  }
) });
const BaseSvgIcon$1v = createSvgIcon(Icon$1v(), "Min");
function Min({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1v,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Min$1 = forwardRef(Min);
const Icon$1u = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M15.726 4.03a.89.89 0 0 0-.815-.53H7.82l-.118.008a.88.88 0 0 0-.736.633L2.533 19.89l-.024.113a.87.87 0 0 0 .172.651c.167.217.429.345.705.345H15.48v-2H4.925L8.458 5.508H10.5v2.448h2V5.508h1.813L16 12l1.979-.495-2.213-7.365z"
    }
  ),
  /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M12.5 18.5V15h-2v3.5zM12.5 13V9.5h-2V13z" }),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M19.77 13.12c1.855 0 3.36 1.493 3.36 3.333 0 1.134-.69 2.61-1.446 3.884l-.285.468-.353.548-.337.497-.248.351-.32.437-.371.482-.371-.482-.32-.437-.248-.351-.268-.393-.28-.427-.143-.225-.285-.468c-.755-1.274-1.445-2.75-1.445-3.884 0-1.84 1.504-3.333 3.36-3.333m0 1.667c-.927 0-1.68.746-1.68 1.666s.753 1.667 1.68 1.667 1.68-.747 1.68-1.667-.753-1.666-1.68-1.666",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$1u = createSvgIcon(Icon$1u(), "MobilityPlanning");
function MobilityPlanning({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1u,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const MobilityPlanning$1 = forwardRef(MobilityPlanning);
const Icon$1t = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12.007 5.999c1.907 0 3.657.877 4.802 2.403l-1.6 1.199a3.97 3.97 0 0 0-3.202-1.602 3.97 3.97 0 0 0-3.2 1.602L7.207 8.4a6.03 6.03 0 0 1 4.8-2.401m0-4a10 10 0 0 1 7.64 3.548L18.12 6.838a8 8 0 0 0-6.113-2.839 8 8 0 0 0-6.124 2.852L4.354 5.562a9.99 9.99 0 0 1 7.653-3.563m.994 14c2.757 0 5 2.243 5 5v2h-12v-2c0-2.757 2.243-5 5-5zm-8.705 3a7 7 0 0 0-.295 2v2h-4v-1c0-1.653 1.346-3 3-3zm16.705 0c1.654 0 3 1.346 3 3v1h-4v-2c0-.694-.106-1.364-.295-2zm-8-1h-2c-1.654 0-3 1.346-3 3h8c0-1.653-1.346-3-3-3m6.092-5a2.494 2.494 0 0 1 .213 4.979 7.04 7.04 0 0 0-2.665-2.947A2.5 2.5 0 0 1 19.093 13m-14 0c1.185 0 2.173.828 2.43 1.934a7.03 7.03 0 0 0-2.818 3.028 2.495 2.495 0 0 1 .388-4.962m6.908-3c1.654 0 3 1.347 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3m0 2a1.001 1.001 0 1 0 1 1c0-.55-.449-1-1-1",
      clipRule: "evenodd"
    }
  ) }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M0 0h24v24H0z" }) }) })
] });
const BaseSvgIcon$1t = createSvgIcon(Icon$1t(), "NetworkDeployment");
function NetworkDeployment({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1t,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const NetworkDeployment$1 = forwardRef(NetworkDeployment);
const Icon$1s = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M20 17.494q.18 0 .357-.006A9.99 9.99 0 0 1 12 21.994a10 10 0 0 1-3.27-.547 4 4 0 0 0 .224-2.054c.939.387 1.967.6 3.046.6a7.96 7.96 0 0 0 4.12-1.14C11.397 17.24 8 12.763 8 7.493c0-.886.096-1.75.279-2.583a8 8 0 0 0-4.277 7.249 3.2 3.2 0 0 0-1.85 1.58Q2 12.888 2 11.994C2 6.59 6.285 2.188 11.643 2a10 10 0 0 0-1.06 2.119A10 10 0 0 0 10 7.494c0 4.836 3.432 8.87 7.994 9.798.648.132 1.319.202 2.006.202"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M6.2 18.4v-3.2c0-.664-.536-1.2-1.2-1.2s-1.2.536-1.2 1.2v3.2a2 2 0 1 0 2.4 0"
    }
  )
] });
const BaseSvgIcon$1s = createSvgIcon(Icon$1s(), "NightsThermostat");
function NightsThermostat({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1s,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const NightsThermostat$1 = forwardRef(NightsThermostat);
const Icon$1r = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M17.629 14H20v-4h-4v2.371zM11.629 8H14V4h-4v2.372zM2 4.028l1.414-1.414 17.678 17.678-1.414 1.414L17.97 20H16v-1.971l-2-2V20h-4v-4h3.972l-2-2H10v-1.972l-2-2V14H4v-4h3.972l-2-2H4V6.028z"
    }
  ),
  /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M8 20H4v-4h4zM16 4v4h4V4z" })
] });
const BaseSvgIcon$1r = createSvgIcon(Icon$1r(), "NoApp");
function NoApp({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1r,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const NoApp$1 = forwardRef(NoApp);
const Icon$1q = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m21.707 20.294-1.414 1.414-3.817-3.818L12.6 20.8a1 1 0 0 1-1.2 0l-8-6a1 1 0 0 1 0-1.6l2.266-1.7-2.267-1.7a1 1 0 0 1 0-1.6l1.934-1.452-3.04-3.04 1.414-1.414zM5.666 14 12 18.75l3.048-2.288-1.429-1.428-1.02.766a1 1 0 0 1-1.2 0l-4.067-3.05zm0-5L12 13.75l.191-.144-5.43-5.43z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M11.4 2.2a1 1 0 0 1 1.2 0l8 6a1 1 0 0 1 0 1.6l-2.267 1.7 2.267 1.7a1 1 0 0 1 0 1.6l-.891.666-4.285-4.285L18.333 9 12 4.25 9.995 5.754l-1.429-1.43z"
    }
  )
] });
const BaseSvgIcon$1q = createSvgIcon(Icon$1q(), "NoLayer");
function NoLayer({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1q,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const NoLayer$1 = forwardRef(NoLayer);
const Icon$1p = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M3.515 2.1 2.1 3.516l1.353 1.353-.094.032c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 3.43-1.155 2.055 2.055 1.415-1.415zM16.85 18.265l-.85-.85v1.136zM14 15.414l-4-4v5.716l4 1.4zm-6-6L5.034 6.45 5 6.46v11.85l3-1.16z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M14 6.87v2.942l2 2V6.86l3-1.16v9.112l2 2V3.5c0-.28-.22-.5-.5-.5l-.16.03L15 5.1 9 3l-1.355.457L10 5.812V5.47z"
    }
  )
] });
const BaseSvgIcon$1p = createSvgIcon(Icon$1p(), "NoMap");
function NoMap({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1p,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const NoMap$1 = forwardRef(NoMap);
const Icon$1o = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m19.678 21.706-.98-.98A10.95 10.95 0 0 1 12 23c-1.578 0-3.08-.332-4.436-.931a4 4 0 0 0 1.187-1.676A8.9 8.9 0 0 0 12 21a8.96 8.96 0 0 0 5.268-1.702l-1.437-1.438a6.96 6.96 0 0 1-3.59 1.136L12 19A7 7 0 0 1 6.14 8.169L4.703 6.732A8.96 8.96 0 0 0 3 12c0 1.873.572 3.612 1.551 5.052Q4.769 17 5 17a2 2 0 1 1-1.92 1.437l.154.209A10.95 10.95 0 0 1 1 12c0-2.52.848-4.843 2.274-6.698L2 4.028l1.414-1.414 17.678 17.678zM19 3a2 2 0 0 1 1.92 2.563l-.154-.209A10.95 10.95 0 0 1 23 12c0 2.108-.593 4.077-1.621 5.75l-1.463-1.464A8.96 8.96 0 0 0 21 12a8.96 8.96 0 0 0-1.55-5.052A2 2 0 1 1 19 3m-6.28 11.75-1.68-1.681-.005-.068c.086 1.231.33 2.34.682 3.16q.116.27.231.468l.051.084.053-.084q.076-.132.154-.296l.077-.171a8 8 0 0 0 .437-1.412m-3.69-1.749H7.1a5 5 0 0 0 2.576 3.427l-.057-.168c-.306-.93-.514-2.044-.589-3.259M12 5a7 7 0 0 1 6.421 9.792L16.85 13.22q.027-.108.05-.219h-.27l-3.957-3.959a7.6 7.6 0 0 0-.39-1.204 4 4 0 0 0-.231-.467L12 7.286l-.052.085a4 4 0 0 0-.231.467l-.072.178-2.437-2.437A7 7 0 0 1 12 5m2.324 2.572.057.168c.306.93.514 2.045.589 3.26h1.93a5 5 0 0 0-2.576-3.428M7.598 9.628c-.23.424-.4.885-.498 1.372l1.87-.001zM12 1c1.579 0 3.08.333 4.436.931a4 4 0 0 0-1.187 1.675A8.9 8.9 0 0 0 12 3a8.96 8.96 0 0 0-4.287 1.085L6.249 2.62A10.95 10.95 0 0 1 12 1",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1o = createSvgIcon(Icon$1o(), "NoSpatialExtension");
function NoSpatialExtension({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1o,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const NoSpatialExtension$1 = forwardRef(NoSpatialExtension);
const Icon$1n = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M3.414 2.614 2 4.028l5.623 5.624a1 1 0 0 0-.737.204l-4.501 3.511a1 1 0 0 0 .009 1.584l9 6.858-9.01-8.442 9.01 8.443a1 1 0 0 0 1.214-.001l4.07-3.102 3 2.999 1.414-1.414zM12 15.33l2.862 2.18L12 19.745 9.137 17.51zm-1.65-1.257-2.905 2.213-2.808-2.139 2.87-2.24z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "m8.351 4.723 1.427 1.426L12 4.457l2.85 2.17-2.607 1.987 1.427 1.428 3.436-2.619a1 1 0 0 0 0-1.59l-4.5-3.429a1 1 0 0 0-1.212 0zM14.523 10.894l1.426 1.426.544-.414 2.869 2.24-.901.687 1.428 1.427 1.717-1.309a1 1 0 0 0 .01-1.584l-4.5-3.511a1 1 0 0 0-1.221-.007z"
    }
  )
] });
const BaseSvgIcon$1n = createSvgIcon(Icon$1n(), "NoTileset");
function NoTileset({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1n,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const NoTileset$1 = forwardRef(NoTileset);
const Icon$1m = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    d: "M2.614 2.476 1.2 3.891 4.31 7H4v3h3.31l4 4H4v3h10.31l4.568 4.568 1.414-1.414zM16.938 14l3 3H20v-3zM9.938 7l3 3H20V7z"
  }
) });
const BaseSvgIcon$1m = createSvgIcon(Icon$1m(), "NotEqual");
function NotEqual({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1m,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const NotEqual$1 = forwardRef(NotEqual);
const Icon$1l = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m11.299 9 .201-2h-2l-.201 2H7.6l-.2 2h1.699l-.2 2H7.6l-.2 2h1.299L8.5 17h2l.199-2h2l-.199 2h2l.199-2H16.4l.2-2h-1.701l.2-2H16.4l.2-2h-1.301l.201-2h-2l-.201 2zm-.2 2h2l-.2 2h-2z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m0 16H5V5h14z",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$1l = createSvgIcon(Icon$1l(), "Number");
function Number({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1l,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Number$1 = forwardRef(Number);
const Icon$1k = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m10-8a8 8 0 0 0-6.32 12.906L12.586 10H9V8h7v7h-2v-3.586L7.094 18.32A8 8 0 1 0 12 4",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1k = createSvgIcon(Icon$1k(), "Onboarding");
function Onboarding({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1k,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Onboarding$1 = forwardRef(Onboarding);
const Icon$1j = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.25 14.478c3.535 0 6.041 3.52 6.146 3.671a.57.57 0 0 1 0 .658c-.105.15-2.61 3.67-6.146 3.67s-6.041-3.52-6.146-3.67a.57.57 0 0 1 0-.658c.105-.15 2.61-3.672 6.146-3.672m0 1.142c-2.375 0-4.29 2.042-4.96 2.857.67.815 2.593 2.858 4.96 2.858 2.375 0 4.29-2.041 4.96-2.857-.67-.814-2.593-2.858-4.96-2.858m0 .572a2.28 2.28 0 0 1 2.273 2.285c0 1.261-1.02 2.286-2.273 2.286a2.28 2.28 0 0 1-2.273-2.286c0-1.26 1.02-2.285 2.273-2.285m0 1.143c-.627 0-1.136.513-1.136 1.142 0 .63.51 1.143 1.136 1.143a1.14 1.14 0 0 0 1.136-1.143c0-.63-.51-1.142-1.136-1.142M18.04 1.5c.83 0 1.955 1.13 1.955 1.99v5.454c0 .86-1.124 2.027-1.956 2.027H11.5v4.985H9.126V10.97H2.96c-.831 0-1.96-.699-1.96-1.558V3.49C1 2.63 2.129 1.5 2.96 1.5zm0 1.99H2.96v5.454h15.08z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1j = createSvgIcon(Icon$1j(), "OohAnalytics");
function OohAnalytics({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1j,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const OohAnalytics$1 = forwardRef(OohAnalytics);
const Icon$1i = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M13.125 13.125h-2.25v-2.25h2.25z" }),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M13.125 15.375h2.25v-2.25h2.25v-2.25h-2.25v-2.25h2.25v-2.25h-2.25v2.25h-2.25v-2.25h-2.25v2.25h-2.25v-2.25h-2.25v2.25h2.25v2.25h-2.25v2.25h2.25v2.25h-2.25v2.25h2.25v-2.25h2.25v2.25h2.25zm2.25 0h2.25v2.25h-2.25zm-2.25-2.25h2.25v-2.25h-2.25v-2.25h-2.25v2.25h-2.25v2.25h2.25v2.25h2.25z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-1.375 16v-1.375H19v-2.25h-1.375v-2.25H19v-2.25h-1.375v-2.25H19v-2.25h-1.375V5h-2.25v1.375h-2.25V5h-2.25v1.375h-2.25V5h-2.25v1.375H5v2.25h1.375v2.25H5v2.25h1.375v2.25H5v2.25h1.375V19h2.25v-1.375h2.25V19h2.25v-1.375h2.25V19z",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$1i = createSvgIcon(Icon$1i(), "Opacity");
function Opacity({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1i,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Opacity$1 = forwardRef(Opacity);
const Icon$1h = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m14.121 12.707 2.877 2.877V13H19v6l-6-.007v-1.994l2.584-.001-2.877-2.877zM5 5l6 .007v1.994H8.415l2.878 2.878-1.414 1.414L7 8.415V11H5z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1h = createSvgIcon(Icon$1h(), "OpenDiagonallyLeft");
function OpenDiagonallyLeft({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1h,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const OpenDiagonallyLeft$1 = forwardRef(OpenDiagonallyLeft);
const Icon$1g = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    d: "M7 7V5H4q-.824 0-1.412.588A1.93 1.93 0 0 0 2 7v12q0 .824.587 1.413Q3.176 21 4 21h14q.824 0 1.413-.587Q20 19.825 20 19v-3h-2v3H4V7zm4-4q-.825 0-1.412.587A1.93 1.93 0 0 0 9 5v7q0 .825.588 1.412Q10.175 14 11 14h9q.824 0 1.413-.588Q22 12.826 22 12V5q0-.824-.587-1.412A1.93 1.93 0 0 0 20 3zm0 2h9v7h-9z"
  }
) });
const BaseSvgIcon$1g = createSvgIcon(Icon$1g(), "OpenNewWindow");
function OpenNewWindow({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1g,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const OpenNewWindow$1 = forwardRef(OpenNewWindow);
const Icon$1f = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13 14v4.17L15.17 16l1.42 1.41L12 22l-4.58-4.59L8.83 16 11 18.17V14zM12 2l4.58 4.59L15.17 8 13 5.83V10h-2V5.83L8.83 8 7.41 6.59z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1f = createSvgIcon(Icon$1f(), "OpenVertically");
function OpenVertically({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1f,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const OpenVertically$1 = forwardRef(OpenVertically);
const Icon$1e = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M4 7v2c0 .55-.45 1-1 1H2v4h1c.55 0 1 .45 1 1v2c0 1.65 1.35 3 3 3h3v-2H7c-.55 0-1-.45-1-1v-2c0-1.3-.84-2.42-2-2.83v-.34C5.16 11.42 6 10.3 6 9V7c0-.55.45-1 1-1h3V4H7C5.35 4 4 5.35 4 7"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m22.69 18.37 1.14-1-1-1.73-1.45.49q-.48-.405-1.08-.63L20 14h-2l-.3 1.49q-.6.225-1.08.63l-1.45-.49-1 1.73 1.14 1c-.08.5-.08.76 0 1.26l-1.14 1 1 1.73 1.45-.49q.48.405 1.08.63L18 24h2l.3-1.49q.6-.225 1.08-.63l1.45.49 1-1.73-1.14-1c.08-.51.08-.77 0-1.27M19 21c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M21 10c-.55 0-1-.45-1-1V7c0-1.65-1.35-3-3-3h-3v2h3c.55 0 1 .45 1 1v2c0 1.3.84 2.42 2 2.83V12h2v-2z"
    }
  )
] });
const BaseSvgIcon$1e = createSvgIcon(Icon$1e(), "ParameterSettings");
function ParameterSettings({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1e,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const ParameterSettings$1 = forwardRef(ParameterSettings);
const Icon$1d = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m8.515 20 .11-.676C8.715 18.791 9.789 18 11.094 18h1.974c1.304 0 2.379.791 2.467 1.324l.11.676zM11 10h2v6h-2zm1-6a1 1 0 1 1-.001 2 1 1 0 0 1 0-2m6 16h-.33l-.163-1c-.137-.833-.716-1.588-1.534-2.133A.99.99 0 0 0 15 16v-6c.55 0 1-.45 1-1s-.45-1-1-1h-2c0-.069.027-.131.04-.196A2.993 2.993 0 0 0 12 2a2.993 2.993 0 0 0-1.04 5.804c.014.065.04.127.04.196H9c-.55 0-1 .45-1 1s.45 1 1 1v6c-.55 0-1 .45-1 1l.002.008c-.715.531-1.223 1.226-1.35 1.992l-.164 1H6c-.55 0-1 .45-1 1s.45 1 1 1h12c.55 0 1-.45 1-1s-.45-1-1-1",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1d = createSvgIcon(Icon$1d(), "PawnChess");
function PawnChess({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1d,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const PawnChess$1 = forwardRef(PawnChess);
const Icon$1c = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2c4.143 0 7.898 3.134 7.998 8h-2.001v-.04C17.881 6.457 15.275 4 12 4c-3.35 0-6 2.57-6 6.2 0 2.34 1.95 5.44 6 9.14h2.883A47 47 0 0 1 12 22c-5.33-4.55-8-8.48-8-11.8C4 5.22 7.8 2 12 2m8 10-2.29 2.3L20 16.59 18.59 18l-2.3-2.29L14 18v-6zm-8-5c1.652 0 3 1.348 3 3h-1c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2v1c-1.652 0-3-1.348-3-3s1.348-3 3-3",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1c = createSvgIcon(Icon$1c(), "PlaceSelect");
function PlaceSelect({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1c,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const PlaceSelect$1 = forwardRef(PlaceSelect);
const Icon$1b = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.773 13.117c1.855 0 3.36 1.495 3.36 3.34 0 1.135-.691 2.613-1.446 3.89l-.285.469-.284.443-.138.21-.268.393-.249.353-.32.436-.37.484-.372-.484-.32-.436-.247-.353-.268-.393-.28-.428-.143-.225-.285-.469c-.755-1.277-1.445-2.755-1.445-3.89 0-1.844 1.504-3.34 3.36-3.34M11.25 3.5c4.354 0 8.03 3.172 8.656 7.422l.035.261-1.738.2c-.365-3.125-2.787-5.56-5.83-6.048l-.248-.035v3.417h2.625v5.653l-4.821 3.594-1.935-5.768H6V7.61a6.9 6.9 0 0 0-1.75 4.586c0 3.835 3.14 6.956 7 6.956a7 7 0 0 0 2.697-.534l.317-.141.755 1.568a8.7 8.7 0 0 1-3.769.846c-4.825 0-8.75-3.9-8.75-8.695S6.425 3.5 11.25 3.5m8.523 11.287c-.928 0-1.68.748-1.68 1.67s.752 1.67 1.68 1.67 1.68-.749 1.68-1.67c0-.922-.753-1.67-1.68-1.67M10.375 5.3a7 7 0 0 0-2.324.717l-.301.164v4.276h1.506l1.565 4.666L13 13.5v-3.043h-2.625z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1b = createSvgIcon(Icon$1b(), "PointsOfInterest");
function PointsOfInterest({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1b,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const PointsOfInterest$1 = forwardRef(PointsOfInterest);
const Icon$1a = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M18.836 8.773a15.5 15.5 0 0 1-1.516 3.673q.05-.171.08-.352l.034-.332.005-.16-.003-.164-.023-.328-.033-.297-.06-.502-.016-.195-.004-.194.01-.244.02-.182.04-.287.046-.289c.047-.317.06-.545.046-.8a.3.3 0 0 0-.023-.103 1 1 0 0 0-.025-.133 3 3 0 0 0-.102-.32l-.047-.122-.152-.337a6.3 6.3 0 0 0-.707-1.12 5.5 5.5 0 0 0-1.831-1.53q.458-.071.92-.076c1.455-.013 2.618.484 3.44 1.525.224.283.26 1.043.084 2.036l-.057.297q-.055.261-.127.536M8.55 14.847l-.033.029q.164-.19.334-.38l.55-.602.087-.093q.363.18.781.224l-.197.237-.048.05a.65.65 0 0 1-.255.138l-.03.01-.157.045-.514.116c-.232.058-.4.131-.518.226M8.093 11.487a2.62 2.62 0 0 0 .83 1.925l-.236.252q-.352.382-.686.769l-.407.472c-.315.332-.56.333-.89.016a2 2 0 0 1-.2-.223l-.126-.175-.14-.221-.127-.227-.179-.358-.176-.402-.188-.477a22 22 0 0 1-.725-2.418l-.152-.662-.122-.597L4.5 8.79l-.06-.392-.033-.308-.002-.05c-.058-1.259.204-2.158.762-2.719.448-.449 1.095-.686 1.931-.716.623-.023 1.319.07 2.054.266q.165.045.32.092c-.371.394-.666.888-.886 1.473a6.8 6.8 0 0 0-.377 1.597q-.034.289-.046.56l-.004.257-.001.032v.038l.023.429.013.323c.014.523-.01.975-.075 1.442l-.021.208z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M8.88 8.192c.268-.133.564-.241.846-.305.447-.103.843-.095 1.173.03.425.163.708.514.819 1.02.18.827.235 1.525.17 2.133a3.9 3.9 0 0 1-.234.988l-.103.256-.224.507-.203.558-.023.075a.9.9 0 0 1 .398.086c.34.14.57.483.623.84a.3.3 0 0 1 .016.11l-.014.65-.002 1.013.014.719.019.463.03.489.05.486.026.162q.027.149.056.22l.093.213c.107.225.212.368.356.488.274.229.647.295 1.163.186 1.004-.214 1.35-.563 1.517-1.518l.049-.304.126-.904.13-1.025.085-.74.036-.373q-.04-.911.595-1.192l.07-.03-.198-.253-.113-.157a3 3 0 0 1-.19-.322l-.103-.222-.62-1.146a10 10 0 0 1-.352-.765l-.109-.289-.068-.209-.045-.152c-.174-.64-.16-1.151.064-1.544.29-.513.886-.742 1.774-.693l.074.005-.037-.093a5.5 5.5 0 0 0-.745-1.25c-.928-1.175-2.166-1.815-3.675-1.84-.805-.012-1.46.2-1.978.632-.423.353-.754.85-.99 1.478a6.2 6.2 0 0 0-.339 1.44z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M16.609 12.38q.095-.257.12-.549l.008-.104.004-.18-.012-.25-.082-.735-.03-.277-.014-.232.001-.217.028-.383.098-.658c.02-.136.032-.251.037-.359-.756-.084-1.204.038-1.37.33-.11.195-.123.498-.033.895l.044.176.088.279.018.049q.108.3.27.644l.172.345.172.32.397.73.043.084zm-.57-3.815a1 1 0 0 0-.09.025l-.028.01c-.214.085-.366.253-.35.442.021.255.29.551.53.497s.488-.477.467-.723l-.002-.017c-.03-.21-.262-.295-.528-.234",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "m16.967 14.083-.012-.01-.153.047-.056.021c-.128.057-.188.163-.194.4v.09l.042.015c.123.037.313.057.538.055.468-.005 1-.105 1.302-.244q.157-.073.3-.158l.051-.033-.353.046-.235.017-.24.005-.222-.01a1.7 1.7 0 0 1-.646-.168z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M9.064 8.86c.25-.137.545-.251.815-.313.684-.156 1.058.011 1.172.533q.035.158.062.308l.06.363c.064.468.076.88.036 1.247-.04.383-.126.687-.299 1.08l-.15.337-.08.19-.16.43-.062.18-.041.14-.07-.004c-.966-.088-1.704-1.062-1.552-2.142a9.6 9.6 0 0 0 .065-1.955L8.845 9l.044-.031q.073-.051.175-.107m.96-.02h.022l.003-.005c.08-.15.278-.198.497-.15a1 1 0 0 1 .084.022l.027.01c.216.079.372.245.353.456-.023.26-.292.54-.533.488s-.487-.448-.464-.702z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "m11.12 14.131.033.005.086.03.058.036c.128.103.2.342.124.448-.292.404-.659.635-1.11.711a2.4 2.4 0 0 1-.976-.056l-.094-.028.238-.052.353-.086.235-.076c.214-.083.362-.184.504-.34l.338-.406.065-.076.051-.053a.3.3 0 0 1 .07-.05z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M15.594 3h.056c.794.01 1.54.149 2.226.423.86.345 1.595.894 2.185 1.64.625.79.645 2.212.156 4.086a16.6 16.6 0 0 1-1.288 3.336l-.212.397.372-.067a2 2 0 0 1 .333-.02c.285.01.535.09.755.254.328.247.496.638.457 1.042-.022.223-.1.424-.23.619-.261.39-.77.772-1.363 1.044-.514.237-1.281.379-1.961.374l-.012.294-.026.418-.042.437c-.12 1.04-.362 1.81-.76 2.384l-.141.187a2.75 2.75 0 0 1-.948.74 3.5 3.5 0 0 1-.49.192l-.051.015-.276.074-.245.055c-1.261.268-2.232-.179-2.726-1.204a4 4 0 0 1-.15-.371l-.158-.472-.034-.132-.046-.219-.039-.238-.029-.235-.036-.416-.029-.51-.016-.416-.236.053-.246.035a3.8 3.8 0 0 1-1.337-.108 2.2 2.2 0 0 1-.82-.375l-.035-.03-.04.027c-.716.426-1.529.346-2.216-.217l-.136-.119-.18-.184q-.229-.255-.444-.59l-.131-.216a8 8 0 0 1-.194-.357l-.078-.156-.154-.332-.206-.493-.214-.575a23 23 0 0 1-.39-1.232l-.066-.235-.2-.764-.163-.686-.155-.745L3.1 8.93q-.03-.182-.05-.34l-.03-.29-.009-.125c-.084-1.666.304-2.95 1.168-3.814.718-.718 1.696-1.085 2.885-1.124.769-.026 1.595.086 2.461.318q.24.066.469.138l.117-.062a4.45 4.45 0 0 1 1.799-.441l.286-.005.367.012q.471.023.905.095l.181-.05.28-.066.346-.066A8 8 0 0 1 15.594 3m-1.635.885a7 7 0 0 1 1.53-.183 5.5 5.5 0 0 1 2.023.34 4.5 4.5 0 0 1 1.96 1.444c.915 1.157-.107 5.12-2.04 8.082q.128.057.356.079.294.026.705-.024l.272-.04.277-.051c.31-.063.522-.047.68.071.124.094.186.24.171.394a.6.6 0 0 1-.111.287c-.18.268-.59.571-1.062.788-.393.18-1.017.3-1.58.306a2.8 2.8 0 0 1-.646-.058l-.132 1.122-.119.9-.11.742-.05.272c-.237 1.106-.8 1.628-2.011 1.885-.718.152-1.304.039-1.745-.329-.268-.224-.438-.477-.612-.893l-.02-.049-.04-.107a4 4 0 0 1-.116-.655l-.03-.302-.027-.384-.03-.676-.008-.315-.006-.932a2.3 2.3 0 0 1-1.011.43 3 3 0 0 1-1.257-.066c-.346-.086-.643-.263-.762-.48a.48.48 0 0 1 .023-.507q-.12.137-.234.275c-.606.722-1.328.773-1.968.157a3.2 3.2 0 0 1-.43-.526l-.118-.185-.116-.2-.142-.27-.113-.232-.22-.507-.122-.309-.171-.474a25 25 0 0 1-.708-2.512l-.054-.24-.154-.76-.049-.27-.064-.408-.034-.292-.017-.38q-.033-1.996.966-2.998c.579-.58 1.385-.881 2.392-.917.694-.025 1.454.076 2.254.289q.325.086.62.187l.063.021.07.026c.591-.387 1.302-.578 2.123-.565q.642.011 1.23.151l.168-.058z",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$1a = createSvgIcon(Icon$1a(), "Postgre");
function Postgre({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1a,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Postgre$1 = forwardRef(Postgre);
const Icon$19 = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M16.038 8.565a1 1 0 0 0-.088.025l-.029.01c-.214.085-.366.253-.35.442.021.255.29.551.53.497s.488-.477.467-.723l-.002-.017c-.03-.21-.262-.295-.528-.234M10.024 8.84h.022l.003-.005c.08-.15.278-.198.497-.15a1 1 0 0 1 .084.022l.027.009c.216.08.372.246.353.457-.023.26-.292.54-.533.488s-.487-.448-.464-.702z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M15.49 3.701a7 7 0 0 0-1.531.184l-.356.094-.169.058a5.7 5.7 0 0 0-1.229-.15c-.821-.014-1.532.177-2.123.564l-.07-.026-.063-.021a10 10 0 0 0-.62-.187c-.8-.213-1.56-.314-2.254-.29-1.007.037-1.813.338-2.392.918-.665.666-.99 1.668-.966 2.998l.017.38.034.292.064.408.049.27.154.76.054.24c.205.895.448 1.758.708 2.512l.171.474.122.309.22.507.113.233.142.27.116.199.118.185q.211.315.43.525c.64.617 1.362.566 1.968-.156l.234-.275a.48.48 0 0 0-.023.506c.119.218.416.395.762.48.442.11.85.136 1.257.067a2.3 2.3 0 0 0 1.01-.43l.008.931.007.316.03.676.027.384.03.302q.047.429.117.655l.038.107.02.05c.175.415.345.668.613.892.441.368 1.027.481 1.745.329 1.21-.257 1.774-.78 2.011-1.886l.05-.271.11-.742.119-.9.132-1.122c.18.041.398.06.645.058.564-.006 1.188-.125 1.581-.306.471-.217.882-.52 1.062-.788a.6.6 0 0 0 .111-.287.43.43 0 0 0-.171-.394c-.158-.118-.37-.135-.68-.071l-.277.052-.272.04q-.412.048-.705.022a1.2 1.2 0 0 1-.356-.078c1.933-2.963 2.955-6.925 2.04-8.082a4.5 4.5 0 0 0-1.96-1.444 5.5 5.5 0 0 0-2.023-.34m1.83 8.745a15.5 15.5 0 0 0 1.515-3.673q.072-.274.127-.537l.057-.296c.175-.993.14-1.753-.083-2.036-.823-1.04-1.986-1.539-3.44-1.525q-.463.005-.921.077a5.5 5.5 0 0 1 1.83 1.528 6.3 6.3 0 0 1 .708 1.121l.152.337.047.121q.067.179.102.32.018.075.025.133.02.049.023.104c.015.255 0 .483-.046.8l-.045.288-.042.288-.018.182-.011.244.004.194.017.195.059.502.033.297.023.328.003.164-.005.16-.035.331q-.028.182-.08.353m-8.803 2.43.033-.029c.118-.095.286-.168.518-.226l.514-.116.157-.046.03-.01a.65.65 0 0 0 .255-.138l.048-.049.197-.238a2.3 2.3 0 0 1-.78-.223l-.088.092-.55.603q-.17.19-.334.38m.406-1.465a2.62 2.62 0 0 1-.83-1.924l.006-.165.02-.208c.067-.467.09-.92.076-1.442l-.013-.324-.023-.428v-.038l.001-.032.004-.258q.012-.27.046-.559a6.8 6.8 0 0 1 .377-1.597q.33-.88.887-1.474a9 9 0 0 0-.321-.091c-.735-.196-1.431-.289-2.054-.266-.836.03-1.483.267-1.93.716-.56.56-.82 1.46-.763 2.72l.002.049.033.308.06.392.068.371.122.597.152.661c.214.878.463 1.713.725 2.419l.188.477.176.402.179.358.127.227.14.22.127.175q.1.129.199.224c.33.317.575.316.89-.016l.407-.473q.334-.385.686-.769zm.803-5.525a4 4 0 0 0-.847.306l.008-.08a6.2 6.2 0 0 1 .339-1.44c.236-.628.567-1.125.99-1.477.519-.431 1.173-.644 1.978-.631 1.509.024 2.747.664 3.675 1.838.31.393.569.83.745 1.251l.037.093-.074-.005c-.888-.049-1.483.18-1.774.693-.223.393-.238.903-.064 1.544l.045.152.068.21.11.288q.144.357.35.765l.622 1.146.102.222q.085.164.19.322l.113.157.199.253-.071.03q-.636.281-.595 1.192l-.036.373-.085.74-.13 1.025-.127.904-.048.304c-.166.955-.513 1.304-1.517 1.517-.516.11-.89.044-1.163-.185a1.3 1.3 0 0 1-.356-.488l-.093-.213a1.2 1.2 0 0 1-.056-.22l-.025-.162-.05-.486-.031-.489-.019-.463-.014-.719.002-1.012.014-.65a.3.3 0 0 0-.016-.111c-.052-.357-.284-.7-.623-.84a.9.9 0 0 0-.398-.087l.023-.074.203-.559.224-.507.103-.255a3.9 3.9 0 0 0 .234-.988c.065-.608.01-1.306-.17-2.134-.11-.505-.394-.856-.82-1.019-.329-.126-.725-.133-1.172-.03m7.004 3.945a2 2 0 0 1-.121.549l-.04-.092-.044-.084-.397-.73-.172-.32-.171-.345a7 7 0 0 1-.271-.644l-.018-.05-.088-.278-.044-.176c-.09-.397-.077-.7.033-.895.166-.292.614-.414 1.37-.33a4 4 0 0 1-.037.36l-.098.657-.028.382v.218l.014.232.029.277.082.735.012.25-.004.18zm.225 2.242.012.01.122.073q.261.134.646.167l.221.01.24-.004.236-.017.354-.046-.052.033q-.143.085-.3.158c-.302.139-.834.239-1.302.244a2 2 0 0 1-.538-.056l-.042-.014v-.09c.006-.237.066-.343.194-.4l.056-.021zM9.879 8.548c-.27.061-.565.175-.815.314a2 2 0 0 0-.175.106L8.845 9l.015.255c.04.738.024 1.33-.065 1.955-.152 1.08.586 2.053 1.553 2.142l.069.003.04-.138.062-.18.16-.431.08-.19.151-.336c.173-.395.258-.699.3-1.08.039-.368.027-.78-.038-1.248l-.059-.363a10 10 0 0 0-.062-.308c-.114-.522-.488-.69-1.172-.533m1.274 5.588-.033-.004-.025.007a.3.3 0 0 0-.07.05l-.05.053-.066.076-.338.407c-.142.155-.29.256-.504.339l-.235.076-.353.086-.238.052.094.028c.35.087.67.108.977.056.45-.076.817-.307 1.109-.711.077-.107.004-.346-.124-.449l-.058-.034z",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$19 = createSvgIcon(Icon$19(), "PostgreOutlined");
function PostgreOutlined({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$19,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const PostgreOutlined$1 = forwardRef(PostgreOutlined);
const Icon$18 = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M5.938 5.938A1.45 1.45 0 0 1 7 5.5q.624 0 1.063.438Q8.5 6.374 8.5 7q0 .624-.437 1.063A1.45 1.45 0 0 1 7 8.5q-.625 0-1.062-.437A1.45 1.45 0 0 1 5.5 7q0-.625.438-1.062"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M3 7a4 4 0 0 1 4-4h10a4 4 0 0 1 0 8H7a4 4 0 0 1-4-4m4-2h10a2 2 0 1 1 0 4H7a2 2 0 1 1 0-4",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M17 15.5q-.625 0-1.062.438A1.45 1.45 0 0 0 15.5 17q0 .625.438 1.063.437.437 1.062.437t1.063-.437T18.5 17t-.437-1.062A1.45 1.45 0 0 0 17 15.5"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M3 17a4 4 0 0 1 4-4h10a4 4 0 0 1 0 8H7a4 4 0 0 1-4-4m4-2h10a2 2 0 1 1 0 4H7a2 2 0 1 1 0-4",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$18 = createSvgIcon(Icon$18(), "Preferences");
function Preferences({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$18,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Preferences$1 = forwardRef(Preferences);
const Icon$17 = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19 14v3h3v2h-3v3h-2v-3h-3v-2h3v-3zm.5-11c1.1 0 2 .9 2 2v7h-2v-2h-3v2h-2v-2h-5v9H12v2H4.5c-1.05 0-1.918-.82-1.994-1.851L2.5 19V5c0-1.1.9-2 2-2zm-12 7h-3v9h3zm12-5h-15v3h15z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$17 = createSvgIcon(Icon$17(), "ProcessData");
function ProcessData({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$17,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const ProcessData$1 = forwardRef(ProcessData);
const Icon$16 = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M20 12c0-.34-.04-.67-.08-1h2.03c.03.33.05.66.05 1 0 5.52-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2c1.05 0 2.05.16 3 .46V5c0 1.1-.9 2-2 2h-2v2c0 .55-.45 1-1 1H8v2h6c.55 0 1 .45 1 1v3h1c.9 0 1.64.58 1.9 1.39C19.2 15.97 20 14.08 20 12M4 12c0 4.08 3.05 7.44 7 7.93V18c-1.1 0-2-.9-2-2v-1l-4.79-4.79C4.08 10.79 4 11.38 4 12",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "m23.008 2.875-.991 1.715H24v1.75h-1.983l.991 1.727-1.516.875-.992-1.727-.992 1.727-1.516-.875.991-1.727H17V4.59h1.983l-.991-1.715L19.508 2l.992 1.715L21.492 2z"
    }
  )
] });
const BaseSvgIcon$16 = createSvgIcon(Icon$16(), "PublicWithPassword");
function PublicWithPassword({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$16,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const PublicWithPassword$1 = forwardRef(PublicWithPassword);
const Icon$15 = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    d: "M11 20v-8.15l-2.6 2.6L7 13l5-5 5 5-1.4 1.45-2.6-2.6V20zM4 9V6q0-.824.588-1.412A1.93 1.93 0 0 1 6 4h12q.824 0 1.413.588Q20 5.175 20 6v3h-2V6H6v3z"
  }
) });
const BaseSvgIcon$15 = createSvgIcon(Icon$15(), "Publish");
function Publish({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$15,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Publish$1 = forwardRef(Publish);
const Icon$14 = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 2c1.05 0 1.918.82 1.994 1.851L22 4v16c0 1.05-.82 1.918-1.851 1.994L20 22H4c-1.05 0-1.918-.82-1.994-1.851L2 20V4c0-1.05.82-1.918 1.851-1.994L4 2zm-9 11H4v7h7zm9 0h-7v7h7zm-9-9H4v7h7zm9 0h-7v7h7z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$14 = createSvgIcon(Icon$14(), "Quadbin");
function Quadbin({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$14,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Quadbin$1 = forwardRef(Quadbin);
const Icon$13 = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M20 2c1.05 0 1.918.82 1.994 1.851L22 4v16c0 1.05-.82 1.918-1.851 1.994L20 22H4c-1.05 0-1.918-.82-1.994-1.851L2 20V4c0-1.05.82-1.918 1.851-1.994L4 2zm-9 11H4v7h7zm9 0h-7v7h7zm-3 1a1 1 0 0 1 .993.883L18 15v.75c0 .415-.335.75-.75.75a.75.75 0 0 1 .743.648l.007.102V18a1 1 0 0 1-.884.993L17 19h-2v-1h2v-1h-1v-1h1v-1h-2v-1zM11 4H4v7h7zm9 0h-7v7h7zm-3 1v5h-1V6h-1V5zm-9 9a1 1 0 0 1 .993.883L9 15v1a1 1 0 0 1-.884.993L8 17H7v1h2v1H6v-2a1 1 0 0 1 .884-.993L7 16h1v-1H6v-1z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M6.827 10H8.16a.836.836 0 0 0 .833-.833V5.833A.836.836 0 0 0 8.16 5H6.827a.836.836 0 0 0-.834.833v3.334c0 .458.375.833.834.833m.166-4h1v3h-1z"
    }
  )
] });
const BaseSvgIcon$13 = createSvgIcon(Icon$13(), "Quadkey");
function Quadkey({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$13,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Quadkey$1 = forwardRef(Quadkey);
const Icon$12 = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M17 12a5.005 5.005 0 0 1 5 5c0 .98-.29 1.937-.833 2.753L23.91 22.5 22.5 23.91l-2.747-2.743A4.97 4.97 0 0 1 17 22a5.005 5.005 0 0 1-5-5 5.005 5.005 0 0 1 5-5m2.5-9c1.1 0 2 .9 2 2v6.639a7 7 0 0 0-2-1.179V10h-10v9h.79a7 7 0 0 0 .966 2.001L4.5 21c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2zM17 14c-1.653 0-3 1.347-3 3 0 1.655 1.347 3 3 3s3-1.345 3-3c0-1.653-1.347-3-3-3m-9.5-4h-3v9h3zm12-5h-15v3h15z",
      clipRule: "evenodd"
    }
  ) }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M0 0h24v24H0z" }) }) })
] });
const BaseSvgIcon$12 = createSvgIcon(Icon$12(), "QueryTable");
function QueryTable({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$12,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const QueryTable$1 = forwardRef(QueryTable);
const Icon$11 = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 2c2.97 0 5.45 2.18 5.92 5.02A4.5 4.5 0 0 1 22 11.5c0 2.48-2.02 4.5-4.5 4.5h-10A5.51 5.51 0 0 1 2 10.5c0-2.76 2.09-5.09 4.78-5.44A5.98 5.98 0 0 1 12 2M7.5 14h10a2.5 2.5 0 0 0 2.5-2.5c0-1.28-.99-2.37-2.26-2.49l-1.54-.14-.25-1.52C15.63 5.44 13.94 4 12 4c-1.44 0-2.77.78-3.48 2.04l-.49.87-.99.13A3.51 3.51 0 0 0 4 10.5C4 12.43 5.57 14 7.5 14",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M7.35 17H5.042L1 24h2.31zM9.083 24h-2.31l4.042-7h2.31zM12.547 24h2.31l4.04-7h-2.309z"
    }
  )
] });
const BaseSvgIcon$11 = createSvgIcon(Icon$11(), "Rain");
function Rain({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$11,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Rain$1 = forwardRef(Rain);
const Icon$10 = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    d: "M6.5 21v-3.5H3V21zM7.5 21h4v-3.5h-4zM17.5 21H21v-3.5h-3.5zM21 11.5v-4h-3.5v4zM21 6.5V3h-3.5v3.5zM16.5 3h-4v3.5h4zM11.5 3h-4v3.5h4zM6.5 3H3v3.5h3.5zM3 7.5v4h3.5v-4zM3 12.5v4h3.5v-4zM11.5 16.5h-4v-4h4zM11.5 11.5h-4v-4h4zM12.5 12.5h4v4h-4z"
  }
) });
const BaseSvgIcon$10 = createSvgIcon(Icon$10(), "Raster");
function Raster({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$10,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Raster$1 = forwardRef(Raster);
const Icon$$ = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.47 21v-.007l-2.588-1.297v-1.985l-2.588.74L4 17.795V6.205l1.294-.656 2.588.774v-2.02l2.588-1.296V3h3.56v.008l2.588 1.296-.001 1.855 2.589-.61-.001.006h.006l1.289.65v11.59l-1.294.656-2.589-.611v1.856L14.043 21zM13.53 3.5H10.97v17l2.558-.001zm.588.111v16.79l2-1.012V4.612zm5.088 2.5v11.778l.794-.401V6.512zM5.794 6.22v11.567l2.088-.597V6.845z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$$ = createSvgIcon(Icon$$(), "Redshift");
function Redshift({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$$,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Redshift$1 = forwardRef(Redshift);
const Icon$_ = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m14 2 6 6v12c0 1.05-.82 1.918-1.851 1.994L18 22H6c-1.05 0-1.918-.82-1.994-1.851L4 20V4c0-1.05.82-1.918 1.851-1.994L6 2zm0 2H6v16h12V8h-4zm-4 8v6H8v-6zm3-2v8h-2v-8zm3 4v4h-2v-4z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$_ = createSvgIcon(Icon$_(), "Report");
function Report({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$_,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Report$1 = forwardRef(Report);
const Icon$Z = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.35 6.35A7.96 7.96 0 0 1 12 4c4.42 0 7.99 3.58 7.99 8s-3.57 8-7.99 8c-3.73 0-6.84-2.55-7.73-6h2.08c.82 2.33 3.04 4 5.65 4 3.31 0 6-2.69 6-6s-2.69-6-6-6c-1.66 0-3.14.69-4.22 1.78L11 11H4V4z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$Z = createSvgIcon(Icon$Z(), "Reset");
function Reset({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$Z,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Reset$1 = forwardRef(Reset);
const Icon$Y = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx("g", { clipPath: "url(#a)", children: /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M18.999 12v1.101a5 5 0 0 1 1.751.731l.785-.784 1.414 1.414-.784.784c.348.525.603 1.117.733 1.754H24v2h-1.102a4.9 4.9 0 0 1-.733 1.751l.784.783-1.413 1.415-.784-.783a5 5 0 0 1-1.753.732V24h-2v-1.102a5 5 0 0 1-1.753-.73l-.783.783-1.415-1.413.784-.784A5 5 0 0 1 13.1 19h-1.102v-2H13.1c.13-.636.384-1.229.732-1.753l-.783-.783 1.414-1.414.783.783a5 5 0 0 1 1.753-.732v-1.1zM18 15a3 3 0 1 0 0 6.001 3 3 0 0 0 0-6M10.434.1 20 4.35v.682c-.006.321-.089 2.95-1.14 5.968H11v8.695c-.224.088-.448.175-.684.254l-.316.105-.316-.105C.302 16.82.008 5.579 0 5.02v-.67L9.567.098zM9 11H3.245C4.459 14.084 6.39 16.27 9 17.517zm2-8.461V9h6.407c.37-1.426.51-2.657.562-3.364zm-2 0L2.031 5.636c.051.706.192 1.937.563 3.364H9z",
      clipRule: "evenodd"
    }
  ) }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M0 0h24v24H0z" }) }) })
] });
const BaseSvgIcon$Y = createSvgIcon(Icon$Y(), "RiskAnalysis");
function RiskAnalysis({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$Y,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const RiskAnalysis$1 = forwardRef(RiskAnalysis);
const Icon$X = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M15.726 4.03a.89.89 0 0 0-.815-.53H7.82l-.118.008a.88.88 0 0 0-.736.633L2.533 19.89l-.024.113a.87.87 0 0 0 .172.651c.167.217.429.345.705.345H15.48v-2H4.925L8.458 5.508H10.5v2.448h2V5.508h1.813L16 12l1.979-.495-2.213-7.365z"
    }
  ),
  /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M12.5 18.5V15h-2v3.5zM12.5 13V9.5h-2V13z" }),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M19.77 13.12c1.855 0 3.36 1.493 3.36 3.333 0 1.134-.69 2.61-1.446 3.884l-.285.468-.353.548-.337.497-.248.351-.32.437-.371.482-.371-.482-.32-.437-.248-.351-.268-.393-.28-.427-.143-.225-.285-.468c-.755-1.274-1.445-2.75-1.445-3.884 0-1.84 1.504-3.333 3.36-3.333m0 1.667c-.927 0-1.68.746-1.68 1.666s.753 1.667 1.68 1.667 1.68-.747 1.68-1.667-.753-1.666-1.68-1.666",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$X = createSvgIcon(Icon$X(), "RoadTraffic");
function RoadTraffic({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$X,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const RoadTraffic$1 = forwardRef(RoadTraffic);
const Icon$W = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M1 12C1 6.48 5.48 2 11 2c5.183 0 9.448 3.949 9.95 9h-2.012C18.444 7.06 15.07 4 11 4c-4.41 0-8 3.59-8 8s3.59 8 8 8q.508 0 1-.062v2.013Q11.507 22 11 22C5.48 22 1 17.52 1 12"
    }
  ),
  /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "m9 8 6 4-6 4z" }),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m23.83 16.37-1.14 1c.08.5.08.76 0 1.27l1.14 1-1 1.73-1.45-.49q-.48.405-1.08.63L20 23h-2l-.3-1.51q-.6-.225-1.08-.63l-1.45.49-1-1.73 1.14-1c-.08-.5-.08-.76 0-1.26l-1.14-1 1-1.73 1.45.49q.48-.405 1.08-.63L18 13h2l.3 1.5q.6.225 1.08.63l1.45-.49zM17 18c0 1.1.9 2 2 2s2-.9 2-2-.9-2-2-2-2 .9-2 2",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$W = createSvgIcon(Icon$W(), "RunSettings");
function RunSettings({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$W,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const RunSettings$1 = forwardRef(RunSettings);
const Icon$V = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 16h2v4h-2zm0-12h2v4h-2zm0 6h2v4h-2zM6 16.5l6-4.5-6-4.5z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$V = createSvgIcon(Icon$V(), "RunStep");
function RunStep({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$V,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const RunStep$1 = forwardRef(RunStep);
const Icon$U = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.486 16.108c2.733 0 4.946-2.222 4.946-4.971 0-2.741-2.213-4.971-4.946-4.971-.705 0-1.386.152-1.996.423a4.04 4.04 0 0 0-3.534-2.093 4.03 4.03 0 0 0-2.91 1.246A4.48 4.48 0 0 0 6.503 4c-2.46 0-4.456 1.982-4.456 4.428 0 .63.136 1.222.369 1.766A3.85 3.85 0 0 0 .5 13.534c0 2.134 1.715 3.86 3.831 3.853.265 0 .53-.024.786-.08A4.125 4.125 0 0 0 8.988 20c1.7 0 3.166-1.031 3.791-2.501.473.231 1.01.36 1.58.36a3.61 3.61 0 0 0 3.15-1.847c.32.064.64.096.977.096m2.597-4.624q.004-.062 0-.151z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$U = createSvgIcon(Icon$U(), "Salesforce");
function Salesforce({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$U,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Salesforce$1 = forwardRef(Salesforce);
const Icon$T = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.99 2C17.52 2 22 6.48 22 12s-4.48 10-10.01 10C6.47 22 2 17.52 2 12S6.47 2 11.99 2M12 4c-4.42 0-8 3.58-8 8a8 8 0 0 0 7.75 7.996L12 20z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$T = createSvgIcon(Icon$T(), "Sample");
function Sample({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$T,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Sample$1 = forwardRef(Sample);
const Icon$S = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M5 3h12l4 4v6h-2V7.83L16.17 5H5v14h8v2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M15 6H6v4h9zM17.83 22 15 19.17l1.41-1.41 1.41 1.41 3.54-3.54 1.41 1.41zM9 15c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3-3-1.34-3-3"
    }
  )
] });
const BaseSvgIcon$S = createSvgIcon(Icon$S(), "SaveOk");
function SaveOk({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$S,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const SaveOk$1 = forwardRef(SaveOk);
const Icon$R = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M11.99 2C17.52 2 22 6.48 22 12q0 .335-.022.663A7 7 0 0 0 20 12.071V12c0-4.42-3.58-8-8-8s-8 3.58-8 8 3.58 8 8 8h.07c.1.698.303 1.362.593 1.978Q12.33 22 11.99 22C6.47 22 2 17.52 2 12S6.47 2 11.99 2"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "m12.5 12.25 2.143 1.27a7 7 0 0 0-1.05 1.035L11 13V7h1.5z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M14 19c0-2.76 2.24-5 5-5s5 2.24 5 5-2.24 5-5 5-5-2.24-5-5m7 0-3-2.25v4.5z",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$R = createSvgIcon(Icon$R(), "ScheduleRun");
function ScheduleRun({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$R,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const ScheduleRun$1 = forwardRef(ScheduleRun);
const Icon$Q = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "m9.17 6 2 2H20v6h2V8c0-1.1-.9-2-2-2h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h10v-2H4V6z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M20.71 19.3 23 17h-6v6l2.29-2.29 2.3 2.29L23 21.59z"
    }
  )
] });
const BaseSvgIcon$Q = createSvgIcon(Icon$Q(), "SelectDestination");
function SelectDestination({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$Q,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const SelectDestination$1 = forwardRef(SelectDestination);
const Icon$P = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M11.293 11.293a1 1 0 0 1 1.1-.212l9 3.857a1.001 1.001 0 0 1 .122 1.777l-2.995 1.797-.006.004-1.798 2.999a1 1 0 0 1-1.778-.121l-3.857-9a1 1 0 0 1 .212-1.101m4.713 7.515.805-1.341a1.9 1.9 0 0 1 .511-.559l.092-.062.052-.034 1.343-.806-4.906-2.103z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "m10.566 17.405-2.052 4.93-1.385-.576 2.05-4.928zM7.163 14.809l-4.941 2.037-.572-1.387 4.939-2.036zM22.361 8.545l-4.948 2.039-.574-1.386 4.951-2.04zM7.17 9.175l-.574 1.385-4.931-2.053.576-1.385zM16.193 1.942l.693.29-2.058 4.94-1.387-.575 2.06-4.943zM10.58 6.588l-1.387.574-2.039-4.947 1.387-.571z"
    }
  )
] });
const BaseSvgIcon$P = createSvgIcon(Icon$P(), "SelectFeature");
function SelectFeature({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$P,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const SelectFeature$1 = forwardRef(SelectFeature);
const Icon$O = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m10.083 19.394.057.113a1 1 0 0 0 1.72.007l2.869-4.786 4.786-2.87a1 1 0 0 0-.121-1.777l-14-6c-.83-.356-1.669.483-1.313 1.313zM6.905 6.904l9.903 4.244-3.322 1.995-.102.07a1 1 0 0 0-.242.273l-1.992 3.321z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$O = createSvgIcon(Icon$O(), "SelectTool");
function SelectTool({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$O,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const SelectTool$1 = forwardRef(SelectTool);
const Icon$N = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    d: "M15 3v11h6V5a2 2 0 0 0-2-2zM17 23v-6h6l-2.29 2.3L23 21.59 21.59 23l-2.3-2.29zM13 21h-2v-2h2zM9 5H7V3h2zM5 17H3v-2h2zM5 19v2c-1.1 0-2-.9-2-2zM13 5h-2V3h2zM5 9H3V7h2zM9 21H7v-2h2zM5 13H3v-2h2zM5 5H3c0-1.1.9-2 2-2zM9 17h2v-2H9zM11 9H9V7h2zM9 13h2v-2H9z"
  }
) });
const BaseSvgIcon$N = createSvgIcon(Icon$N(), "SelectVariable");
function SelectVariable({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$N,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const SelectVariable$1 = forwardRef(SelectVariable);
const Icon$M = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "m12.643 5.307-3.857 7.285h2.691v4.715l3.737-7.286h-2.571zM17.97 24a6.7 6.7 0 0 1-3.617-1.034 6 6 0 0 1-2.412-2.842 6 6 0 0 1 2.412-2.842 6.7 6.7 0 0 1 3.618-1.034q1.96 0 3.617 1.034A6 6 0 0 1 24 20.124a6 6 0 0 1-2.412 2.842A6.7 6.7 0 0 1 17.971 24m0-1.723q1.228 0 2.316-.56a4.7 4.7 0 0 0 1.776-1.593 4.7 4.7 0 0 0-1.777-1.593 5 5 0 0 0-2.314-.56q-1.228 0-2.315.56a4.7 4.7 0 0 0-1.777 1.593 4.7 4.7 0 0 0 1.777 1.594q1.087.56 2.315.56m0-.861q-.537 0-.915-.377a1.25 1.25 0 0 1-.376-.915q0-.538.377-.915.376-.377.915-.377t.915.377q.377.377.377.915t-.377.915a1.25 1.25 0 0 1-.915.377"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M19.75 1.723a2 2 0 0 1 2 2v11.37a8.6 8.6 0 0 0-2-.67v-10.7h-16v16h6.192c0 .86.19 1.34.553 2H3.75a2 2 0 0 1-2-2v-16a2 2 0 0 1 2-2z"
    }
  )
] });
const BaseSvgIcon$M = createSvgIcon(Icon$M(), "ShowNodeResults");
function ShowNodeResults({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$M,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const ShowNodeResults$1 = forwardRef(ShowNodeResults);
const Icon$L = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M12 8.83 8.83 12 12 15.17l-1.41 1.41L6 12l4.59-4.59z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M18 3a4 4 0 0 1 4 4v10a4 4 0 0 1-3.794 3.995L18 21H6l-.206-.005a4 4 0 0 1-3.79-3.789L2 17V7a4 4 0 0 1 4-4zM6 5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h9V5zm10.5 14H18a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1.5z",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$L = createSvgIcon(Icon$L(), "ShowRightsidebar");
function ShowRightsidebar({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$L,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const ShowRightsidebar$1 = forwardRef(ShowRightsidebar);
const Icon$K = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12.6 2.2a1 1 0 0 0-1.2 0l-8 6a1 1 0 0 0 0 1.6l8 6a1 1 0 0 0 1.2 0l8-6a1 1 0 0 0 0-1.6zM12 13.75 5.667 9 12 4.25 18.333 9z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "m4.4 12.45-1 .75a1 1 0 0 0 0 1.6l1 .75 1.029-1.372.171-.128-.037-.05.037-.05-.171-.129zM20.6 13.2l-1-.75-1.029 1.371-.171.129.038.05-.038.05.171.128L19.6 15.55l1-.75a1 1 0 0 0 0-1.6M6.4 17.05l2 1.5 1.2-1.6-2-1.5zM15.6 18.55l2-1.5-1.2-1.6-2 1.5zM10.4 20.05l1 .75a1 1 0 0 0 1.2 0l1-.75-1.2-1.6-.4.3-.4-.3z"
    }
  )
] });
const BaseSvgIcon$K = createSvgIcon(Icon$K(), "SingleLayer");
function SingleLayer({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$K,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const SingleLayer$1 = forwardRef(SingleLayer);
const Icon$J = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m18.632 17.875 1.856 1.875v2.813a.933.933 0 0 1-.928.937h-5.568a.933.933 0 0 1-.928-.937V19.75l1.856-1.875v3.75h3.712zM10.28 1c5.117 0 9.28 4.206 9.28 9.375h-1.856c0-3.817-2.84-6.971-6.496-7.435v3.685h2.784v6.094l-5.113 3.874-2.052-6.218H4.712V5.431a7.5 7.5 0 0 0-1.856 4.944c0 3.863 2.865 7.072 6.664 7.462L9.332 19.7C4.582 19.215 1 15.204 1 10.375 1 5.205 5.163 1 10.28 1m5.84 11.525a.92.92 0 0 1 1.312 0L23 18.149l-1.312 1.325-4.912-4.96-4.912 4.961-1.312-1.325zM9.352 2.94a7.3 7.3 0 0 0-2.784.95V8.5h1.597l1.66 5.032 2.311-1.75V8.5H9.352z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$J = createSvgIcon(Icon$J(), "SiteSelection");
function SiteSelection({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$J,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const SiteSelection$1 = forwardRef(SiteSelection);
const Icon$I = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.954 9.617c.219.018.446-.028.65-.146L18.42 7.28c.538-.31.72-.992.411-1.529a1.125 1.125 0 0 0-1.533-.408L15.162 6.57V4.117A1.12 1.12 0 0 0 14.038 3c-.622 0-1.123.5-1.123 1.117v4.385a1.12 1.12 0 0 0 1.04 1.115m-4.892 2.348a1.111 1.111 0 0 1-.564 1.002L4.686 15.16a1.125 1.125 0 0 1-1.533-.408 1.114 1.114 0 0 1 .41-1.528L5.693 12l-2.13-1.227a1.11 1.11 0 0 1-.411-1.526 1.125 1.125 0 0 1 1.533-.41L8.5 11.03a1.11 1.11 0 0 1 .563.935m.332 2.564a1.1 1.1 0 0 1 .652-.146c.58.041 1.04.525 1.04 1.113v4.385c0 .618-.505 1.119-1.123 1.119a1.12 1.12 0 0 1-1.124-1.119v-2.453L6.7 18.656a1.119 1.119 0 1 1-1.123-1.937zm0-5.058L5.578 7.28a1.117 1.117 0 0 1-.41-1.529A1.125 1.125 0 0 1 6.7 5.342L8.839 6.57V4.117A1.12 1.12 0 0 1 9.963 3c.619 0 1.122.5 1.122 1.117v4.385c0 .588-.458 1.072-1.039 1.115a1.13 1.13 0 0 1-.652-.146m9.026 7.248-3.815-2.19a1.1 1.1 0 0 0-.65-.146 1.12 1.12 0 0 0-1.04 1.113v4.385A1.12 1.12 0 0 0 14.038 21c.621 0 1.124-.5 1.124-1.119v-2.453l2.136 1.228a1.12 1.12 0 1 0 1.122-1.937M18.307 12l2.13-1.227c.539-.31.723-.991.412-1.526a1.126 1.126 0 0 0-1.534-.41l-3.816 2.192a1.12 1.12 0 0 0-.56.935q-.006.183.05.364c.079.26.255.49.51.638l3.816 2.193a1.126 1.126 0 0 0 1.534-.408 1.115 1.115 0 0 0-.411-1.528zm-4.29.428-1.585 1.577a.32.32 0 0 1-.2.084h-.466a.32.32 0 0 1-.2-.084l-1.584-1.577a.32.32 0 0 1-.083-.197v-.464c0-.065.037-.154.083-.2l1.585-1.576a.32.32 0 0 1 .199-.083h.466c.065 0 .154.037.2.083l1.586 1.577a.32.32 0 0 1 .082.199v.464a.32.32 0 0 1-.082.197m-1.267-.437a.33.33 0 0 0-.084-.2l-.46-.455a.33.33 0 0 0-.198-.082h-.018a.32.32 0 0 0-.197.082l-.46.455a.33.33 0 0 0-.081.2v.017c0 .063.035.151.081.197l.46.456a.32.32 0 0 0 .197.082h.018a.33.33 0 0 0 .199-.082l.459-.456a.32.32 0 0 0 .084-.197z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$I = createSvgIcon(Icon$I(), "Snowflake");
function Snowflake({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$I,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Snowflake$1 = forwardRef(Snowflake);
const Icon$H = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    d: "M15.245.445q-1.07-.3-2.177-.397l-.175 1.992c.612.054 1.223.166 1.813.331zM17.313 1.237q.996.494 1.886 1.161l-1.202 1.6a10 10 0 0 0-1.571-.968zM6.619 1.271l.899 1.787q-.827.417-1.565.977L4.742 2.443c.588-.445 1.219-.84 1.877-1.172M8.155 13.031A4 4 0 0 1 8 12.001a3.994 3.994 0 0 1 2.97-3.846l-.517-1.932A5.996 5.996 0 0 0 6 12c.005.523.08 1.044.223 1.547zM14 12a2 2 0 1 0-4 0 2 2 0 0 0 4 0M14.828 14.828l1.415 1.414A5.96 5.96 0 0 1 12 18a5.96 5.96 0 0 1-4.243-1.758l1.415-1.414c1.51 1.512 4.146 1.512 5.656 0M17.776 13.548l-1.932-.519c.107-.394.156-.72.156-1.029a3.994 3.994 0 0 0-2.969-3.845l.517-1.932A5.996 5.996 0 0 1 18 12c0 .488-.071.98-.224 1.548M22.18 5.643a12 12 0 0 0-1.342-1.759l-1.473 1.354c.417.453.793.947 1.119 1.467zM3.112 3.94l1.48 1.343c-.412.455-.785.951-1.109 1.475l-1.701-1.05a12 12 0 0 1 1.33-1.769M21.824 10.122l1.965-.374a12 12 0 0 0-.613-2.126l-1.863.73c.224.57.396 1.166.511 1.77M10.857.054l.188 1.992a10 10 0 0 0-1.811.341L8.681.465c.708-.203 1.44-.34 2.176-.41M14.746 21.62l.548 1.922a12 12 0 0 0 2.063-.802l-.893-1.789c-.55.275-1.128.5-1.718.668M.797 7.69l1.867.72a10 10 0 0 0-.5 1.773l-1.967-.36c.133-.728.334-1.442.6-2.133M20.506 17.261l1.7 1.054c.389-.627.721-1.293.987-1.98l-1.864-.725a10 10 0 0 1-.823 1.651M10.907 23.951l.18-1.992a10 10 0 0 0 1.846-.003l.185 1.993a12.4 12.4 0 0 1-2.211.002M22 12c0 .62-.057 1.236-.168 1.838l1.967.364c.133-.72.201-1.462.201-2.202v-.046zM19.238 21.573l-1.207-1.595c.49-.37.948-.789 1.362-1.244l1.479 1.348a12 12 0 0 1-1.634 1.491M2 12.021l-2 .005c.002.74.071 1.481.207 2.202l1.965-.369c-.113-.602-.17-1.22-.172-1.838M8.73 23.55a12 12 0 0 1-2.066-.799l.89-1.79a10 10 0 0 0 1.72.663zM2.679 15.63l-1.863.727c.267.686.601 1.352.991 1.98l1.697-1.058a10 10 0 0 1-.825-1.649M4.782 21.587A12 12 0 0 1 3.145 20.1l1.475-1.35c.416.453.876.872 1.366 1.242z"
  }
) });
const BaseSvgIcon$H = createSvgIcon(Icon$H(), "SpatialAnalysis");
function SpatialAnalysis({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$H,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const SpatialAnalysis$1 = forwardRef(SpatialAnalysis);
const Icon$G = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19 3a2 2 0 0 1 1.92 2.563l-.154-.209A10.95 10.95 0 0 1 23 12c0 6.075-4.925 11-11 11-1.578 0-3.08-.332-4.436-.931a4 4 0 0 0 1.187-1.676 9 9 0 0 0 10.7-13.445A2 2 0 1 1 19 3m-7-2c1.579 0 3.08.333 4.436.931a4 4 0 0 0-1.187 1.675A9 9 0 0 0 4.55 17.052Q4.77 17 5.001 17a2 2 0 1 1-1.92 1.437l.154.209A10.95 10.95 0 0 1 1 12C1 5.925 5.925 1 12 1m0 4a7 7 0 0 1 .24 13.996L12 19a7 7 0 1 1 0-14m.965 8.001h-1.93c.086 1.231.33 2.34.682 3.16q.116.27.231.468l.051.084.053-.084q.076-.132.154-.296l.077-.171c.352-.822.596-1.93.682-3.16m-3.935 0H7.1a5 5 0 0 0 2.576 3.427l-.057-.168c-.306-.93-.514-2.044-.589-3.259m5.94 0c-.08 1.289-.31 2.465-.646 3.427A5 5 0 0 0 16.9 13zm-.646-5.43.057.169c.306.93.514 2.045.589 3.26h1.93a5 5 0 0 0-2.576-3.428m-4.648.001-.082.044A5 5 0 0 0 7.1 11h1.93c.08-1.29.309-2.465.646-3.428M12 7.286l-.052.085a4 4 0 0 0-.231.467c-.352.822-.596 1.93-.682 3.162h1.93c-.086-1.231-.33-2.34-.682-3.162a4 4 0 0 0-.231-.467z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$G = createSvgIcon(Icon$G(), "SpatialExtension");
function SpatialExtension({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$G,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const SpatialExtension$1 = forwardRef(SpatialExtension);
const Icon$F = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.995 3.851A2.007 2.007 0 0 0 20 2H4l-.149.006A2.007 2.007 0 0 0 2 4v16l.006.149A2.007 2.007 0 0 0 4 22h16l.149-.006A2.007 2.007 0 0 0 22 20V4zM4 13h7v7H4zm9 0h7v7h-7zm0-9h7v7h-7zM4 6.5h2.5V4H4zm4.5 0H11V4H8.5zm-2 4.5H4V8.5h2.5zm4.5 0H8.5V8.5H11z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$F = createSvgIcon(Icon$F(), "SpatialIndexes");
function SpatialIndexes({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$F,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const SpatialIndexes$1 = forwardRef(SpatialIndexes);
const Icon$E = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2q.418 0 .826.013l.473.02.443.027.806.071.282.031c3.673.429 6.507 1.67 7.123 3.2l.047.13V10h-2V8.4c-1.823.972-4.728 1.6-8 1.6-3.271 0-6.175-.628-8-1.6l.001 9.579c.003-.015.012-.014.035.007l.124.118c.3.283.817.59 1.512.867C7.282 19.617 9.552 20 12 20h8.661c-1.729 1.196-4.96 2-8.661 2-5.415 0-9.824-1.721-9.995-3.87L2 18V5.493c.409-1.246 2.285-2.318 4.9-2.935l.475-.105.437-.086.368-.064.548-.084.062-.008q.663-.09 1.361-.143l.53-.033.471-.02Q11.572 2 12 2m-2 10c.51 0 .935.388.993.884L11 13v1H9.5v-.5h-2v1H10c.51 0 .935.388.993.884L11 15.5V17c0 .51-.388.935-.884.993L10 18H7c-.51 0-.935-.388-.993-.884L6 17v-1h1.5v.5h2v-1H7c-.51 0-.935-.388-.993-.884L6 14.5V13c0-.51.388-.935.884-.993L7 12zm7 0c.51 0 .935.388.993.884L18 13v3.44l.966.644-.555.832-.584-.389a1 1 0 0 1-.697.464L17 18h-4c-.51 0-.935-.388-.993-.884L12 17v-4c0-.51.388-.935.884-.993L13 12zm4.5 0v4.5H24V18h-4v-6zm-5 1.5h-3v3h2.787l-1.376-.834.555-.832 1.034.606zM12 4l-.415.004-.153.003c-1.515.04-2.926.235-4.108.506-.603.145-1.159.318-1.652.516-.618.246-1.095.516-1.404.772L4.051 6l.11.104c.299.283.816.59 1.51.867C7.284 7.616 9.554 8 12 8s4.717-.384 6.328-1.029c.617-.246 1.095-.516 1.404-.772l.216-.2-.108-.103c-.3-.283-.817-.59-1.512-.867a13 13 0 0 0-2.28-.653 22 22 0 0 0-3.18-.359l-.494-.014z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$E = createSvgIcon(Icon$E(), "Sql");
function Sql({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$E,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Sql$1 = forwardRef(Sql);
const Icon$D = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m12 2 .254.001a7 7 0 0 0-.968 2.012l.146-.006c-1.515.04-2.926.235-4.108.506-.603.145-1.159.318-1.652.516-.618.246-1.095.516-1.404.772L4.051 6l.11.104c.299.283.816.59 1.51.867 1.454.582 3.444.951 5.617 1.018.213.726.543 1.403.966 2.01L12 10c-3.271 0-6.175-.628-8-1.6l.001 9.579c.003-.015.012-.014.035.007l.124.118c.3.283.817.59 1.512.867C7.282 19.617 9.552 20 12 20h8.661c-1.729 1.196-4.96 2-8.661 2-5.415 0-9.824-1.721-9.995-3.87L2 18V5.493c.409-1.246 2.285-2.318 4.9-2.935l.475-.105.437-.086.368-.064.548-.084.062-.008q.663-.09 1.361-.143l.53-.033.471-.02Q11.572 2 12 2m-2 10c.51 0 .935.388.993.884L11 13v1H9.5v-.5h-2v1H10c.51 0 .935.388.993.884L11 15.5V17c0 .51-.388.935-.884.993L10 18H7c-.51 0-.935-.388-.993-.884L6 17v-1h1.5v.5h2v-1H7c-.51 0-.935-.388-.993-.884L6 14.5V13c0-.51.388-.935.884-.993L7 12zm7 0c.51 0 .935.388.993.884L18 13v3.44l.966.644-.555.832-.584-.389a1 1 0 0 1-.697.464L17 18h-4c-.51 0-.935-.388-.993-.884L12 17v-4c0-.51.388-.935.884-.993L13 12zm4.5 0v4.5H24V18h-4v-6zm-5 1.5h-3v3h2.787l-1.376-.834.555-.832 1.034.606zM18 1c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5m.5 7h-1v1h1zm0-5h-1v4h1z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$D = createSvgIcon(Icon$D(), "SqlError");
function SqlError({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$D,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const SqlError$1 = forwardRef(SqlError);
const Icon$C = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10.83 13A3.01 3.01 0 0 0 8 11c-1.66 0-3 1.34-3 3 0 1.65 1.34 3 3 3 1.3 0 2.41-.84 2.83-2H16v2h2v-2h1v-2zM8 15c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 4a7.49 7.49 0 0 1 7.35 6.04c2.6.18 4.65 2.32 4.65 4.96 0 2.76-2.24 5-5 5H6c-3.31 0-6-2.69-6-6 0-3.09 2.34-5.64 5.35-5.96A7.5 7.5 0 0 1 12 4M6 18h13c1.65 0 3-1.35 3-3a2.98 2.98 0 0 0-2.78-2.96l-1.53-.11-.3-1.5A5.5 5.5 0 0 0 12 6C9.94 6 8.08 7.14 7.13 8.97l-.5.95-1.07.11A3.973 3.973 0 0 0 2 14c0 2.21 1.79 4 4 4",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$C = createSvgIcon(Icon$C(), "Sso");
function Sso({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$C,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Sso$1 = forwardRef(Sso);
const Icon$B = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M13 11h-2v2h2zm3 2h5v-2h-5zm-8-2H3v2h5z" }) });
const BaseSvgIcon$B = createSvgIcon(Icon$B(), "StrokeCustom");
function StrokeCustom({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$B,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const StrokeCustom$1 = forwardRef(StrokeCustom);
const Icon$A = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M3 11h4v2H3zM10 11h4v2h-4zM21 11h-4v2h4z" }) });
const BaseSvgIcon$A = createSvgIcon(Icon$A(), "StrokeDash");
function StrokeDash({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$A,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const StrokeDash$1 = forwardRef(StrokeDash);
const Icon$z = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M21 11H3v2h18z" }) });
const BaseSvgIcon$z = createSvgIcon(Icon$z(), "StrokeSolid");
function StrokeSolid({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$z,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const StrokeSolid$1 = forwardRef(StrokeSolid);
const Icon$y = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 5a2 2 0 0 1 2 2v11a1 1 0 0 1-1 1h-1.185a3 3 0 0 1-2.816 2 2.99 2.99 0 0 1-2.815-2h-3.368A3 3 0 0 1 8 21a2.99 2.99 0 0 1-2.815-2H3a1 1 0 0 1-1-1v-6c0-.265.105-.52.293-.707l3-3A1 1 0 0 1 6 8h2V7a2 2 0 0 1 2-2zM8 17c-.551 0-1 .449-1 1s.449 1 1 1 1-.449 1-1-.449-1-1-1m9 0c-.551 0-1 .449-1 1s.449 1 1 1 1-.449 1-1-.449-1-1-1m3-10h-9.999v8.781c.369.332.65.751.816 1.219h3.368A2.99 2.99 0 0 1 17 15c1.301 0 2.401.838 2.816 2H20zM8 10H6.414L4 12.414V17h1.185A2.99 2.99 0 0 1 8 15zm-1 2v2H5v-2zm10.939 0c-.277 1.142-1.488 2-2.939 2s-2.662-.858-2.94-2zM15 9c1.451 0 2.662.859 2.94 2h-5.879c.277-1.141 1.488-2 2.939-2",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$y = createSvgIcon(Icon$y(), "SupplyChain");
function SupplyChain({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$y,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const SupplyChain$1 = forwardRef(SupplyChain);
const Icon$x = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx("circle", { cx: 12, cy: 12, r: 8, fill: "currentColor" }) });
const BaseSvgIcon$x = createSvgIcon(Icon$x(), "SwatchCircle");
function SwatchCircle({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$x,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const SwatchCircle$1 = forwardRef(SwatchCircle);
const Icon$w = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-1.5 0a6.5 6.5 0 0 1-10.535 5.096l9.131-9.131A6.47 6.47 0 0 1 18.5 12M6.904 16.035l9.131-9.131a6.5 6.5 0 0 0-9.131 9.131",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$w = createSvgIcon(Icon$w(), "SwatchCircleNone");
function SwatchCircleNone({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$w,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const SwatchCircleNone$1 = forwardRef(SwatchCircleNone);
const Icon$v = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2m-5 16h-4V5h4zM5 5h3v14H5zm11 14V5h3v14z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$v = createSvgIcon(Icon$v(), "TableColumn");
function TableColumn({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$v,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const TableColumn$1 = forwardRef(TableColumn);
const Icon$u = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5 3h12v2h-1v14h1v2H5c-1.1 0-2-.9-2-2V5c0-1.1.9-2 2-2m9 16V5h-4v14zM8 5H5v14h3z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M19 17h2v-2h-2zM19 19v2c1.1 0 2-.9 2-2zM19 9h2V7h-2zM19 13h2v-2h-2zM19 5h2c0-1.1-.9-2-2-2z"
    }
  )
] });
const BaseSvgIcon$u = createSvgIcon(Icon$u(), "TableColumnLimited");
function TableColumnLimited({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$u,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const TableColumnLimited$1 = forwardRef(TableColumnLimited);
const Icon$t = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsxs(
    "g",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      clipPath: "url(#a)",
      clipRule: "evenodd",
      children: [
        /* @__PURE__ */ jsx("path", { d: "M19.5 3h-15c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2H13v-2H9.5v-9h12V5c0-1.1-.9-2-2-2m0 2v3h-15V5zm-15 5h3v9h-3z" }),
        /* @__PURE__ */ jsx("path", { d: "M24 12h-8v3.37L18.254 18 16 20.63V24h8v-3.37L21.746 18 24 15.37zm-6 2.63V14h4v.63l-2 2.333z" })
      ]
    }
  ),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "a", children: /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M0 0h24v24H0z" }) }) })
] });
const BaseSvgIcon$t = createSvgIcon(Icon$t(), "TempTable");
function TempTable({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$t,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const TempTable$1 = forwardRef(TempTable);
const Icon$s = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 11c2.757 0 5 2.243 5 5a4.97 4.97 0 0 1-.833 2.753l2.54 2.54-1.414 1.414-2.54-2.54A4.97 4.97 0 0 1 16 21c-2.757 0-5-2.243-5-5s2.243-5 5-5m1.375-8.78A1 1 0 0 1 19 3v6h-2V5.081L14 7.48V10h-2V7.481L9 5.082V17a1 1 0 0 1-.375.781l-5 4a1 1 0 0 1-1.058.121A1 1 0 0 1 2 21V7c0-.304.138-.591.376-.78l5-4c.175-.14.404-.21.622-.21.221-.002.452.07.627.21L13 5.72zM16 13c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3M7 5.081 4 7.48v11.44l3-2.4z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$s = createSvgIcon(Icon$s(), "TerritoryPlanning");
function TerritoryPlanning({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$s,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const TerritoryPlanning$1 = forwardRef(TerritoryPlanning);
const Icon$r = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m8.2 5 5.04 14h-2.16l-1.12-3.22H4.3L3.16 19H1L6.06 5zM7.14 7.6q-.18.72-.48 1.58l-1.72 4.76h4.38l-1.7-4.76q-.36-.98-.48-1.58m11.093.85q.767 0 1.373.131.605.132 1.231.505.626.374.98 1.201.352.828.352 2.039v6.682h-2.018v-.889q-1.091 1.131-2.826 1.131-1.635 0-2.655-.898-1.02-.899-1.02-2.554 0-1.676 1.151-2.543 1.151-.87 2.806-.869 1.514 0 2.544.606v-.565q0-1.15-.525-1.635t-1.676-.485q-1.695 0-2.947.929l-.626-1.716q1.555-1.07 3.856-1.07m-.283 5.753q-1.01 0-1.645.394-.636.394-.636 1.201 0 .747.525 1.17.525.425 1.514.425 1.454 0 2.443-1.11v-1.575q-.95-.505-2.2-.505",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$r = createSvgIcon(Icon$r(), "TextBox");
function TextBox({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$r,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const TextBox$1 = forwardRef(TextBox);
const Icon$q = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m6.894 5.832 4.5-3.428a1 1 0 0 1 1.212 0l4.5 3.428a1 1 0 0 1 0 1.591l-4.5 3.43a1 1 0 0 1-1.212 0l-4.5-3.43a1 1 0 0 1 0-1.59m7.956.795L12 4.457l-2.85 2.17L12 8.799z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m2.385 13.367 4.5-3.511a1 1 0 0 1 1.222-.007L12 12.815l3.895-2.966a1 1 0 0 1 1.221.007l4.5 3.511a1 1 0 0 1-.01 1.584l-8.998 6.858q-.064.048-.132.085a1 1 0 0 1-1.081-.084m5.16-5.525 2.807-2.139-2.869-2.24-2.843 2.166zM12 15.328l2.862 2.181L12 19.745 9.137 17.51zm-1.65-1.256-2.905 2.213-2.808-2.139 2.87-2.24z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "m11.394 21.809-9-6.858a1 1 0 0 1-.01-1.584" })
] });
const BaseSvgIcon$q = createSvgIcon(Icon$q(), "Tileset");
function Tileset({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$q,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Tileset$1 = forwardRef(Tileset);
const Icon$p = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M15.245.397q-1.07-.3-2.177-.397l-.175 1.992c.612.054 1.223.166 1.813.331zM17.313 1.189a12 12 0 0 1 1.886 1.161l-1.202 1.599a10 10 0 0 0-1.571-.967zM7.518 3.01l-.899-1.787c-.658.332-1.289.727-1.877 1.172l1.211 1.592q.737-.56 1.565-.977M22.18 5.595a12 12 0 0 0-1.342-1.759L19.365 5.19c.417.453.793.947 1.119 1.467zM3.112 3.891l1.48 1.344c-.412.455-.785.951-1.109 1.475L1.782 5.659a12 12 0 0 1 1.33-1.768M21.824 10.074l1.965-.374a12 12 0 0 0-.613-2.126l-1.863.729c.224.571.396 1.167.511 1.771M10.857.006l.188 1.992a10 10 0 0 0-1.811.341L8.681.417c.708-.203 1.44-.341 2.176-.411M14.746 21.571l.548 1.923a12 12 0 0 0 2.063-.802l-.893-1.789c-.55.275-1.128.5-1.718.668M.797 7.642l1.867.72a10 10 0 0 0-.5 1.773l-1.967-.36c.133-.728.334-1.442.6-2.133M20.506 17.213l1.7 1.054c.389-.627.721-1.293.987-1.981l-1.864-.724a10 10 0 0 1-.823 1.651M10.907 23.903l.18-1.992a10 10 0 0 0 1.846-.003l.185 1.993a12.4 12.4 0 0 1-2.211.002M22 11.952c0 .619-.057 1.236-.168 1.838l1.967.364c.133-.72.201-1.462.201-2.202v-.046zM19.238 21.525l-1.207-1.595c.49-.371.948-.789 1.362-1.244l1.479 1.348a12 12 0 0 1-1.634 1.491M2 11.973l-2 .005c.002.74.071 1.481.207 2.202l1.965-.369c-.113-.602-.17-1.22-.172-1.838M8.73 23.501a12 12 0 0 1-2.066-.798l.89-1.791a10 10 0 0 0 1.72.664zM2.679 15.582l-1.863.727c.267.686.601 1.352.991 1.979l1.697-1.057a10 10 0 0 1-.825-1.649M4.782 21.539a12 12 0 0 1-1.637-1.488L4.62 18.7c.416.454.876.873 1.366 1.243z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m11.525 3.138-4.084 3.11a.908.908 0 0 0 0 1.444l4.084 3.112a.91.91 0 0 0 1.1 0l4.084-3.112a.907.907 0 0 0 0-1.444l-4.084-3.11a.91.91 0 0 0-1.1 0M12.075 5l2.586 1.97-2.586 1.97-2.586-1.97z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "m7.434 9.9-4.085 3.186a.907.907 0 0 0 .008 1.438l4.679 3.564 3.396 2.653c.176.137.39.201.601.192a.9.9 0 0 0 .601-.192l3.396-2.653 4.679-3.564a.907.907 0 0 0 .008-1.438L16.633 9.9a.91.91 0 0 0-1.109-.007l-3.49 2.66-3.492-2.66a.91.91 0 0 0-1.108.007m1.962 6.943 2.637 2.01 2.637-2.01-2.637-2.009zm9.277-3.05-2.506 1.91-2.637-2.01 2.539-1.933zM7.9 15.703l2.637-2.01-2.538-1.933-2.605 2.033z",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$p = createSvgIcon(Icon$p(), "TilesetsAggregated");
function TilesetsAggregated({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$p,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const TilesetsAggregated$1 = forwardRef(TilesetsAggregated);
const Icon$o = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m19 14 .3 1.5q.48.18.883.475l.197.155 1.45-.49 1 1.73-1.14 1c.069.429.078.68.03 1.065l-.03.205 1.14 1-1 1.73-1.45-.49a3.6 3.6 0 0 1-.845.533l-.235.097L19 24h-2l-.3-1.51a3.7 3.7 0 0 1-.883-.475l-.197-.155-1.45.49-1-1.73 1.14-1c-.067-.417-.078-.667-.033-1.028l.033-.232-1.14-1 1-1.73 1.45.49q.384-.324.845-.533l.235-.097L17 14zM8 2v2h8V2h2v2h1c1.05 0 1.918.82 1.994 1.851L21 6v6h-2v-2H5v10h6v2H5a2 2 0 0 1-1.995-1.851L3 20l.01-14c0-1.05.802-1.918 1.84-1.994L5 4h1V2zm10 15c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2m1-11H5v2h14z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$o = createSvgIcon(Icon$o(), "TimeBuckets");
function TimeBuckets({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$o,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const TimeBuckets$1 = forwardRef(TimeBuckets);
const Icon$n = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M16.5 4H15v5l3.62 2.16.75-1.23-2.87-1.68zM5.5 13a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M16 1a7 7 0 0 1 7 7 6.99 6.99 0 0 1-4 6.317V20c0 .55-.45 1-1 1h-1c-.55 0-1-.45-1-1v-1H4v1c0 .55-.45 1-1 1H2c-.55 0-1-.45-1-1v-8l2.08-5.99C3.29 5.42 3.84 5 4.5 5h5.183A6.99 6.99 0 0 1 16 1m-5 7c0 2.757 2.243 5 5 5s5-2.243 5-5-2.243-5-5-5-5 2.243-5 5m-8 9h14v-2.08c-.328.048-.66.08-1 .08l-.051-.003-.039-.002A1.496 1.496 0 0 1 13 14.5q.002-.065.012-.127l.006-.047A7 7 0 0 1 10.26 12H3zM9.08 7H4.85l-1.08 3.109h5.555A7 7 0 0 1 9 8c0-.34.033-.673.08-1",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$n = createSvgIcon(Icon$n(), "TimeCar");
function TimeCar({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$n,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const TimeCar$1 = forwardRef(TimeCar);
const Icon$m = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 6c1.05 0 1.918.82 1.994 1.851L18 8v8c0 1.05-.82 1.918-1.851 1.994L16 18H6c-1.05 0-1.918-.82-1.994-1.851L4 16V8c0-1.05.82-1.918 1.851-1.994L6 6zm0 2H6v8h10zM2 6H0v12h2zm18 2 4 4-4 4z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$m = createSvgIcon(Icon$m(), "TimeWindowIncremental");
function TimeWindowIncremental({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$m,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const TimeWindowIncremental$1 = forwardRef(TimeWindowIncremental);
const Icon$l = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 6c1.05 0 1.918.82 1.994 1.851L18 8v8c0 1.05-.82 1.918-1.851 1.994L16 18H8c-1.05 0-1.918-.82-1.994-1.851L6 16V8c0-1.05.82-1.918 1.851-1.994L8 6zm0 2H8v8h8zM4 8v8l-4-4zm16 0 4 4-4 4z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$l = createSvgIcon(Icon$l(), "TimeWindowMoving");
function TimeWindowMoving({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$l,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const TimeWindowMoving$1 = forwardRef(TimeWindowMoving);
const Icon$k = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19 2c1.05 0 1.918.82 1.994 1.851L21 4v14c0 1.05-.82 1.918-1.851 1.994L19 20h-4l-3 3-3-3H5a2 2 0 0 1-1.995-1.851L3 18V4a2 2 0 0 1 1.85-1.994L5 2zm0 2H5v14h4.83L12 20.17 14.17 18H19zm-5 10v2H7v-2zm3-4v2H7v-2zm0-4v2H7V6z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$k = createSvgIcon(Icon$k(), "Tooltip");
function Tooltip({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$k,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Tooltip$1 = forwardRef(Tooltip);
const Icon$j = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    d: "M12 13.694 7.41 18.21 6 16.823l6-5.904 6 5.904-1.41 1.387zM6 7.968h12V6H6z"
  }
) });
const BaseSvgIcon$j = createSvgIcon(Icon$j(), "TopRow");
function TopRow({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$j,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const TopRow$1 = forwardRef(TopRow);
const Icon$i = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17 19c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m-5-8c-.551 0-1-.448-1-1V9h2v1c0 .552-.449 1-1 1m-3 2.555A3.96 3.96 0 0 0 7 13c-.475 0-.923.098-1.346.249l1.366-7.45A1 1 0 0 1 9 6zM7 19c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m8-13a1.001 1.001 0 0 1 1.921-.389h.001a1 1 0 0 1 .058.188l1.366 7.45A4 4 0 0 0 17 13c-.732 0-1.41.211-2 .555zm5.918 10.19L18.943 5.416l-.003-.009q-.06-.3-.177-.577v-.001A3 3 0 0 0 13 6v1h-2V6a3 3 0 0 0-5.763-1.171v.001a3 3 0 0 0-.177.577l-.003.009L3.082 16.19A4 4 0 1 0 11 17v-4.185c.314.113.647.185 1 .185s.686-.072 1-.185V17a4 4 0 1 0 7.918-.81",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$i = createSvgIcon(Icon$i(), "TwinArea");
function TwinArea({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$i,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const TwinArea$1 = forwardRef(TwinArea);
const Icon$h = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21 6.419a7.7 7.7 0 0 1-2.126.583 3.67 3.67 0 0 0 1.623-2.04c-.713.425-1.5.726-2.34.893a3.689 3.689 0 0 0-6.383 2.523c0 .293.025.574.085.842a10.45 10.45 0 0 1-7.606-3.86 3.7 3.7 0 0 0-.505 1.866c0 1.278.658 2.41 1.64 3.066a3.65 3.65 0 0 1-1.668-.454v.04a3.71 3.71 0 0 0 2.956 3.626c-.3.082-.627.122-.967.122-.236 0-.475-.014-.699-.063a3.725 3.725 0 0 0 3.449 2.57 7.4 7.4 0 0 1-4.576 1.574c-.303 0-.593-.013-.883-.05a10.4 10.4 0 0 0 5.661 1.656c6.79 0 10.503-5.625 10.503-10.501q-.001-.243-.014-.477A7.4 7.4 0 0 0 21 6.419",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$h = createSvgIcon(Icon$h(), "Twitter");
function Twitter({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$h,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Twitter$1 = forwardRef(Twitter);
const Icon$g = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M21 12a9 9 0 1 1-2.156-5.844L16 9h7V2l-2.738 2.738A10.97 10.97 0 0 0 12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "m13.51 10.49 3.44 1.56-3.44 1.56-1.56 3.44-1.56-3.44-3.44-1.56 3.44-1.56 1.56-3.44z"
    }
  )
] });
const BaseSvgIcon$g = createSvgIcon(Icon$g(), "UpdateGen");
function UpdateGen({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$g,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const UpdateGen$1 = forwardRef(UpdateGen);
const Icon$f = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M11 2H3c-1.1 0-1.99.9-1.99 2L1 20c0 1.1.89 2 1.99 2H7v-2H3V4h7v5h5v4h2V8z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M13 15h2v2h-2a2 2 0 1 0 0 4h2v2h-2a4 4 0 0 1 0-8M21 19a2 2 0 0 1-2 2h-2v2h2a4 4 0 0 0 0-8h-2v2h2a2 2 0 0 1 2 2"
    }
  ),
  /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M14 18h4v2h-4z" })
] });
const BaseSvgIcon$f = createSvgIcon(Icon$f(), "UploadFileUrl");
function UploadFileUrl({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$f,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const UploadFileUrl$1 = forwardRef(UploadFileUrl);
const Icon$e = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 5.99V18h11v-5h5V5.99zM16 20H4c-1.1 0-2-.901-2-2V5.99C2 4.889 2.9 4 4 4h16c1.1 0 2 .9 2 2v8z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$e = createSvgIcon(Icon$e(), "View2d");
function View2d({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$e,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const View2d$1 = forwardRef(View2d);
const Icon$d = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13 19.426v-6.775l6-3.461v6.774zm-8-3.462V9.19l6 3.461v6.775zm7-11.967 5.999 3.462L12 10.92 6.001 7.459zm8 2.308-7-4.038a2 2 0 0 0-2 0L4 6.305c-.617.356-1 1.02-1 1.731v7.928c0 .711.383 1.375 1 1.732l7 4.038a2.01 2.01 0 0 0 2 0l7-4.038c.617-.357 1-1.021 1-1.732V8.036c0-.711-.383-1.375-1-1.731",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$d = createSvgIcon(Icon$d(), "View3d");
function View3d({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$d,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const View3d$1 = forwardRef(View3d);
const Icon$c = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "m11.5 8.83 1.41-1.42L17.5 12l-4.59 4.59-1.41-1.42L14.67 12z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M21 21a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1zm-1-2H8.5V5H20zM6.5 5v14H4V5z",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$c = createSvgIcon(Icon$c(), "ViewLeftsidebar");
function ViewLeftsidebar({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$c,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const ViewLeftsidebar$1 = forwardRef(ViewLeftsidebar);
const Icon$b = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M20 4H4v5.17a3 3 0 0 0-2 0V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5.17a3 3 0 0 0-2 0zM3 15c.35 0 .687-.06 1-.17V20h16v-5.17a3 3 0 0 0 2 0V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5.17c.313.11.65.17 1 .17M5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0M21 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    }
  ),
  /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "m12.75 5-4.5 8.5h3.14V19l4.36-8.5h-3z" })
] });
const BaseSvgIcon$b = createSvgIcon(Icon$b(), "WfComponent");
function WfComponent({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$b,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const WfComponent$1 = forwardRef(WfComponent);
const Icon$a = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M4 4h16v6.17a3 3 0 0 1 2 0V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v6.17a3 3 0 0 1 2 0zM4 13.83a3 3 0 0 1-2 0V20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6.17a3 3 0 0 1-2 0V20H4z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M11 7h2v6h-2zM11 15h2v2h-2zM4 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0M21 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
    }
  )
] });
const BaseSvgIcon$a = createSvgIcon(Icon$a(), "WfComponentInvalid");
function WfComponentInvalid({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$a,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const WfComponentInvalid$1 = forwardRef(WfComponentInvalid);
const Icon$9 = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12.441 2.235a2 2 0 0 0-1.882 0l-6.5 3.467A2 2 0 0 0 3 7.467v7.8a2 2 0 0 0 1.056 1.762l6.918 3.704v-2.247L5 15.27V8.633l6.5 3.9 6.5-3.9v2.734h2v-3.9a2 2 0 0 0-1.059-1.765zm-.941 7.966L6.029 6.918 11.5 4l5.471 2.918z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M22 17.733a5 5 0 1 1-10 0 5 5 0 0 1 10 0m-4.6-4L15 18.59h1.675v3.143L19 16.876h-1.6z",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$9 = createSvgIcon(Icon$9(), "WfExtensionPackageDefault");
function WfExtensionPackageDefault({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$9,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const WfExtensionPackageDefault$1 = forwardRef(WfExtensionPackageDefault);
const Icon$8 = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M7.002 9V6h11v12h-11v-3h-2v3a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-11a2 2 0 0 0-2 2v3z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M15 11.994 10.556 7.55 9.31 8.816l2.289 2.29H1v1.777h10.6l-2.289 2.289 1.245 1.267z"
    }
  )
] });
const BaseSvgIcon$8 = createSvgIcon(Icon$8(), "WfInput");
function WfInput({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$8,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const WfInput$1 = forwardRef(WfInput);
const Icon$7 = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M9 7 7.59 8.41 10.17 11H2v2h8.17l-2.58 2.59L9 17l5-5zM14.14 16.102a5 5 0 1 0 0-8.204l1.085 1.085a3.5 3.5 0 1 1 0 6.035z"
    }
  ),
  /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M17 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4" })
] });
const BaseSvgIcon$7 = createSvgIcon(Icon$7(), "WfInputAlt");
function WfInputAlt({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$7,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const WfInputAlt$1 = forwardRef(WfInputAlt);
const Icon$6 = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M4 4h16v5.17a3 3 0 0 1 2 0V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v5.17a3 3 0 0 1 2 0zM4 14.83a3 3 0 0 1-2 0V20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5.17a3 3 0 0 1-2 0V20H4zM5 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0M23 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8 6a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h1a2 2 0 0 0 1.803-1.133L13 11.789v.422l-2.197 1.922A2 2 0 0 0 9 13H8a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-.71l2.197-1.923A2 2 0 0 0 15 14.5h1a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2h-1a2 2 0 0 0-1.803 1.133L11 8.71V8a2 2 0 0 0-2-2zm1 1.5H8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5m5.5 5v-1a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5m-5.5 2H8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$6 = createSvgIcon(Icon$6(), "WfModule");
function WfModule({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$6,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const WfModule$1 = forwardRef(WfModule);
const Icon$5 = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M15 6v3h2V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-3h-2v3H5V6z"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M24 11.994 19.556 7.55 18.31 8.816l2.289 2.29H10v1.777h10.6l-2.289 2.289 1.245 1.267z"
    }
  )
] });
const BaseSvgIcon$5 = createSvgIcon(Icon$5(), "WfOutput");
function WfOutput({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$5,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const WfOutput$1 = forwardRef(WfOutput);
const Icon$4 = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M7 17c1.063 0 2.05-.332 2.86-.898l-1.085-1.085a3.5 3.5 0 1 1 0-6.035L9.86 7.899A5 5 0 1 0 7 17"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      d: "M5 12a2 2 0 1 0 4 0 2 2 0 0 0-4 0M15.59 8.41 17 7l5 5-5 5-1.41-1.41L18.17 13H10v-2h8.17z"
    }
  )
] });
const BaseSvgIcon$4 = createSvgIcon(Icon$4(), "WfOutputAlt");
function WfOutputAlt({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$4,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const WfOutputAlt$1 = forwardRef(WfOutputAlt);
const Icon$3 = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M21.167 7.753A4.97 4.97 0 0 0 22 5c0-2.757-2.243-5-5-5s-5 2.243-5 5 2.243 5 5 5c.98 0 1.938-.29 2.753-.833L22.5 11.91l1.41-1.41zM14 5c0-1.654 1.346-3 3-3s3 1.346 3 3c0 1.655-1.346 3-3 3s-3-1.345-3-3",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2 6.732A2 2 0 1 1 4.732 4H10v2H4.732A2 2 0 0 1 4 6.732v4.536c.304.175.557.428.732.732h4.536a2 2 0 0 1 3.464 0H20v7.268A2 2 0 1 1 17.268 22h-4.536a2 2 0 0 1-3.464 0H4.732A2 2 0 1 1 2 19.268v-4.536a2 2 0 0 1 0-3.464zm2 8A2 2 0 0 0 4.732 14h4.536c.175.304.428.557.732.732v4.536a2 2 0 0 0-.732.732H4.732A2 2 0 0 0 4 19.268zM12.732 14a2 2 0 0 1-.732.732v4.536c.304.175.557.428.732.732h4.536a2 2 0 0 1 .732-.732V14z",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon$3 = createSvgIcon(Icon$3(), "WhiteSpace");
function WhiteSpace({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$3,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const WhiteSpace$1 = forwardRef(WhiteSpace);
const Icon$2 = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m20 14 .3 1.5q.48.18.883.475l.197.155 1.45-.49 1 1.73-1.14 1c.069.429.078.68.03 1.065l-.03.205 1.14 1-1 1.73-1.45-.49a3.6 3.6 0 0 1-.845.533l-.235.097L20 24h-2l-.3-1.51a3.7 3.7 0 0 1-.883-.475l-.197-.155-1.45.49-1-1.73 1.14-1c-.067-.417-.078-.667-.033-1.028l.033-.232-1.14-1 1-1.73 1.45.49q.384-.324.845-.533l.235-.097L18 14zM19 3c1.05 0 1.918.82 1.994 1.851L21 5v7h-2V5H5v14h7v2H5c-1.05 0-1.918-.82-1.994-1.851L3 19V5c0-1.05.82-1.918 1.851-1.994L5 3zm0 14c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2M9 11v6H7v-6zm4-4v10h-2V7zm4 1v4h-2V8z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$2 = createSvgIcon(Icon$2(), "WidgetOptions");
function WidgetOptions({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$2,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const WidgetOptions$1 = forwardRef(WidgetOptions);
const Icon$1 = () => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: /* @__PURE__ */ jsx(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 3a2 2 0 0 1 2 2v1.25h.013c2.301.04 3.645 1.104 3.733 3.058l.004.205c0 1.143.587 1.678 2.054 1.733l.196.004V10a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-1.25l-.196.005c-1.4.052-1.999.541-2.05 1.58l-.008.357c-.085 1.887-1.34 2.943-3.498 3.05L9 17.75V19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.25l.204-.007c1.39-.066 1.99-.564 2.042-1.604l.008-.358c.045-1.004.422-1.77 1.09-2.282-.668-.51-1.045-1.276-1.09-2.28l-.004-.206c0-1.143-.589-1.687-2.046-1.756L9 7.75V9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zm0 12H4v4h3zm13-5h-3v4h3zM7 5H4v4h3z",
    clipRule: "evenodd"
  }
) });
const BaseSvgIcon$1 = createSvgIcon(Icon$1(), "Workflow");
function Workflow({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon$1,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const Workflow$1 = forwardRef(Workflow);
const Icon = () => /* @__PURE__ */ jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", children: [
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M9 5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2V7.75l.204.007c1.457.07 2.046.613 2.046 1.756l.005.206c.044 1.004.421 1.77 1.09 2.28-.669.511-1.046 1.278-1.09 2.282l-.009.358c-.051 1.04-.651 1.538-2.042 1.604L9 16.25V15a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-1.251l.248-.007c2.158-.107 3.413-1.163 3.498-3.05l.008-.357c.051-1.039.65-1.528 2.05-1.58L15 12.75h2V10h3v2.75h2V10a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2v1.25l-.196-.005c-1.467-.054-2.054-.589-2.054-1.732l-.005-.205c-.087-1.954-1.43-3.017-3.732-3.058H9zM4 15h3v4H4zM4 5h3v4H4z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ jsx(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M13.989 23.025a.9.9 0 0 1-.488-.137 1.3 1.3 0 0 1-.362-.363 1.1 1.1 0 0 1-.138-.487q-.012-.263.113-.513l4-7q.15-.225.387-.375t.513-.15a.93.93 0 0 1 .85.525l4 7q.15.225.137.5t-.137.5q-.15.224-.375.363a.94.94 0 0 1-.5.137zm4-1a.48.48 0 0 0 .35-.15.48.48 0 0 0 0-.7.48.48 0 0 0-.7 0 .48.48 0 0 0 0 .7q.15.15.35.15m-.5-2h1v-4h-1z",
      clipRule: "evenodd"
    }
  )
] });
const BaseSvgIcon = createSvgIcon(Icon(), "WorkflowTemp");
function WorkflowTemp({ width, height, sx, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    BaseSvgIcon,
    {
      ref,
      viewBox: "0 0 24 24",
      sx: {
        width,
        height: height || width,
        ...sx
      },
      ...props
    }
  );
}
const WorkflowTemp$1 = forwardRef(WorkflowTemp);
export {
  AccessIn$1 as AccessIn,
  AddApp$1 as AddApp,
  AddSection$1 as AddSection,
  AdvancedSettings$1 as AdvancedSettings,
  AiAgent$1 as AiAgent,
  AiGeneratedObject$1 as AiGeneratedObject,
  AiTool$1 as AiTool,
  Annotation$1 as Annotation,
  ApiCall$1 as ApiCall,
  A as ArrowDown,
  ArrowLeft$1 as ArrowLeft,
  ArrowRight$1 as ArrowRight,
  A2 as ArrowUp,
  AsynchronousWait$1 as AsynchronousWait,
  Autostyle$1 as Autostyle,
  Avg$1 as Avg,
  Behavioral$1 as Behavioral,
  Bigquery$1 as Bigquery,
  Blending$1 as Blending,
  BlockLabel$1 as BlockLabel,
  BlockLabelOff$1 as BlockLabelOff,
  BottomRow$1 as BottomRow,
  BulletPointAlt$1 as BulletPointAlt,
  BulletPointCheckedAlt$1 as BulletPointCheckedAlt,
  Carto$1 as Carto,
  CartoAi$1 as CartoAi,
  CartoSymbol$1 as CartoSymbol,
  CatalogView$1 as CatalogView,
  CatastropheModeling$1 as CatastropheModeling,
  Center$1 as Center,
  CenterLayer$1 as CenterLayer,
  CloseDiagonallyLeft$1 as CloseDiagonallyLeft,
  C as CloseDiagonallyRight,
  CloseVertically$1 as CloseVertically,
  CodeBlock$1 as CodeBlock,
  Comments$1 as Comments,
  Console$1 as Console,
  Covid19$1 as Covid19,
  CreateMap$1 as CreateMap,
  CreateSpatialAnalysis$1 as CreateSpatialAnalysis,
  CreateTileset$1 as CreateTileset,
  CreateWorkflow$1 as CreateWorkflow,
  Data$1 as Data,
  DataAccess$1 as DataAccess,
  DataExplorer$1 as DataExplorer,
  DataFilter$1 as DataFilter,
  DataMonetization$1 as DataMonetization,
  DataObservatory$1 as DataObservatory,
  DataOk$1 as DataOk,
  DataPending$1 as DataPending,
  DataPremium$1 as DataPremium,
  DataPublic$1 as DataPublic,
  DataSample$1 as DataSample,
  DataUnavailable$1 as DataUnavailable,
  Databricks$1 as Databricks,
  Demographics$1 as Demographics,
  Derived$1 as Derived,
  Distance$1 as Distance,
  Dot$1 as Dot,
  DrawCircle$1 as DrawCircle,
  DrawLasso$1 as DrawLasso,
  DrawLine$1 as DrawLine,
  DrawPolygon$1 as DrawPolygon,
  DrawSquare$1 as DrawSquare,
  DropAPin$1 as DropAPin,
  DualMap$1 as DualMap,
  Environmental$1 as Environmental,
  EnvironmentalManagement$1 as EnvironmentalManagement,
  Equal$1 as Equal,
  ExitToAppLeft$1 as ExitToAppLeft,
  Fabric$1 as Fabric,
  Facebook$1 as Facebook,
  Financial$1 as Financial,
  FlipInverse$1 as FlipInverse,
  Framed$1 as Framed,
  FraudDetection$1 as FraudDetection,
  Functions$1 as Functions,
  GeneratingDescription$1 as GeneratingDescription,
  GeocodeTable$1 as GeocodeTable,
  Geography$1 as Geography,
  Geomarketing$1 as Geomarketing,
  Geometry$1 as Geometry,
  Github$1 as Github,
  Google$1 as Google,
  H3$1 as H3,
  HealthAnalytics$1 as HealthAnalytics,
  HideComments$1 as HideComments,
  HideLeftsidebar$1 as HideLeftsidebar,
  HideRightsidebar$1 as HideRightsidebar,
  Home$1 as Home,
  Housing$1 as Housing,
  HumanMobility$1 as HumanMobility,
  Id$1 as Id,
  Image$1 as Image,
  Infrastructure$1 as Infrastructure,
  IotAnalytics$1 as IotAnalytics,
  LabelDeprecated$1 as LabelDeprecated,
  Layers$1 as Layers,
  Linkedin$1 as Linkedin,
  MapCoordinates$1 as MapCoordinates,
  MapCopy$1 as MapCopy,
  MapOthers$1 as MapOthers,
  MapPin$1 as MapPin,
  MarkCommentRead$1 as MarkCommentRead,
  MarketAnalysis$1 as MarketAnalysis,
  Max$1 as Max,
  McpTool$1 as McpTool,
  MeasureTool$1 as MeasureTool,
  Min$1 as Min,
  MobilityPlanning$1 as MobilityPlanning,
  NetworkDeployment$1 as NetworkDeployment,
  NightsThermostat$1 as NightsThermostat,
  NoApp$1 as NoApp,
  NoLayer$1 as NoLayer,
  NoMap$1 as NoMap,
  NoSpatialExtension$1 as NoSpatialExtension,
  NoTileset$1 as NoTileset,
  NotEqual$1 as NotEqual,
  Number$1 as Number,
  Onboarding$1 as Onboarding,
  OohAnalytics$1 as OohAnalytics,
  Opacity$1 as Opacity,
  OpenDiagonallyLeft$1 as OpenDiagonallyLeft,
  O as OpenDiagonallyRight,
  OpenNewWindow$1 as OpenNewWindow,
  OpenVertically$1 as OpenVertically,
  ParameterSettings$1 as ParameterSettings,
  PawnChess$1 as PawnChess,
  PlaceSelect$1 as PlaceSelect,
  PointsOfInterest$1 as PointsOfInterest,
  Postgre$1 as Postgre,
  PostgreOutlined$1 as PostgreOutlined,
  Preferences$1 as Preferences,
  ProcessData$1 as ProcessData,
  PublicWithPassword$1 as PublicWithPassword,
  Publish$1 as Publish,
  Quadbin$1 as Quadbin,
  Quadkey$1 as Quadkey,
  QueryTable$1 as QueryTable,
  Rain$1 as Rain,
  Raster$1 as Raster,
  Redshift$1 as Redshift,
  Report$1 as Report,
  Reset$1 as Reset,
  RiskAnalysis$1 as RiskAnalysis,
  RoadTraffic$1 as RoadTraffic,
  RunSettings$1 as RunSettings,
  RunStep$1 as RunStep,
  Salesforce$1 as Salesforce,
  Sample$1 as Sample,
  SaveOk$1 as SaveOk,
  ScheduleRun$1 as ScheduleRun,
  S as Search,
  SelectDestination$1 as SelectDestination,
  SelectFeature$1 as SelectFeature,
  SelectTool$1 as SelectTool,
  SelectVariable$1 as SelectVariable,
  ShowNodeResults$1 as ShowNodeResults,
  ShowRightsidebar$1 as ShowRightsidebar,
  SingleLayer$1 as SingleLayer,
  SiteSelection$1 as SiteSelection,
  Snowflake$1 as Snowflake,
  SpatialAnalysis$1 as SpatialAnalysis,
  SpatialExtension$1 as SpatialExtension,
  SpatialIndexes$1 as SpatialIndexes,
  Sql$1 as Sql,
  SqlError$1 as SqlError,
  Sso$1 as Sso,
  StrokeCustom$1 as StrokeCustom,
  StrokeDash$1 as StrokeDash,
  StrokeSolid$1 as StrokeSolid,
  SupplyChain$1 as SupplyChain,
  SwatchCircle$1 as SwatchCircle,
  SwatchCircleNone$1 as SwatchCircleNone,
  a as SwatchSquare,
  TableColumn$1 as TableColumn,
  TableColumnLimited$1 as TableColumnLimited,
  TempTable$1 as TempTable,
  TerritoryPlanning$1 as TerritoryPlanning,
  TextBox$1 as TextBox,
  Tileset$1 as Tileset,
  TilesetsAggregated$1 as TilesetsAggregated,
  TimeBuckets$1 as TimeBuckets,
  TimeCar$1 as TimeCar,
  TimeWindowIncremental$1 as TimeWindowIncremental,
  TimeWindowMoving$1 as TimeWindowMoving,
  Tooltip$1 as Tooltip,
  TopRow$1 as TopRow,
  TwinArea$1 as TwinArea,
  Twitter$1 as Twitter,
  UpdateGen$1 as UpdateGen,
  UploadFileUrl$1 as UploadFileUrl,
  View2d$1 as View2d,
  View3d$1 as View3d,
  ViewLeftsidebar$1 as ViewLeftsidebar,
  WfComponent$1 as WfComponent,
  WfComponentInvalid$1 as WfComponentInvalid,
  WfExtensionPackageDefault$1 as WfExtensionPackageDefault,
  WfInput$1 as WfInput,
  WfInputAlt$1 as WfInputAlt,
  WfModule$1 as WfModule,
  WfOutput$1 as WfOutput,
  WfOutputAlt$1 as WfOutputAlt,
  WhiteSpace$1 as WhiteSpace,
  WidgetOptions$1 as WidgetOptions,
  Workflow$1 as Workflow,
  WorkflowTemp$1 as WorkflowTemp
};
